const manufacturers = [
  { hersteller_id: "1", hersteller_name: "Alfa Romeo", hersteller_aktiv: "1" },
  { hersteller_id: "2", hersteller_name: "Audi", hersteller_aktiv: "1" },
  { hersteller_id: "3", hersteller_name: "Austin", hersteller_aktiv: "1" },
  { hersteller_id: "4", hersteller_name: "BMW", hersteller_aktiv: "1" },
  { hersteller_id: "5", hersteller_name: "Cadillac", hersteller_aktiv: "1" },
  { hersteller_id: "6", hersteller_name: "Chevrolet", hersteller_aktiv: "1" },
  { hersteller_id: "7", hersteller_name: "Chrysler", hersteller_aktiv: "1" },
  { hersteller_id: "8", hersteller_name: "Citroen", hersteller_aktiv: "1" },
  { hersteller_id: "9", hersteller_name: "Dacia", hersteller_aktiv: "1" },
  { hersteller_id: "11", hersteller_name: "Daihatsu", hersteller_aktiv: "1" },
  { hersteller_id: "12", hersteller_name: "Dodge", hersteller_aktiv: "1" },
  { hersteller_id: "13", hersteller_name: "Fiat", hersteller_aktiv: "1" },
  { hersteller_id: "14", hersteller_name: "Ford", hersteller_aktiv: "1" },
  { hersteller_id: "15", hersteller_name: "Honda", hersteller_aktiv: "1" },
  { hersteller_id: "16", hersteller_name: "Hyundai", hersteller_aktiv: "1" },
  { hersteller_id: "17", hersteller_name: "Infiniti", hersteller_aktiv: "1" },
  { hersteller_id: "18", hersteller_name: "Jaguar", hersteller_aktiv: "1" },
  { hersteller_id: "19", hersteller_name: "Jeep", hersteller_aktiv: "1" },
  { hersteller_id: "20", hersteller_name: "Kia", hersteller_aktiv: "1" },
  { hersteller_id: "21", hersteller_name: "Lada", hersteller_aktiv: "1" },
  { hersteller_id: "22", hersteller_name: "Lancia", hersteller_aktiv: "1" },
  { hersteller_id: "23", hersteller_name: "Land Rover", hersteller_aktiv: "1" },
  { hersteller_id: "24", hersteller_name: "Lexus", hersteller_aktiv: "1" },
  { hersteller_id: "25", hersteller_name: "Mazda", hersteller_aktiv: "1" },
  { hersteller_id: "26", hersteller_name: "Mercedes", hersteller_aktiv: "1" },
  { hersteller_id: "27", hersteller_name: "MINI", hersteller_aktiv: "1" },
  { hersteller_id: "28", hersteller_name: "Mitsubishi", hersteller_aktiv: "1" },
  { hersteller_id: "29", hersteller_name: "Nissan", hersteller_aktiv: "1" },
  { hersteller_id: "30", hersteller_name: "Opel", hersteller_aktiv: "1" },
  { hersteller_id: "31", hersteller_name: "Peugeot", hersteller_aktiv: "1" },
  {
    hersteller_id: "32",
    hersteller_name: "PKW universal",
    hersteller_aktiv: "1",
  },
  { hersteller_id: "33", hersteller_name: "Porsche", hersteller_aktiv: "1" },
  { hersteller_id: "34", hersteller_name: "Renault", hersteller_aktiv: "1" },
  { hersteller_id: "36", hersteller_name: "Saab", hersteller_aktiv: "1" },
  { hersteller_id: "37", hersteller_name: "Seat", hersteller_aktiv: "1" },
  { hersteller_id: "38", hersteller_name: "Skoda", hersteller_aktiv: "1" },
  { hersteller_id: "39", hersteller_name: "Ssang Yong", hersteller_aktiv: "1" },
  { hersteller_id: "40", hersteller_name: "Subaru", hersteller_aktiv: "1" },
  { hersteller_id: "41", hersteller_name: "Suzuki", hersteller_aktiv: "1" },
  { hersteller_id: "42", hersteller_name: "Toyota", hersteller_aktiv: "1" },
  { hersteller_id: "43", hersteller_name: "Volkswagen", hersteller_aktiv: "1" },
  { hersteller_id: "44", hersteller_name: "Volvo", hersteller_aktiv: "1" },
  { hersteller_id: "45", hersteller_name: "Ferrari", hersteller_aktiv: "1" },
  { hersteller_id: "46", hersteller_name: "Cupra", hersteller_aktiv: "1" },
  { hersteller_id: "47", hersteller_name: "Aiways", hersteller_aktiv: "1" },
  { hersteller_id: "48", hersteller_name: "MG", hersteller_aktiv: "1" },
  { hersteller_id: "49", hersteller_name: "BYD", hersteller_aktiv: "1" },
  { hersteller_id: "50", hersteller_name: "DS", hersteller_aktiv: "1" },
];

const models = {
  1: [
    {
      modell_id: "1",
      modell_name: "155",
      modell_name_en: "155",
      modell_hersteller_id: "1",
      modell_aktiv: "1",
    },
    {
      modell_id: "2",
      modell_name: "156",
      modell_name_en: "156",
      modell_hersteller_id: "1",
      modell_aktiv: "1",
    },
    {
      modell_id: "3",
      modell_name: "164",
      modell_name_en: "164",
      modell_hersteller_id: "1",
      modell_aktiv: "1",
    },
    {
      modell_id: "4",
      modell_name: "156 Sportwagen",
      modell_name_en: "156 Sportwagen",
      modell_hersteller_id: "1",
      modell_aktiv: "1",
    },
    {
      modell_id: "5",
      modell_name: "33",
      modell_name_en: "33",
      modell_hersteller_id: "1",
      modell_aktiv: "1",
    },
    {
      modell_id: "6",
      modell_name: "33 Sport Wagon",
      modell_name_en: "33 Sport Wagon",
      modell_hersteller_id: "1",
      modell_aktiv: "1",
    },
    {
      modell_id: "7",
      modell_name: "90",
      modell_name_en: "90",
      modell_hersteller_id: "1",
      modell_aktiv: "1",
    },
    {
      modell_id: "8",
      modell_name: "Q4 Crosswagon",
      modell_name_en: "Q4 Crosswagon",
      modell_hersteller_id: "1",
      modell_aktiv: "1",
    },
    {
      modell_id: "9",
      modell_name: "Mito",
      modell_name_en: "Mito",
      modell_hersteller_id: "1",
      modell_aktiv: "1",
    },
  ],
  2: [
    {
      modell_id: "10",
      modell_name: "100 Avant",
      modell_name_en: "100 Avant",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "11",
      modell_name: "100",
      modell_name_en: "100",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "12",
      modell_name: "200 Avant",
      modell_name_en: "200 Avant",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "13",
      modell_name: "200",
      modell_name_en: "200",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "14",
      modell_name: "80 Avant",
      modell_name_en: "80 Avant",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "15",
      modell_name: "80",
      modell_name_en: "80",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "16",
      modell_name: "90",
      modell_name_en: "90",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "17",
      modell_name: "A1 Sportback",
      modell_name_en: "A1 Sportback",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "18",
      modell_name: "A1",
      modell_name_en: "A1",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "19",
      modell_name: "A3",
      modell_name_en: "A3",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "20",
      modell_name: "A3 Sportback",
      modell_name_en: "A3 Sportback",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "21",
      modell_name: "A4 Allroad",
      modell_name_en: "A4 Allroad",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "22",
      modell_name: "A4 Avant",
      modell_name_en: "A4 Avant",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "23",
      modell_name: "A4",
      modell_name_en: "A4",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "24",
      modell_name: "A5 Sportback",
      modell_name_en: "A5 Sportback",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "25",
      modell_name: "A6 Allroad",
      modell_name_en: "A6 Allroad",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "26",
      modell_name: "A6 Avant",
      modell_name_en: "A6 Avant",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "27",
      modell_name: "A6",
      modell_name_en: "A6",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "28",
      modell_name: "A8",
      modell_name_en: "A8",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "29",
      modell_name: "Q2",
      modell_name_en: "Q2",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "30",
      modell_name: "Q3",
      modell_name_en: "Q3",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "31",
      modell_name: "Q5",
      modell_name_en: "Q5",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "32",
      modell_name: "Q7",
      modell_name_en: "Q7",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
    {
      modell_id: "33",
      modell_name: "Q8",
      modell_name_en: "Q8",
      modell_hersteller_id: "2",
      modell_aktiv: "1",
    },
  ],
  3: [
    {
      modell_id: "34",
      modell_name: "Land Rover",
      modell_name_en: "Land Rover",
      modell_hersteller_id: "3",
      modell_aktiv: "1",
    },
    {
      modell_id: "35",
      modell_name: "Montego",
      modell_name_en: "Montego",
      modell_hersteller_id: "3",
      modell_aktiv: "1",
    },
    {
      modell_id: "36",
      modell_name: "Range Rover",
      modell_name_en: "Range Rover",
      modell_hersteller_id: "3",
      modell_aktiv: "1",
    },
    {
      modell_id: "37",
      modell_name: "Rover",
      modell_name_en: "Rover",
      modell_hersteller_id: "3",
      modell_aktiv: "1",
    },
    {
      modell_id: "38",
      modell_name: "Rover 620",
      modell_name_en: "Rover 620",
      modell_hersteller_id: "3",
      modell_aktiv: "1",
    },
    {
      modell_id: "39",
      modell_name: "Rover 623",
      modell_name_en: "Rover 623",
      modell_hersteller_id: "3",
      modell_aktiv: "1",
    },
  ],
  4: [
    {
      modell_id: "40",
      modell_name: "1",
      modell_name_en: "1",
      modell_hersteller_id: "4",
      modell_aktiv: "1",
    },
    {
      modell_id: "41",
      modell_name: "2",
      modell_name_en: "2",
      modell_hersteller_id: "4",
      modell_aktiv: "1",
    },
    {
      modell_id: "42",
      modell_name: "3",
      modell_name_en: "3",
      modell_hersteller_id: "4",
      modell_aktiv: "1",
    },
    {
      modell_id: "43",
      modell_name: "4",
      modell_name_en: "4",
      modell_hersteller_id: "4",
      modell_aktiv: "1",
    },
    {
      modell_id: "44",
      modell_name: "5",
      modell_name_en: "5",
      modell_hersteller_id: "4",
      modell_aktiv: "1",
    },
    {
      modell_id: "45",
      modell_name: "7",
      modell_name_en: "7",
      modell_hersteller_id: "4",
      modell_aktiv: "1",
    },
    {
      modell_id: "46",
      modell_name: "X1",
      modell_name_en: "X1",
      modell_hersteller_id: "4",
      modell_aktiv: "1",
    },
    {
      modell_id: "47",
      modell_name: "X2",
      modell_name_en: "X2",
      modell_hersteller_id: "4",
      modell_aktiv: "1",
    },
    {
      modell_id: "48",
      modell_name: "X3",
      modell_name_en: "X3",
      modell_hersteller_id: "4",
      modell_aktiv: "1",
    },
    {
      modell_id: "49",
      modell_name: "X5",
      modell_name_en: "X5",
      modell_hersteller_id: "4",
      modell_aktiv: "1",
    },
    {
      modell_id: "50",
      modell_name: "Z3",
      modell_name_en: "Z3",
      modell_hersteller_id: "4",
      modell_aktiv: "1",
    },
    {
      modell_id: "581",
      modell_name: "3 Touring",
      modell_name_en: "3 touring",
      modell_hersteller_id: "4",
      modell_aktiv: "1",
    },
    {
      modell_id: "582",
      modell_name: "X7",
      modell_name_en: "X7",
      modell_hersteller_id: "4",
      modell_aktiv: "1",
    },
    {
      modell_id: "600",
      modell_name: "5 Touring",
      modell_name_en: "5 touring",
      modell_hersteller_id: "4",
      modell_aktiv: "1",
    },
    {
      modell_id: "645",
      modell_name: "X2 mit Reling ",
      modell_name_en: "X2 with roof rails",
      modell_hersteller_id: "4",
      modell_aktiv: "0",
    },
  ],
  5: [
    {
      modell_id: "51",
      modell_name: "BLS",
      modell_name_en: "BLS",
      modell_hersteller_id: "5",
      modell_aktiv: "1",
    },
    {
      modell_id: "52",
      modell_name: "SRX",
      modell_name_en: "SRX",
      modell_hersteller_id: "5",
      modell_aktiv: "1",
    },
  ],
  6: [
    {
      modell_id: "53",
      modell_name: "Captiva",
      modell_name_en: "Captiva",
      modell_hersteller_id: "6",
      modell_aktiv: "1",
    },
    {
      modell_id: "54",
      modell_name: "Cruze SW",
      modell_name_en: "Cruze SW",
      modell_hersteller_id: "6",
      modell_aktiv: "1",
    },
    {
      modell_id: "55",
      modell_name: "Kalos",
      modell_name_en: "Kalos",
      modell_hersteller_id: "6",
      modell_aktiv: "1",
    },
    {
      modell_id: "56",
      modell_name: "Matiz",
      modell_name_en: "Matiz",
      modell_hersteller_id: "6",
      modell_aktiv: "1",
    },
    {
      modell_id: "57",
      modell_name: "Nubria",
      modell_name_en: "Nubria",
      modell_hersteller_id: "6",
      modell_aktiv: "1",
    },
    {
      modell_id: "58",
      modell_name: "Spark",
      modell_name_en: "Spark",
      modell_hersteller_id: "6",
      modell_aktiv: "1",
    },
    {
      modell_id: "59",
      modell_name: "Trans Sport",
      modell_name_en: "Trans Sport",
      modell_hersteller_id: "6",
      modell_aktiv: "1",
    },
    {
      modell_id: "60",
      modell_name: "Trax",
      modell_name_en: "Trax",
      modell_hersteller_id: "6",
      modell_aktiv: "1",
    },
    {
      modell_id: "583",
      modell_name: "Rezzo",
      modell_name_en: "Rezzo",
      modell_hersteller_id: "6",
      modell_aktiv: "1",
    },
  ],
  7: [
    {
      modell_id: "61",
      modell_name: "C300",
      modell_name_en: "C300",
      modell_hersteller_id: "7",
      modell_aktiv: "1",
    },
    {
      modell_id: "62",
      modell_name: "Cherokee",
      modell_name_en: "Cherokee",
      modell_hersteller_id: "7",
      modell_aktiv: "1",
    },
    {
      modell_id: "63",
      modell_name: "Grand Cherokee",
      modell_name_en: "Grand Cherokee",
      modell_hersteller_id: "7",
      modell_aktiv: "1",
    },
    {
      modell_id: "64",
      modell_name: "Grand Voyager",
      modell_name_en: "Grand Voyager",
      modell_hersteller_id: "7",
      modell_aktiv: "1",
    },
    {
      modell_id: "65",
      modell_name: "Jeep Patriot",
      modell_name_en: "Jeep Patriot",
      modell_hersteller_id: "7",
      modell_aktiv: "1",
    },
    {
      modell_id: "66",
      modell_name: "PT Cruiser",
      modell_name_en: "PT Cruiser",
      modell_hersteller_id: "7",
      modell_aktiv: "1",
    },
    {
      modell_id: "67",
      modell_name: "Voyager",
      modell_name_en: "Voyager",
      modell_hersteller_id: "7",
      modell_aktiv: "1",
    },
  ],
  8: [
    {
      modell_id: "68",
      modell_name: "AX",
      modell_name_en: "AX",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "69",
      modell_name: "Berlingo",
      modell_name_en: "Berlingo",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "70",
      modell_name: "BX",
      modell_name_en: "BX",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "71",
      modell_name: "C1",
      modell_name_en: "C1",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "72",
      modell_name: "C3",
      modell_name_en: "C3",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "73",
      modell_name: "C4",
      modell_name_en: "C4",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "74",
      modell_name: "C5",
      modell_name_en: "C5",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "75",
      modell_name: "C6",
      modell_name_en: "C6",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "76",
      modell_name: "C8",
      modell_name_en: "C8",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "77",
      modell_name: "C-Crosser",
      modell_name_en: "C-Crosser",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "78",
      modell_name: "DS4",
      modell_name_en: "DS4",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "79",
      modell_name: "Evasion",
      modell_name_en: "Evasion",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "80",
      modell_name: "Jumper",
      modell_name_en: "Jumper",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "81",
      modell_name: "Jumpy",
      modell_name_en: "Jumpy",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "82",
      modell_name: "Nemo",
      modell_name_en: "Nemo",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "83",
      modell_name: "Saxo",
      modell_name_en: "Saxo",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "84",
      modell_name: "Spacetourer",
      modell_name_en: "Spacetourer",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "85",
      modell_name: "Xantia",
      modell_name_en: "Xantia",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "86",
      modell_name: "XM",
      modell_name_en: "XM",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "87",
      modell_name: "Xsara",
      modell_name_en: "Xsara",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
    {
      modell_id: "88",
      modell_name: "ZX",
      modell_name_en: "ZX",
      modell_hersteller_id: "8",
      modell_aktiv: "1",
    },
  ],
  9: [
    {
      modell_id: "89",
      modell_name: "Dokker",
      modell_name_en: "Dokker",
      modell_hersteller_id: "9",
      modell_aktiv: "1",
    },
    {
      modell_id: "90",
      modell_name: "Duster",
      modell_name_en: "Duster",
      modell_hersteller_id: "9",
      modell_aktiv: "1",
    },
    {
      modell_id: "91",
      modell_name: "Lodgy",
      modell_name_en: "Lodgy",
      modell_hersteller_id: "9",
      modell_aktiv: "1",
    },
    {
      modell_id: "92",
      modell_name: "Logan",
      modell_name_en: "Logan",
      modell_hersteller_id: "9",
      modell_aktiv: "1",
    },
    {
      modell_id: "93",
      modell_name: "Sandero",
      modell_name_en: "Sandero",
      modell_hersteller_id: "9",
      modell_aktiv: "1",
    },
    {
      modell_id: "609",
      modell_name: "Sandero mit normalem Dach",
      modell_name_en: "Sandero with regular roof",
      modell_hersteller_id: "9",
      modell_aktiv: "1",
    },
  ],
  10: [
    {
      modell_id: "94",
      modell_name: "Evanda",
      modell_name_en: "Evanda",
      modell_hersteller_id: "10",
      modell_aktiv: "1",
    },
    {
      modell_id: "95",
      modell_name: "Kalos",
      modell_name_en: "Kalos",
      modell_hersteller_id: "10",
      modell_aktiv: "1",
    },
    {
      modell_id: "96",
      modell_name: "Lacetti",
      modell_name_en: "Lacetti",
      modell_hersteller_id: "10",
      modell_aktiv: "1",
    },
    {
      modell_id: "97",
      modell_name: "Lanos",
      modell_name_en: "Lanos",
      modell_hersteller_id: "10",
      modell_aktiv: "1",
    },
    {
      modell_id: "98",
      modell_name: "Leganza",
      modell_name_en: "Leganza",
      modell_hersteller_id: "10",
      modell_aktiv: "1",
    },
    {
      modell_id: "99",
      modell_name: "Matiz",
      modell_name_en: "Matiz",
      modell_hersteller_id: "10",
      modell_aktiv: "1",
    },
    {
      modell_id: "100",
      modell_name: "Nexia",
      modell_name_en: "Nexia",
      modell_hersteller_id: "10",
      modell_aktiv: "1",
    },
    {
      modell_id: "101",
      modell_name: "Nubira",
      modell_name_en: "Nubira",
      modell_hersteller_id: "10",
      modell_aktiv: "1",
    },
  ],
  11: [
    {
      modell_id: "102",
      modell_name: "1000",
      modell_name_en: "1000",
      modell_hersteller_id: "11",
      modell_aktiv: "1",
    },
    {
      modell_id: "103",
      modell_name: "Applause",
      modell_name_en: "Applause",
      modell_hersteller_id: "11",
      modell_aktiv: "1",
    },
    {
      modell_id: "104",
      modell_name: "Charade",
      modell_name_en: "Charade",
      modell_hersteller_id: "11",
      modell_aktiv: "1",
    },
    {
      modell_id: "105",
      modell_name: "Cuore",
      modell_name_en: "Cuore",
      modell_hersteller_id: "11",
      modell_aktiv: "1",
    },
    {
      modell_id: "106",
      modell_name: "Sparcar",
      modell_name_en: "Sparcar",
      modell_hersteller_id: "11",
      modell_aktiv: "1",
    },
    {
      modell_id: "107",
      modell_name: "Terios",
      modell_name_en: "Terios",
      modell_hersteller_id: "11",
      modell_aktiv: "1",
    },
    {
      modell_id: "108",
      modell_name: "YRV",
      modell_name_en: "YRV",
      modell_hersteller_id: "11",
      modell_aktiv: "1",
    },
  ],
  12: [
    {
      modell_id: "109",
      modell_name: "Journey",
      modell_name_en: "Journey",
      modell_hersteller_id: "12",
      modell_aktiv: "1",
    },
  ],
  13: [
    {
      modell_id: "110",
      modell_name: "500X",
      modell_name_en: "500X",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "111",
      modell_name: "Brava",
      modell_name_en: "Brava",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "112",
      modell_name: "Bravo",
      modell_name_en: "Bravo",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "113",
      modell_name: "Cinquecento",
      modell_name_en: "Cinquecento",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "114",
      modell_name: "Croma",
      modell_name_en: "Croma",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "115",
      modell_name: "Daily",
      modell_name_en: "Daily",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "116",
      modell_name: "Doblo",
      modell_name_en: "Doblo",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "117",
      modell_name: "Ducato",
      modell_name_en: "Ducato",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "118",
      modell_name: "Fiorino",
      modell_name_en: "Fiorino",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "119",
      modell_name: "Freemont",
      modell_name_en: "Freemont",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "120",
      modell_name: "Grande Punto",
      modell_name_en: "Grande Punto",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "121",
      modell_name: "Idea",
      modell_name_en: "Idea",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "122",
      modell_name: "Iveco",
      modell_name_en: "Iveco",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "123",
      modell_name: "Marea",
      modell_name_en: "Marea",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "124",
      modell_name: "Palio",
      modell_name_en: "Palio",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "125",
      modell_name: "Panda",
      modell_name_en: "Panda",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "126",
      modell_name: "Punto",
      modell_name_en: "Punto",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "127",
      modell_name: "Scudo",
      modell_name_en: "Scudo",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "128",
      modell_name: "Sedici",
      modell_name_en: "Sedici",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "129",
      modell_name: "Seicento",
      modell_name_en: "Seicento",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "130",
      modell_name: "Station Wagon",
      modell_name_en: "Station Wagon",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "131",
      modell_name: "Stilo",
      modell_name_en: "Stilo",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "132",
      modell_name: "Talento",
      modell_name_en: "Talento",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "133",
      modell_name: "Tempra",
      modell_name_en: "Tempra",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "134",
      modell_name: "Tipo",
      modell_name_en: "Tipo",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "135",
      modell_name: "Ulysse",
      modell_name_en: "Ulysse",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "136",
      modell_name: "Uno",
      modell_name_en: "Uno",
      modell_hersteller_id: "13",
      modell_aktiv: "1",
    },
    {
      modell_id: "639",
      modell_name: "Doblo ohne Reling",
      modell_name_en: " Doblo, without roof rails",
      modell_hersteller_id: "13",
      modell_aktiv: "0",
    },
  ],
  14: [
    {
      modell_id: "137",
      modell_name: "C-MAX",
      modell_name_en: "C-MAX",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "138",
      modell_name: "Tourneo Connect",
      modell_name_en: "Tourneo Connect",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "139",
      modell_name: "Ecovan",
      modell_name_en: "Ecovan",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "140",
      modell_name: "Edge",
      modell_name_en: "Edge",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "141",
      modell_name: "Escort",
      modell_name_en: "Escort",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "142",
      modell_name: "Escort Turnier",
      modell_name_en: "Escort Turnier",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "143",
      modell_name: "Explorer",
      modell_name_en: "Explorer",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "144",
      modell_name: "Fiesta",
      modell_name_en: "Fiesta",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "145",
      modell_name: "Focus",
      modell_name_en: "Focus",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "146",
      modell_name: "Focus Turnier",
      modell_name_en: "Focus Turnier",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "147",
      modell_name: "Galaxy",
      modell_name_en: "Galaxy",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "148",
      modell_name: "Grand C-MAX",
      modell_name_en: "Grand C-MAX",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "149",
      modell_name: "Grand Tourneo",
      modell_name_en: "Grand Tourneo",
      modell_hersteller_id: "14",
      modell_aktiv: "0",
    },
    {
      modell_id: "150",
      modell_name: "Grand Transit",
      modell_name_en: "Grand Transit",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "151",
      modell_name: "Kuga",
      modell_name_en: "Kuga",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "152",
      modell_name: "Maverick",
      modell_name_en: "Maverick",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "153",
      modell_name: "Mondeo",
      modell_name_en: "Mondeo",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "154",
      modell_name: "Mondeo Turnier",
      modell_name_en: "Mondeo Turnier",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "155",
      modell_name: "Orion",
      modell_name_en: "Orion",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "156",
      modell_name: "Ranger",
      modell_name_en: "Ranger",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "157",
      modell_name: "Scorpio",
      modell_name_en: "Scorpio",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "158",
      modell_name: "Scorpio Turnier",
      modell_name_en: "Scorpio Turnier",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "159",
      modell_name: "Sierra",
      modell_name_en: "Sierra",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "160",
      modell_name: "S-MAX",
      modell_name_en: "S-MAX",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "161",
      modell_name: "Tourneo",
      modell_name_en: "Tourneo",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "162",
      modell_name: "Transit",
      modell_name_en: "Transit",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "584",
      modell_name: "Ka",
      modell_name_en: "Ka",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "585",
      modell_name: "Grand Tourneo Connect",
      modell_name_en: "Grand Tourneo Connect",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "586",
      modell_name: "Transit Connect",
      modell_name_en: "Transit Connect",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
    {
      modell_id: "587",
      modell_name: "Grand Transit Connect",
      modell_name_en: "Grand Transit Connect",
      modell_hersteller_id: "14",
      modell_aktiv: "1",
    },
  ],
  15: [
    {
      modell_id: "163",
      modell_name: "Accord",
      modell_name_en: "Accord",
      modell_hersteller_id: "15",
      modell_aktiv: "1",
    },
    {
      modell_id: "164",
      modell_name: "Civic",
      modell_name_en: "Civic",
      modell_hersteller_id: "15",
      modell_aktiv: "1",
    },
    {
      modell_id: "165",
      modell_name: "Concerto",
      modell_name_en: "Concerto",
      modell_hersteller_id: "15",
      modell_aktiv: "1",
    },
    {
      modell_id: "166",
      modell_name: "CR-V",
      modell_name_en: "CR-V",
      modell_hersteller_id: "15",
      modell_aktiv: "1",
    },
    {
      modell_id: "167",
      modell_name: "FR-V",
      modell_name_en: "FR-V",
      modell_hersteller_id: "15",
      modell_aktiv: "1",
    },
    {
      modell_id: "168",
      modell_name: "Jazz",
      modell_name_en: "Jazz",
      modell_hersteller_id: "15",
      modell_aktiv: "1",
    },
    {
      modell_id: "169",
      modell_name: "Shuttle",
      modell_name_en: "Shuttle",
      modell_hersteller_id: "15",
      modell_aktiv: "1",
    },
  ],
  16: [
    {
      modell_id: "170",
      modell_name: "Accent",
      modell_name_en: "Accent",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "171",
      modell_name: "Atos",
      modell_name_en: "Atos",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "172",
      modell_name: "Elantra",
      modell_name_en: "Elantra",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "173",
      modell_name: "FC Matrix",
      modell_name_en: "FC Matrix",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "174",
      modell_name: "Getz",
      modell_name_en: "Getz",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "175",
      modell_name: "Grand Santa Fe",
      modell_name_en: "Grand Santa Fe",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "176",
      modell_name: "H100",
      modell_name_en: "H100",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "177",
      modell_name: "H1",
      modell_name_en: "H1",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "178",
      modell_name: "i10",
      modell_name_en: "i10",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "179",
      modell_name: "i20",
      modell_name_en: "i20",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "180",
      modell_name: "i30",
      modell_name_en: "i30",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "181",
      modell_name: "ix35",
      modell_name_en: "ix35",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "182",
      modell_name: "ix55",
      modell_name_en: "ix55",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "183",
      modell_name: "Lantra",
      modell_name_en: "Lantra",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "184",
      modell_name: "Lantra II",
      modell_name_en: "Lantra II",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "185",
      modell_name: "Matrix",
      modell_name_en: "Matrix",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "186",
      modell_name: "Pony",
      modell_name_en: "Pony",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "187",
      modell_name: "Santa Fe",
      modell_name_en: "Santa Fe",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "188",
      modell_name: "Santamo",
      modell_name_en: "Santamo",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "189",
      modell_name: "S-Coupe",
      modell_name_en: "S-Coupe",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "190",
      modell_name: "Sonata",
      modell_name_en: "Sonata",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "191",
      modell_name: "Terracan",
      modell_name_en: "Terracan",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "192",
      modell_name: "Trajet",
      modell_name_en: "Trajet",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "193",
      modell_name: "Tucson",
      modell_name_en: "Tucson",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "194",
      modell_name: "XG 30",
      modell_name_en: "XG 30",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
    {
      modell_id: "588",
      modell_name: "Starex",
      modell_name_en: "Starex",
      modell_hersteller_id: "16",
      modell_aktiv: "1",
    },
  ],
  17: [
    {
      modell_id: "195",
      modell_name: "Q30",
      modell_name_en: "Q30",
      modell_hersteller_id: "17",
      modell_aktiv: "1",
    },
    {
      modell_id: "196",
      modell_name: "QX30",
      modell_name_en: "QX30",
      modell_hersteller_id: "17",
      modell_aktiv: "1",
    },
    {
      modell_id: "197",
      modell_name: "QX70",
      modell_name_en: "QX70",
      modell_hersteller_id: "17",
      modell_aktiv: "1",
    },
  ],
  18: [
    {
      modell_id: "198",
      modell_name: "E-Pace",
      modell_name_en: "E-Pace",
      modell_hersteller_id: "18",
      modell_aktiv: "1",
    },
    {
      modell_id: "199",
      modell_name: "F-Pace",
      modell_name_en: "F-Pace",
      modell_hersteller_id: "18",
      modell_aktiv: "1",
    },
    {
      modell_id: "200",
      modell_name: "X Type",
      modell_name_en: "X Type",
      modell_hersteller_id: "18",
      modell_aktiv: "1",
    },
    {
      modell_id: "201",
      modell_name: "XF Sportbrake",
      modell_name_en: "XF Sportbrake",
      modell_hersteller_id: "18",
      modell_aktiv: "1",
    },
  ],
  19: [
    {
      modell_id: "202",
      modell_name: "Cherokee",
      modell_name_en: "Cherokee",
      modell_hersteller_id: "19",
      modell_aktiv: "1",
    },
    {
      modell_id: "203",
      modell_name: "Renegade",
      modell_name_en: "Renegade",
      modell_hersteller_id: "19",
      modell_aktiv: "1",
    },
    {
      modell_id: "589",
      modell_name: "Grand Cherokee",
      modell_name_en: "Grand Cherokee",
      modell_hersteller_id: "19",
      modell_aktiv: "1",
    },
    {
      modell_id: "590",
      modell_name: "Patriot",
      modell_name_en: "Patriot",
      modell_hersteller_id: "19",
      modell_aktiv: "1",
    },
    {
      modell_id: "601",
      modell_name: "Compass",
      modell_name_en: "Compass",
      modell_hersteller_id: "19",
      modell_aktiv: "1",
    },
  ],
  20: [
    {
      modell_id: "204",
      modell_name: "Carens",
      modell_name_en: "Carens",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "205",
      modell_name: "Carnival",
      modell_name_en: "Carnival",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "206",
      modell_name: "Ceed Sportswagon",
      modell_name_en: "Ceed Sportswagon",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "207",
      modell_name: "Ceed",
      modell_name_en: "Ceed",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "208",
      modell_name: "Cerato",
      modell_name_en: "Cerato",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "209",
      modell_name: "Clarus",
      modell_name_en: "Clarus",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "210",
      modell_name: "Niro",
      modell_name_en: "Niro",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "211",
      modell_name: "Optima Sportswagon",
      modell_name_en: "Optima Sportswagon",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "212",
      modell_name: "Picanto",
      modell_name_en: "Picanto",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "213",
      modell_name: "Pregio",
      modell_name_en: "Pregio",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "214",
      modell_name: "Pride",
      modell_name_en: "Pride",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "215",
      modell_name: "Pro Ceed",
      modell_name_en: "Pro Ceed",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "216",
      modell_name: "Retona",
      modell_name_en: "Retona",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "217",
      modell_name: "Rio",
      modell_name_en: "Rio",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "218",
      modell_name: "Sephia",
      modell_name_en: "Sephia",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "219",
      modell_name: "Shuma II",
      modell_name_en: "Shuma II",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "220",
      modell_name: "Shuma",
      modell_name_en: "Shuma",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "221",
      modell_name: "Sorento",
      modell_name_en: "Sorento",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "222",
      modell_name: "Soul",
      modell_name_en: "Soul",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "223",
      modell_name: "Sportage",
      modell_name_en: "Sportage",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
    {
      modell_id: "224",
      modell_name: "Stonic",
      modell_name_en: "Stonic",
      modell_hersteller_id: "20",
      modell_aktiv: "1",
    },
  ],
  21: [
    {
      modell_id: "225",
      modell_name: "Aleko",
      modell_name_en: "Aleko",
      modell_hersteller_id: "21",
      modell_aktiv: "1",
    },
    {
      modell_id: "226",
      modell_name: "Forman",
      modell_name_en: "Forman",
      modell_hersteller_id: "21",
      modell_aktiv: "1",
    },
    {
      modell_id: "227",
      modell_name: "Priora",
      modell_name_en: "Priora",
      modell_hersteller_id: "21",
      modell_aktiv: "1",
    },
    {
      modell_id: "578",
      modell_name: "Niva",
      modell_name_en: "Niva",
      modell_hersteller_id: "21",
      modell_aktiv: "1",
    },
    {
      modell_id: "579",
      modell_name: "Nova",
      modell_name_en: "Nova",
      modell_hersteller_id: "21",
      modell_aktiv: "1",
    },
    {
      modell_id: "580",
      modell_name: "Taiga",
      modell_name_en: "Taiga",
      modell_hersteller_id: "21",
      modell_aktiv: "1",
    },
  ],
  22: [
    {
      modell_id: "228",
      modell_name: "Dedra",
      modell_name_en: "Dedra",
      modell_hersteller_id: "22",
      modell_aktiv: "1",
    },
    {
      modell_id: "229",
      modell_name: "Delta",
      modell_name_en: "Delta",
      modell_hersteller_id: "22",
      modell_aktiv: "1",
    },
    {
      modell_id: "230",
      modell_name: "Phedra",
      modell_name_en: "Phedra",
      modell_hersteller_id: "22",
      modell_aktiv: "1",
    },
    {
      modell_id: "231",
      modell_name: "Prisma",
      modell_name_en: "Prisma",
      modell_hersteller_id: "22",
      modell_aktiv: "1",
    },
    {
      modell_id: "232",
      modell_name: "Thema",
      modell_name_en: "Thema",
      modell_hersteller_id: "22",
      modell_aktiv: "1",
    },
    {
      modell_id: "233",
      modell_name: "Y10",
      modell_name_en: "Y10",
      modell_hersteller_id: "22",
      modell_aktiv: "1",
    },
    {
      modell_id: "234",
      modell_name: "Zeta",
      modell_name_en: "Zeta",
      modell_hersteller_id: "22",
      modell_aktiv: "1",
    },
  ],
  23: [
    {
      modell_id: "235",
      modell_name: "Defender",
      modell_name_en: "Defender",
      modell_hersteller_id: "23",
      modell_aktiv: "1",
    },
    {
      modell_id: "236",
      modell_name: "Discovery",
      modell_name_en: "Discovery",
      modell_hersteller_id: "23",
      modell_aktiv: "1",
    },
    {
      modell_id: "237",
      modell_name: "Range Rover",
      modell_name_en: "Range Rover",
      modell_hersteller_id: "23",
      modell_aktiv: "1",
    },
    {
      modell_id: "591",
      modell_name: "Freelander",
      modell_name_en: "Freelander",
      modell_hersteller_id: "23",
      modell_aktiv: "1",
    },
  ],
  24: [
    {
      modell_id: "238",
      modell_name: "RX",
      modell_name_en: "RX",
      modell_hersteller_id: "24",
      modell_aktiv: "1",
    },
  ],
  25: [
    {
      modell_id: "239",
      modell_name: "2",
      modell_name_en: "2",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "240",
      modell_name: "5",
      modell_name_en: "5",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "241",
      modell_name: "121",
      modell_name_en: "121",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "242",
      modell_name: "121",
      modell_name_en: "121",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "243",
      modell_name: "2",
      modell_name_en: "2",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "244",
      modell_name: "3",
      modell_name_en: "3",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "245",
      modell_name: "323",
      modell_name_en: "323",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "246",
      modell_name: "6",
      modell_name_en: "6",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "247",
      modell_name: "626",
      modell_name_en: "626",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "248",
      modell_name: "929",
      modell_name_en: "929",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "249",
      modell_name: "Canvas",
      modell_name_en: "Canvas",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "250",
      modell_name: "CX7",
      modell_name_en: "CX7",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "251",
      modell_name: "CX9",
      modell_name_en: "CX9",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "252",
      modell_name: "CX3",
      modell_name_en: "CX3",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "253",
      modell_name: "CX5",
      modell_name_en: "CX5",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "254",
      modell_name: "Demio",
      modell_name_en: "Demio",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "255",
      modell_name: "E 2000",
      modell_name_en: "E 2000",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "256",
      modell_name: "MPV",
      modell_name_en: "MPV",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "257",
      modell_name: "Premacy",
      modell_name_en: "Premacy",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "258",
      modell_name: "Revue",
      modell_name_en: "Revue",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "259",
      modell_name: "Tribute",
      modell_name_en: "Tribute",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "567",
      modell_name: "E2000/E2200",
      modell_name_en: "E2000/E2200",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
    {
      modell_id: "568",
      modell_name: "J10",
      modell_name_en: "J10",
      modell_hersteller_id: "25",
      modell_aktiv: "1",
    },
  ],
  26: [
    {
      modell_id: "260",
      modell_name: "A-Klasse",
      modell_name_en: "A-Class",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "261",
      modell_name: "B-Klasse",
      modell_name_en: "B-Class",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "262",
      modell_name: "C-Coupe",
      modell_name_en: "C-Coupe",
      modell_hersteller_id: "26",
      modell_aktiv: "0",
    },
    {
      modell_id: "263",
      modell_name: "Citan",
      modell_name_en: "Citan",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "264",
      modell_name: "C-Klasse",
      modell_name_en: "C-Class",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "265",
      modell_name: "CLA",
      modell_name_en: "CLA",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "266",
      modell_name: "CLK-Coupe",
      modell_name_en: "CLK-Coupe",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "267",
      modell_name: "CLS",
      modell_name_en: "CLS",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "268",
      modell_name: "Coupe",
      modell_name_en: "Coupe",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "269",
      modell_name: "E-Klasse",
      modell_name_en: "E-Class",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "270",
      modell_name: "GL",
      modell_name_en: "GL",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "271",
      modell_name: "GLA",
      modell_name_en: "GLA",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "272",
      modell_name: "GLC",
      modell_name_en: "GLC",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "273",
      modell_name: "GLE",
      modell_name_en: "GLE",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "274",
      modell_name: "GLK",
      modell_name_en: "GLK",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "275",
      modell_name: "GL-Klasse",
      modell_name_en: "GL-Class",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "276",
      modell_name: "GLS",
      modell_name_en: "GLS",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "277",
      modell_name: "MB 100",
      modell_name_en: "MB 100",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "278",
      modell_name: "M-Klasse",
      modell_name_en: "M-Class",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "279",
      modell_name: "R-Klasse",
      modell_name_en: "R-Class",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "280",
      modell_name: "S-Klasse",
      modell_name_en: "S-Class",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "281",
      modell_name: "Sprinter",
      modell_name_en: "Sprinter",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "282",
      modell_name: "T1",
      modell_name_en: "T1",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "283",
      modell_name: "T2",
      modell_name_en: "T2",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "284",
      modell_name: "Vaneo",
      modell_name_en: "Vaneo",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "285",
      modell_name: "Vito",
      modell_name_en: "Vito",
      modell_hersteller_id: "26",
      modell_aktiv: "0",
    },
    {
      modell_id: "286",
      modell_name: "Vito/Viano",
      modell_name_en: "Vito/Viano",
      modell_hersteller_id: "26",
      modell_aktiv: "0",
    },
    {
      modell_id: "287",
      modell_name: "V Klasse",
      modell_name_en: "V Class",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "288",
      modell_name: "W 123",
      modell_name_en: "W 123",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "289",
      modell_name: "W 124",
      modell_name_en: "W 124",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "290",
      modell_name: "W 126",
      modell_name_en: "W 126",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "291",
      modell_name: "W 201",
      modell_name_en: "W 201",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "292",
      modell_name: "X-Klasse",
      modell_name_en: "X-Class",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "592",
      modell_name: "200",
      modell_name_en: "200",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "593",
      modell_name: "300",
      modell_name_en: "300",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "594",
      modell_name: "G Klasse",
      modell_name_en: "G Class",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "598",
      modell_name: "GLB",
      modell_name_en: "GLB",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "604",
      modell_name: "EQC",
      modell_name_en: "EQC",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "608",
      modell_name: "EQA ",
      modell_name_en: "EQA ",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "611",
      modell_name: "C-Klasse T-Modell, mit Reling (S",
      modell_name_en: " C-Class Estate, with roof rails",
      modell_hersteller_id: "26",
      modell_aktiv: "0",
    },
    {
      modell_id: "620",
      modell_name: "EQB",
      modell_name_en: "EQB",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "629",
      modell_name: "EQE",
      modell_name_en: "EQE",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
    {
      modell_id: "640",
      modell_name: "T-Modell mit Reling (S 214)",
      modell_name_en: "E-Class Estate, with roof rails(",
      modell_hersteller_id: "26",
      modell_aktiv: "1",
    },
  ],
  27: [
    {
      modell_id: "293",
      modell_name: "Clubman",
      modell_name_en: "Clubman",
      modell_hersteller_id: "27",
      modell_aktiv: "1",
    },
    {
      modell_id: "294",
      modell_name: "Countryman",
      modell_name_en: "Countryman",
      modell_hersteller_id: "27",
      modell_aktiv: "1",
    },
  ],
  28: [
    {
      modell_id: "295",
      modell_name: "ASX",
      modell_name_en: "ASX",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "296",
      modell_name: "Colt",
      modell_name_en: "Colt",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "297",
      modell_name: "Eclipse Cross",
      modell_name_en: "Eclipse Cross",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "298",
      modell_name: "Galant",
      modell_name_en: "Galant",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "299",
      modell_name: "Grandis",
      modell_name_en: "Grandis",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "300",
      modell_name: "L200",
      modell_name_en: "L200",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "301",
      modell_name: "L300",
      modell_name_en: "L300",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "302",
      modell_name: "Lancer",
      modell_name_en: "Lancer",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "303",
      modell_name: "Outlander",
      modell_name_en: "Outlander",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "304",
      modell_name: "Pajero",
      modell_name_en: "Pajero",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "305",
      modell_name: "Santamo",
      modell_name_en: "Santamo",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "306",
      modell_name: "Sapporo",
      modell_name_en: "Sapporo",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "307",
      modell_name: "Sigma",
      modell_name_en: "Sigma",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "308",
      modell_name: "Space Runner",
      modell_name_en: "Space Runner",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "309",
      modell_name: "Space Star",
      modell_name_en: "Space Star",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "310",
      modell_name: "Space Wagon",
      modell_name_en: "Space Wagon",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "311",
      modell_name: "ZX",
      modell_name_en: "ZX",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
    {
      modell_id: "595",
      modell_name: "Galopper",
      modell_name_en: "Galopper",
      modell_hersteller_id: "28",
      modell_aktiv: "1",
    },
  ],
  29: [
    {
      modell_id: "312",
      modell_name: "Bluebird",
      modell_name_en: "Bluebird",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "313",
      modell_name: "Bus",
      modell_name_en: "Bus",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "314",
      modell_name: "Coupe",
      modell_name_en: "Coupe",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "315",
      modell_name: "Interstar",
      modell_name_en: "Interstar",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "316",
      modell_name: "Kubistar",
      modell_name_en: "Kubistar",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "317",
      modell_name: "Micra",
      modell_name_en: "Micra",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "318",
      modell_name: "Murano",
      modell_name_en: "Murano",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "319",
      modell_name: "Navara",
      modell_name_en: "Navara",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "320",
      modell_name: "Note",
      modell_name_en: "Note",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "321",
      modell_name: "NV200",
      modell_name_en: "NV200",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "322",
      modell_name: "NV400",
      modell_name_en: "NV400",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "323",
      modell_name: "NV300",
      modell_name_en: "NV300",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "324",
      modell_name: "Pathfinder",
      modell_name_en: "Pathfinder",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "325",
      modell_name: "Patrol",
      modell_name_en: "Patrol",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "326",
      modell_name: "Pixo",
      modell_name_en: "Pixo",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "327",
      modell_name: "Prairie",
      modell_name_en: "Prairie",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "328",
      modell_name: "Prima Star",
      modell_name_en: "Prima Star",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "329",
      modell_name: "Primera",
      modell_name_en: "Primera",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "330",
      modell_name: "Pulsar",
      modell_name_en: "Pulsar",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "331",
      modell_name: "Qashqai",
      modell_name_en: "Qashqai",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "332",
      modell_name: "Serena",
      modell_name_en: "Serena",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "333",
      modell_name: "Stanza",
      modell_name_en: "Stanza",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "334",
      modell_name: "Sunny",
      modell_name_en: "Sunny",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "335",
      modell_name: "Terrano",
      modell_name_en: "Terrano",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "336",
      modell_name: "Terrano II",
      modell_name_en: "Terrano II",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "337",
      modell_name: "Traveller",
      modell_name_en: "Traveller",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "338",
      modell_name: "Urvan",
      modell_name_en: "Urvan",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "339",
      modell_name: "Vanette ",
      modell_name_en: "Vanette ",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "340",
      modell_name: "X Trail",
      modell_name_en: "X Trail",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "573",
      modell_name: "NV400",
      modell_name_en: "NV400",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "574",
      modell_name: "Primastar",
      modell_name_en: "Primastar",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
    {
      modell_id: "628",
      modell_name: "Townstar",
      modell_name_en: "Townstar",
      modell_hersteller_id: "29",
      modell_aktiv: "1",
    },
  ],
  30: [
    {
      modell_id: "341",
      modell_name: "Adam",
      modell_name_en: "Adam",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "342",
      modell_name: "Agila",
      modell_name_en: "Agila",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "343",
      modell_name: "Antara",
      modell_name_en: "Antara",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "344",
      modell_name: "Astra",
      modell_name_en: "Astra",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "345",
      modell_name: "Calibra",
      modell_name_en: "Calibra",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "346",
      modell_name: "Combo",
      modell_name_en: "Combo",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "347",
      modell_name: "Corsa",
      modell_name_en: "Corsa",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "348",
      modell_name: "Crossland X",
      modell_name_en: "Crossland X",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "349",
      modell_name: "Frontera",
      modell_name_en: "Frontera",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "350",
      modell_name: "Grandland X",
      modell_name_en: "Grandland X",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "351",
      modell_name: "Insignia",
      modell_name_en: "Insignia",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "352",
      modell_name: "Kadett",
      modell_name_en: "Kadett",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "353",
      modell_name: "Karl ",
      modell_name_en: "Karl ",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "354",
      modell_name: "Meriva",
      modell_name_en: "Meriva",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "355",
      modell_name: "Mokka",
      modell_name_en: "Mokka",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "356",
      modell_name: "Monterey",
      modell_name_en: "Monterey",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "357",
      modell_name: "Movano",
      modell_name_en: "Movano",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "358",
      modell_name: "Omega",
      modell_name_en: "Omega",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "359",
      modell_name: "Senator",
      modell_name_en: "Senator",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "360",
      modell_name: "Signum",
      modell_name_en: "Signum",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "361",
      modell_name: "Sintra",
      modell_name_en: "Sintra",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "362",
      modell_name: "Tigra",
      modell_name_en: "Tigra",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "363",
      modell_name: "Vectra",
      modell_name_en: "Vectra",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "364",
      modell_name: "Vivaro",
      modell_name_en: "Vivaro",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "365",
      modell_name: "Zafira",
      modell_name_en: "Zafira",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "566",
      modell_name: "Arena",
      modell_name_en: "Arena",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
    {
      modell_id: "642",
      modell_name: "Movano C",
      modell_name_en: "Movano C",
      modell_hersteller_id: "30",
      modell_aktiv: "1",
    },
  ],
  31: [
    {
      modell_id: "366",
      modell_name: "308",
      modell_name_en: "308",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "367",
      modell_name: "406",
      modell_name_en: "406",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "368",
      modell_name: "605",
      modell_name_en: "605",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "369",
      modell_name: "806",
      modell_name_en: "806",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "370",
      modell_name: "1007",
      modell_name_en: "1007",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "371",
      modell_name: "3008",
      modell_name_en: "3008",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "372",
      modell_name: "4007",
      modell_name_en: "4007",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "373",
      modell_name: "4008",
      modell_name_en: "4008",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "374",
      modell_name: "1007",
      modell_name_en: "1007",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "375",
      modell_name: "1008",
      modell_name_en: "1008",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "376",
      modell_name: "106",
      modell_name_en: "106",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "377",
      modell_name: "107",
      modell_name_en: "107",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "378",
      modell_name: "108",
      modell_name_en: "108",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "379",
      modell_name: "205",
      modell_name_en: "205",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "380",
      modell_name: "206",
      modell_name_en: "206",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "381",
      modell_name: "207",
      modell_name_en: "207",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "382",
      modell_name: "208",
      modell_name_en: "208",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "383",
      modell_name: "3008",
      modell_name_en: "3008",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "384",
      modell_name: "306",
      modell_name_en: "306",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "385",
      modell_name: "307",
      modell_name_en: "307",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "386",
      modell_name: "4008",
      modell_name_en: "4008",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "387",
      modell_name: "405",
      modell_name_en: "405",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "388",
      modell_name: "405",
      modell_name_en: "405",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "389",
      modell_name: "406",
      modell_name_en: "406",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "390",
      modell_name: "407",
      modell_name_en: "407",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "391",
      modell_name: "5008",
      modell_name_en: "5008",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "392",
      modell_name: "508",
      modell_name_en: "508",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "393",
      modell_name: "807",
      modell_name_en: "807",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "394",
      modell_name: "Bipper",
      modell_name_en: "Bipper",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "395",
      modell_name: "Boxer",
      modell_name_en: "Boxer",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "396",
      modell_name: "Expert",
      modell_name_en: "Expert",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "397",
      modell_name: "J5",
      modell_name_en: "J5",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "398",
      modell_name: "Partner",
      modell_name_en: "Partner",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "399",
      modell_name: "Rifter",
      modell_name_en: "Rifter",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
    {
      modell_id: "400",
      modell_name: "Traveller",
      modell_name_en: "Traveller",
      modell_hersteller_id: "31",
      modell_aktiv: "1",
    },
  ],
  32: [
    {
      modell_id: "401",
      modell_name: "",
      modell_name_en: "",
      modell_hersteller_id: "32",
      modell_aktiv: "1",
    },
    {
      modell_id: "599",
      modell_name: "allgemein",
      modell_name_en: "general",
      modell_hersteller_id: "32",
      modell_aktiv: "1",
    },
    {
      modell_id: "613",
      modell_name: "Stützfußsatz RTD",
      modell_name_en: "Support foot kit",
      modell_hersteller_id: "32",
      modell_aktiv: "1",
    },
    {
      modell_id: "614",
      modell_name: "Stützfußset",
      modell_name_en: "Support foot kit",
      modell_hersteller_id: "32",
      modell_aktiv: "1",
    },
    {
      modell_id: "618",
      modell_name: "STRADA TRAIL",
      modell_name_en: "STRADA TRAIL",
      modell_hersteller_id: "32",
      modell_aktiv: "1",
    },
  ],
  33: [
    {
      modell_id: "402",
      modell_name: "Cayenne",
      modell_name_en: "Cayenne",
      modell_hersteller_id: "33",
      modell_aktiv: "1",
    },
  ],
  34: [
    {
      modell_id: "403",
      modell_name: "Alaskan",
      modell_name_en: "Alaskan",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "404",
      modell_name: "Captur",
      modell_name_en: "Captur",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "405",
      modell_name: "Chamade",
      modell_name_en: "Chamade",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "406",
      modell_name: "Clio",
      modell_name_en: "Clio",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "407",
      modell_name: "Espace",
      modell_name_en: "Espace",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "408",
      modell_name: "Grand Espace",
      modell_name_en: "Grand Espace",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "409",
      modell_name: "Grand Modus",
      modell_name_en: "Grand Modus",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "410",
      modell_name: "Grand Scenic",
      modell_name_en: "Grand Scenic",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "411",
      modell_name: "Kadjar",
      modell_name_en: "Kadjar",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "412",
      modell_name: "Kangoo",
      modell_name_en: "Kangoo",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "413",
      modell_name: "Koleos",
      modell_name_en: "Koleos",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "414",
      modell_name: "Laguna",
      modell_name_en: "Laguna",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "415",
      modell_name: "Master",
      modell_name_en: "Master",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "416",
      modell_name: "Megane",
      modell_name_en: "Megane",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "417",
      modell_name: "Modus",
      modell_name_en: "Modus",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "418",
      modell_name: "R19",
      modell_name_en: "R19",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "419",
      modell_name: "R21",
      modell_name_en: "R21",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "420",
      modell_name: "R5",
      modell_name_en: "R5",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "421",
      modell_name: "Rapid",
      modell_name_en: "Rapid",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "422",
      modell_name: "Safrane",
      modell_name_en: "Safrane",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "423",
      modell_name: "Scenic",
      modell_name_en: "Scenic",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "424",
      modell_name: "Talisman",
      modell_name_en: "Talisman",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "425",
      modell_name: "Trafic",
      modell_name_en: "Trafic",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "426",
      modell_name: "Twingo",
      modell_name_en: "Twingo",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "576",
      modell_name: "T800",
      modell_name_en: "T800",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "617",
      modell_name: "Express",
      modell_name_en: "Express",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "625",
      modell_name: "Arkana",
      modell_name_en: "Arkana",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "633",
      modell_name: "Austral",
      modell_name_en: "Austral",
      modell_hersteller_id: "34",
      modell_aktiv: "1",
    },
    {
      modell_id: "637",
      modell_name: "Megane E-Tech",
      modell_name_en: "Megane E-Tech",
      modell_hersteller_id: "34",
      modell_aktiv: "0",
    },
  ],
  35: [
    {
      modell_id: "427",
      modell_name: "75",
      modell_name_en: "75",
      modell_hersteller_id: "35",
      modell_aktiv: "1",
    },
    {
      modell_id: "428",
      modell_name: "Land Rover",
      modell_name_en: "Land Rover",
      modell_hersteller_id: "35",
      modell_aktiv: "1",
    },
    {
      modell_id: "429",
      modell_name: "Montego",
      modell_name_en: "Montego",
      modell_hersteller_id: "35",
      modell_aktiv: "1",
    },
    {
      modell_id: "430",
      modell_name: "Range Rover",
      modell_name_en: "Range Rover",
      modell_hersteller_id: "35",
      modell_aktiv: "1",
    },
    {
      modell_id: "431",
      modell_name: "214",
      modell_name_en: "214",
      modell_hersteller_id: "35",
      modell_aktiv: "1",
    },
    {
      modell_id: "432",
      modell_name: "216",
      modell_name_en: "216",
      modell_hersteller_id: "35",
      modell_aktiv: "1",
    },
    {
      modell_id: "433",
      modell_name: "414",
      modell_name_en: "414",
      modell_hersteller_id: "35",
      modell_aktiv: "1",
    },
    {
      modell_id: "434",
      modell_name: "416",
      modell_name_en: "416",
      modell_hersteller_id: "35",
      modell_aktiv: "1",
    },
  ],
  36: [
    {
      modell_id: "435",
      modell_name: "9000",
      modell_name_en: "9000",
      modell_hersteller_id: "36",
      modell_aktiv: "1",
    },
    {
      modell_id: "436",
      modell_name: "900",
      modell_name_en: "900",
      modell_hersteller_id: "36",
      modell_aktiv: "1",
    },
    {
      modell_id: "437",
      modell_name: "9 3",
      modell_name_en: "9 3",
      modell_hersteller_id: "36",
      modell_aktiv: "1",
    },
    {
      modell_id: "438",
      modell_name: "9 5",
      modell_name_en: "9 5",
      modell_hersteller_id: "36",
      modell_aktiv: "1",
    },
  ],
  37: [
    {
      modell_id: "439",
      modell_name: "Alhambra",
      modell_name_en: "Alhambra",
      modell_hersteller_id: "37",
      modell_aktiv: "1",
    },
    {
      modell_id: "440",
      modell_name: "Altea",
      modell_name_en: "Altea",
      modell_hersteller_id: "37",
      modell_aktiv: "1",
    },
    {
      modell_id: "441",
      modell_name: "Arona",
      modell_name_en: "Arona",
      modell_hersteller_id: "37",
      modell_aktiv: "1",
    },
    {
      modell_id: "442",
      modell_name: "Arosa",
      modell_name_en: "Arosa",
      modell_hersteller_id: "37",
      modell_aktiv: "1",
    },
    {
      modell_id: "443",
      modell_name: "Ateca",
      modell_name_en: "Ateca",
      modell_hersteller_id: "37",
      modell_aktiv: "1",
    },
    {
      modell_id: "444",
      modell_name: "Cordoba",
      modell_name_en: "Cordoba",
      modell_hersteller_id: "37",
      modell_aktiv: "1",
    },
    {
      modell_id: "445",
      modell_name: "Exeo",
      modell_name_en: "Exeo",
      modell_hersteller_id: "37",
      modell_aktiv: "1",
    },
    {
      modell_id: "446",
      modell_name: "Ibiza",
      modell_name_en: "Ibiza",
      modell_hersteller_id: "37",
      modell_aktiv: "1",
    },
    {
      modell_id: "447",
      modell_name: "Inca",
      modell_name_en: "Inca",
      modell_hersteller_id: "37",
      modell_aktiv: "1",
    },
    {
      modell_id: "448",
      modell_name: "Leon",
      modell_name_en: "Leon",
      modell_hersteller_id: "37",
      modell_aktiv: "1",
    },
    {
      modell_id: "449",
      modell_name: "Marbella",
      modell_name_en: "Marbella",
      modell_hersteller_id: "37",
      modell_aktiv: "1",
    },
    {
      modell_id: "450",
      modell_name: "Mii",
      modell_name_en: "Mii",
      modell_hersteller_id: "37",
      modell_aktiv: "1",
    },
    {
      modell_id: "451",
      modell_name: "Tarraco",
      modell_name_en: "Tarraco",
      modell_hersteller_id: "37",
      modell_aktiv: "1",
    },
    {
      modell_id: "452",
      modell_name: "Terra",
      modell_name_en: "Terra",
      modell_hersteller_id: "37",
      modell_aktiv: "1",
    },
    {
      modell_id: "453",
      modell_name: "Toledo",
      modell_name_en: "Toledo",
      modell_hersteller_id: "37",
      modell_aktiv: "1",
    },
    {
      modell_id: "615",
      modell_name: "Leon Limousine",
      modell_name_en: "Leon Limousine",
      modell_hersteller_id: "37",
      modell_aktiv: "1",
    },
  ],
  38: [
    {
      modell_id: "454",
      modell_name: "Citigo",
      modell_name_en: "Citigo",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
    {
      modell_id: "455",
      modell_name: "Fabia",
      modell_name_en: "Fabia",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
    {
      modell_id: "456",
      modell_name: "Faforit",
      modell_name_en: "Faforit",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
    {
      modell_id: "457",
      modell_name: "Felicia",
      modell_name_en: "Felicia",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
    {
      modell_id: "458",
      modell_name: "Forman",
      modell_name_en: "Forman",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
    {
      modell_id: "459",
      modell_name: "Karoq",
      modell_name_en: "Karoq",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
    {
      modell_id: "460",
      modell_name: "Kodiaq",
      modell_name_en: "Kodiaq",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
    {
      modell_id: "461",
      modell_name: "Octavia",
      modell_name_en: "Octavia",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
    {
      modell_id: "462",
      modell_name: "Praktik",
      modell_name_en: "Praktik",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
    {
      modell_id: "463",
      modell_name: "Rapid",
      modell_name_en: "Rapid",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
    {
      modell_id: "464",
      modell_name: "Roomster",
      modell_name_en: "Roomster",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
    {
      modell_id: "465",
      modell_name: "Superb",
      modell_name_en: "Superb",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
    {
      modell_id: "466",
      modell_name: "Yeti",
      modell_name_en: "Yeti",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
    {
      modell_id: "596",
      modell_name: "Kamiq",
      modell_name_en: "Kamiq",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
    {
      modell_id: "597",
      modell_name: "Scala",
      modell_name_en: "Scala",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
    {
      modell_id: "610",
      modell_name: "Enyaq",
      modell_name_en: "Enyaq",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
    {
      modell_id: "616",
      modell_name: "Octavia Limousine",
      modell_name_en: "Octavia Limousine",
      modell_hersteller_id: "38",
      modell_aktiv: "1",
    },
  ],
  39: [
    {
      modell_id: "467",
      modell_name: "Korando",
      modell_name_en: "Korando",
      modell_hersteller_id: "39",
      modell_aktiv: "1",
    },
    {
      modell_id: "468",
      modell_name: "Kyron",
      modell_name_en: "Kyron",
      modell_hersteller_id: "39",
      modell_aktiv: "1",
    },
    {
      modell_id: "469",
      modell_name: "Musso",
      modell_name_en: "Musso",
      modell_hersteller_id: "39",
      modell_aktiv: "1",
    },
    {
      modell_id: "470",
      modell_name: "Rexton",
      modell_name_en: "Rexton",
      modell_hersteller_id: "39",
      modell_aktiv: "1",
    },
    {
      modell_id: "471",
      modell_name: "Rodius",
      modell_name_en: "Rodius",
      modell_hersteller_id: "39",
      modell_aktiv: "1",
    },
    {
      modell_id: "472",
      modell_name: "XLV",
      modell_name_en: "XLV",
      modell_hersteller_id: "39",
      modell_aktiv: "1",
    },
    {
      modell_id: "606",
      modell_name: "Tivoli",
      modell_name_en: "Tivoli",
      modell_hersteller_id: "39",
      modell_aktiv: "1",
    },
  ],
  40: [
    {
      modell_id: "473",
      modell_name: "Coupe",
      modell_name_en: "Coupe",
      modell_hersteller_id: "40",
      modell_aktiv: "1",
    },
    {
      modell_id: "474",
      modell_name: "E10",
      modell_name_en: "E10",
      modell_hersteller_id: "40",
      modell_aktiv: "1",
    },
    {
      modell_id: "475",
      modell_name: "E12",
      modell_name_en: "E12",
      modell_hersteller_id: "40",
      modell_aktiv: "1",
    },
    {
      modell_id: "476",
      modell_name: "Forester",
      modell_name_en: "Forester",
      modell_hersteller_id: "40",
      modell_aktiv: "1",
    },
    {
      modell_id: "477",
      modell_name: "Impreza",
      modell_name_en: "Impreza",
      modell_hersteller_id: "40",
      modell_aktiv: "1",
    },
    {
      modell_id: "478",
      modell_name: "Justy",
      modell_name_en: "Justy",
      modell_hersteller_id: "40",
      modell_aktiv: "1",
    },
    {
      modell_id: "479",
      modell_name: "Legacy",
      modell_name_en: "Legacy",
      modell_hersteller_id: "40",
      modell_aktiv: "1",
    },
    {
      modell_id: "480",
      modell_name: "Travel",
      modell_name_en: "Travel",
      modell_hersteller_id: "40",
      modell_aktiv: "1",
    },
    {
      modell_id: "481",
      modell_name: "Trezia",
      modell_name_en: "Trezia",
      modell_hersteller_id: "40",
      modell_aktiv: "1",
    },
    {
      modell_id: "482",
      modell_name: "Tribeca",
      modell_name_en: "Tribeca",
      modell_hersteller_id: "40",
      modell_aktiv: "1",
    },
    {
      modell_id: "483",
      modell_name: "XV",
      modell_name_en: "XV",
      modell_hersteller_id: "40",
      modell_aktiv: "1",
    },
    {
      modell_id: "638",
      modell_name: "Soltera",
      modell_name_en: "Soltera ",
      modell_hersteller_id: "40",
      modell_aktiv: "1",
    },
    {
      modell_id: "643",
      modell_name: "Crosstrek",
      modell_name_en: "Crosstrek",
      modell_hersteller_id: "40",
      modell_aktiv: "1",
    },
  ],
  41: [
    {
      modell_id: "484",
      modell_name: "Alto",
      modell_name_en: "Alto",
      modell_hersteller_id: "41",
      modell_aktiv: "1",
    },
    {
      modell_id: "485",
      modell_name: "Baleno",
      modell_name_en: "Baleno",
      modell_hersteller_id: "41",
      modell_aktiv: "1",
    },
    {
      modell_id: "486",
      modell_name: "Grand Vitara",
      modell_name_en: "Grand Vitara",
      modell_hersteller_id: "41",
      modell_aktiv: "1",
    },
    {
      modell_id: "487",
      modell_name: "Ignis",
      modell_name_en: "Ignis",
      modell_hersteller_id: "41",
      modell_aktiv: "1",
    },
    {
      modell_id: "488",
      modell_name: "Jimny",
      modell_name_en: "Jimny",
      modell_hersteller_id: "41",
      modell_aktiv: "1",
    },
    {
      modell_id: "489",
      modell_name: "Splash",
      modell_name_en: "Splash",
      modell_hersteller_id: "41",
      modell_aktiv: "1",
    },
    {
      modell_id: "490",
      modell_name: "Swift",
      modell_name_en: "Swift",
      modell_hersteller_id: "41",
      modell_aktiv: "1",
    },
    {
      modell_id: "491",
      modell_name: "SX4",
      modell_name_en: "SX4",
      modell_hersteller_id: "41",
      modell_aktiv: "1",
    },
    {
      modell_id: "492",
      modell_name: "Vitara",
      modell_name_en: "Vitara",
      modell_hersteller_id: "41",
      modell_aktiv: "1",
    },
    {
      modell_id: "493",
      modell_name: "Wagon R+",
      modell_name_en: "Wagon R+",
      modell_hersteller_id: "41",
      modell_aktiv: "1",
    },
    {
      modell_id: "575",
      modell_name: "Super Carry",
      modell_name_en: "Super Carry",
      modell_hersteller_id: "41",
      modell_aktiv: "1",
    },
    {
      modell_id: "621",
      modell_name: "Swace",
      modell_name_en: "Swace",
      modell_hersteller_id: "41",
      modell_aktiv: "1",
    },
    {
      modell_id: "622",
      modell_name: "S-Cross",
      modell_name_en: "S-Cross",
      modell_hersteller_id: "41",
      modell_aktiv: "1",
    },
    {
      modell_id: "623",
      modell_name: "Across",
      modell_name_en: "Across",
      modell_hersteller_id: "41",
      modell_aktiv: "1",
    },
  ],
  42: [
    {
      modell_id: "494",
      modell_name: "Auris",
      modell_name_en: "Auris",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "495",
      modell_name: "Avensis",
      modell_name_en: "Avensis",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "496",
      modell_name: "Aygo",
      modell_name_en: "Aygo",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "497",
      modell_name: "Camry",
      modell_name_en: "Camry",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "498",
      modell_name: "Carina",
      modell_name_en: "Carina",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "499",
      modell_name: "Corolla",
      modell_name_en: "Corolla",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "500",
      modell_name: "Hiace",
      modell_name_en: "Hiace",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "501",
      modell_name: "Land Cruiser",
      modell_name_en: "Land Cruiser",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "502",
      modell_name: "Picnic",
      modell_name_en: "Picnic",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "503",
      modell_name: "Previa",
      modell_name_en: "Previa",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "504",
      modell_name: "Proace",
      modell_name_en: "Proace",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "505",
      modell_name: "Prvia",
      modell_name_en: "Prvia",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "506",
      modell_name: "RAV 4",
      modell_name_en: "RAV 4",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "507",
      modell_name: "Starlet",
      modell_name_en: "Starlet",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "508",
      modell_name: "Tercel",
      modell_name_en: "Tercel",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "509",
      modell_name: "Verso",
      modell_name_en: "Verso",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "510",
      modell_name: "Yaris",
      modell_name_en: "Yaris",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "569",
      modell_name: "Lite ace",
      modell_name_en: "Lite ace",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "603",
      modell_name: "Proace City",
      modell_name_en: "Proace City",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
    {
      modell_id: "631",
      modell_name: "BZ4X",
      modell_name_en: "BZ4X",
      modell_hersteller_id: "42",
      modell_aktiv: "1",
    },
  ],
  43: [
    {
      modell_id: "511",
      modell_name: "Amarok",
      modell_name_en: "Amarok",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "512",
      modell_name: "Arteon",
      modell_name_en: "Arteon",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "513",
      modell_name: "Bora",
      modell_name_en: "Bora",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "514",
      modell_name: "Caddy",
      modell_name_en: "Caddy",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "515",
      modell_name: "Caravelle",
      modell_name_en: "Caravelle",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "516",
      modell_name: "Corrado",
      modell_name_en: "Corrado",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "517",
      modell_name: "Crafter",
      modell_name_en: "Crafter",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "518",
      modell_name: "Fox",
      modell_name_en: "Fox",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "519",
      modell_name: "Golf II",
      modell_name_en: "Golf II",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "520",
      modell_name: "Golf III",
      modell_name_en: "Golf III",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "521",
      modell_name: "Golf IV",
      modell_name_en: "Golf IV",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "522",
      modell_name: "Golf",
      modell_name_en: "Golf",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "523",
      modell_name: "Golf V",
      modell_name_en: "Golf V",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "524",
      modell_name: "Golf VI",
      modell_name_en: "Golf VI",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "525",
      modell_name: "Golf VII",
      modell_name_en: "Golf VII",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "526",
      modell_name: "Jetta",
      modell_name_en: "Jetta",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "527",
      modell_name: "Kastenwagen",
      modell_name_en: "Kastenwagen",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "528",
      modell_name: "Kombi",
      modell_name_en: "Kombi",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "529",
      modell_name: "LT 28",
      modell_name_en: "LT 28",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "530",
      modell_name: "LT 35",
      modell_name_en: "LT 35",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "531",
      modell_name: "Lupo",
      modell_name_en: "Lupo",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "532",
      modell_name: "Multivan",
      modell_name_en: "Multivan",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "533",
      modell_name: "Passat",
      modell_name_en: "Passat",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "534",
      modell_name: "Polo",
      modell_name_en: "Polo",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "535",
      modell_name: "Sharan",
      modell_name_en: "Sharan",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "536",
      modell_name: "T4",
      modell_name_en: "T4",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "537",
      modell_name: "T5",
      modell_name_en: "T5",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "538",
      modell_name: "T6, T6-1",
      modell_name_en: "T6, T6-1",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "539",
      modell_name: "Tiguan",
      modell_name_en: "Tiguan",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "540",
      modell_name: "Touareg",
      modell_name_en: "Touareg",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "541",
      modell_name: "Touran",
      modell_name_en: "Touran",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "542",
      modell_name: "Transporter",
      modell_name_en: "Transporter",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "543",
      modell_name: "T-Roc",
      modell_name_en: "T-Roc",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "544",
      modell_name: "Up",
      modell_name_en: "Up",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "545",
      modell_name: "Vento",
      modell_name_en: "Vento",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "570",
      modell_name: "LT2",
      modell_name_en: "LT2",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "571",
      modell_name: "LT2",
      modell_name_en: "LT2",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "572",
      modell_name: "LT28/45",
      modell_name_en: "LT28/45",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "577",
      modell_name: "Transporter, Multivan, Caravelle",
      modell_name_en: "Transporter, Multivan, Caravelle",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "602",
      modell_name: "Golf VIII",
      modell_name_en: "Golf VIII",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "607",
      modell_name: "ID 4",
      modell_name_en: "ID 4",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "619",
      modell_name: "Taigo",
      modell_name_en: "Taigo",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "630",
      modell_name: "T7",
      modell_name_en: "T7",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "636",
      modell_name: "ID Buzz",
      modell_name_en: "ID Buzz",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
    {
      modell_id: "644",
      modell_name: "T-Cross",
      modell_name_en: "T-Cross",
      modell_hersteller_id: "43",
      modell_aktiv: "1",
    },
  ],
  44: [
    {
      modell_id: "546",
      modell_name: "240",
      modell_name_en: "240",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "547",
      modell_name: "440",
      modell_name_en: "440",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "548",
      modell_name: "460",
      modell_name_en: "460",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "549",
      modell_name: "740",
      modell_name_en: "740",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "550",
      modell_name: "760",
      modell_name_en: "760",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "551",
      modell_name: "940",
      modell_name_en: "940",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "552",
      modell_name: "960",
      modell_name_en: "960",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "553",
      modell_name: "850",
      modell_name_en: "850",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "554",
      modell_name: "C30",
      modell_name_en: "C30",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "555",
      modell_name: "S40",
      modell_name_en: "S40",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "556",
      modell_name: "S80",
      modell_name_en: "S80",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "557",
      modell_name: "V40",
      modell_name_en: "V40",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "558",
      modell_name: "V50",
      modell_name_en: "V50",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "559",
      modell_name: "V60",
      modell_name_en: "V60",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "560",
      modell_name: "V70",
      modell_name_en: "V70",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "561",
      modell_name: "V90",
      modell_name_en: "V90",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "562",
      modell_name: "XC40",
      modell_name_en: "XC40",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "563",
      modell_name: "XC60",
      modell_name_en: "XC60",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "564",
      modell_name: "XC70",
      modell_name_en: "XC70",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
    {
      modell_id: "565",
      modell_name: "XC90",
      modell_name_en: "XC90",
      modell_hersteller_id: "44",
      modell_aktiv: "1",
    },
  ],
  46: [
    {
      modell_id: "605",
      modell_name: "Formentor",
      modell_name_en: "Formentor",
      modell_hersteller_id: "46",
      modell_aktiv: "1",
    },
    {
      modell_id: "612",
      modell_name: "Leon Sportstourer",
      modell_name_en: "Leon Sportstourer",
      modell_hersteller_id: "46",
      modell_aktiv: "1",
    },
  ],
  47: [
    {
      modell_id: "624",
      modell_name: "U5",
      modell_name_en: "U5",
      modell_hersteller_id: "47",
      modell_aktiv: "1",
    },
  ],
  48: [
    {
      modell_id: "626",
      modell_name: "5",
      modell_name_en: "5",
      modell_hersteller_id: "48",
      modell_aktiv: "1",
    },
    {
      modell_id: "627",
      modell_name: "EHS",
      modell_name_en: "EHS",
      modell_hersteller_id: "48",
      modell_aktiv: "1",
    },
    {
      modell_id: "632",
      modell_name: "ZS",
      modell_name_en: "ZS",
      modell_hersteller_id: "48",
      modell_aktiv: "1",
    },
  ],
  49: [
    {
      modell_id: "634",
      modell_name: "Atto 3",
      modell_name_en: "Atto 3",
      modell_hersteller_id: "49",
      modell_aktiv: "1",
    },
    {
      modell_id: "635",
      modell_name: "Tang",
      modell_name_en: "Tang",
      modell_hersteller_id: "49",
      modell_aktiv: "1",
    },
  ],
  50: [
    {
      modell_id: "641",
      modell_name: "7Crossback",
      modell_name_en: "7Crossback",
      modell_hersteller_id: "50",
      modell_aktiv: "1",
    },
  ],
};

const trims = {
  1: [
    {
      ausfuehrung_id: "1",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "1",
      ausfuehrung_modell_id: "1",
      ausfuehrung_aktiv: "1",
    },
  ],
  2: [
    {
      ausfuehrung_id: "2",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "1",
      ausfuehrung_modell_id: "2",
      ausfuehrung_aktiv: "1",
    },
  ],
  3: [
    {
      ausfuehrung_id: "3",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "1",
      ausfuehrung_modell_id: "3",
      ausfuehrung_aktiv: "1",
    },
  ],
  4: [
    {
      ausfuehrung_id: "4",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "1",
      ausfuehrung_modell_id: "4",
      ausfuehrung_aktiv: "1",
    },
  ],
  5: [
    {
      ausfuehrung_id: "5",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "1",
      ausfuehrung_modell_id: "5",
      ausfuehrung_aktiv: "1",
    },
  ],
  6: [
    {
      ausfuehrung_id: "6",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "1",
      ausfuehrung_modell_id: "6",
      ausfuehrung_aktiv: "1",
    },
  ],
  7: [
    {
      ausfuehrung_id: "7",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "1",
      ausfuehrung_modell_id: "7",
      ausfuehrung_aktiv: "1",
    },
  ],
  8: [
    {
      ausfuehrung_id: "8",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "1",
      ausfuehrung_modell_id: "8",
      ausfuehrung_aktiv: "1",
    },
  ],
  9: [
    {
      ausfuehrung_id: "9",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "1",
      ausfuehrung_modell_id: "9",
      ausfuehrung_aktiv: "1",
    },
  ],
  10: [
    {
      ausfuehrung_id: "10",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "10",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "11",
      ausfuehrung_name: "o. Reling",
      ausfuehrung_name_en: "wo. rail",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "10",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "12",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "10",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1193",
      ausfuehrung_name: "o. Reling",
      ausfuehrung_name_en: "wo. rail",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "10",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1194",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "10",
      ausfuehrung_aktiv: "1",
    },
  ],
  11: [
    {
      ausfuehrung_id: "13",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "11",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1195",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "11",
      ausfuehrung_aktiv: "1",
    },
  ],
  12: [
    {
      ausfuehrung_id: "14",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "12",
      ausfuehrung_aktiv: "1",
    },
  ],
  13: [
    {
      ausfuehrung_id: "15",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "13",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "16",
      ausfuehrung_name: "V8",
      ausfuehrung_name_en: "V8",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "13",
      ausfuehrung_aktiv: "1",
    },
  ],
  14: [
    {
      ausfuehrung_id: "17",
      ausfuehrung_name: "o. Reling",
      ausfuehrung_name_en: "wo. rail",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "14",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "18",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "14",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "19",
      ausfuehrung_name: "B4 mit Reling",
      ausfuehrung_name_en: "B4 with rail",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "14",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1196",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "14",
      ausfuehrung_aktiv: "1",
    },
  ],
  15: [
    {
      ausfuehrung_id: "20",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "15",
      ausfuehrung_aktiv: "1",
    },
  ],
  16: [
    {
      ausfuehrung_id: "21",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "16",
      ausfuehrung_aktiv: "1",
    },
  ],
  17: [
    {
      ausfuehrung_id: "22",
      ausfuehrung_name: "(8X)",
      ausfuehrung_name_en: "(8X)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "17",
      ausfuehrung_aktiv: "1",
    },
  ],
  18: [
    {
      ausfuehrung_id: "23",
      ausfuehrung_name: "3-türig (8X)",
      ausfuehrung_name_en: "3 doors (8X)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "18",
      ausfuehrung_aktiv: "1",
    },
  ],
  19: [
    {
      ausfuehrung_id: "24",
      ausfuehrung_name: "3- und 5-türig (8L)",
      ausfuehrung_name_en: "3-  and 5 doors (8L)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "19",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "25",
      ausfuehrung_name: "Limousine, 4-türig (8VS)",
      ausfuehrung_name_en: "Limousine, 4 doors (8VS)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "19",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "29",
      ausfuehrung_name: "3-türig (8P) ",
      ausfuehrung_name_en: "3 doors (8P) ",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "19",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "30",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "19",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1183",
      ausfuehrung_name: "3-türig  (8V) ",
      ausfuehrung_name_en: "3 doors  (8V)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "19",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1197",
      ausfuehrung_name: "3- und 5-türig (8L)",
      ausfuehrung_name_en: "3-  and 5 doors (8L)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "19",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1198",
      ausfuehrung_name: "3- und 5-türig (8L)",
      ausfuehrung_name_en: "3-  and 5 doors (8L)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "19",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1201",
      ausfuehrung_name: "3-türig (8P) ",
      ausfuehrung_name_en: "3 doors (8P) ",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "19",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1202",
      ausfuehrung_name: "3-türig (8P) ",
      ausfuehrung_name_en: "3 doors (8P) ",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "19",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1203",
      ausfuehrung_name: "3-türig (8P) ",
      ausfuehrung_name_en: "3 doors (8P) ",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "19",
      ausfuehrung_aktiv: "1",
    },
  ],
  20: [
    {
      ausfuehrung_id: "26",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "20",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "27",
      ausfuehrung_name: "mit Reling (8PA)",
      ausfuehrung_name_en: "with rail (8PA)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "20",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "28",
      ausfuehrung_name: "o. Reling (8PA)",
      ausfuehrung_name_en: "wo. rail (8PA)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "20",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1184",
      ausfuehrung_name: "mit Reling (8VA)",
      ausfuehrung_name_en: "with rail (8VA)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "20",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1185",
      ausfuehrung_name: "o. Reling  (8VA)",
      ausfuehrung_name_en: "wo. rail  (8VA)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "20",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1199",
      ausfuehrung_name: "mit Reling (8PA)",
      ausfuehrung_name_en: "with rail (8PA)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "20",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1200",
      ausfuehrung_name: "o. Reling (8PA)",
      ausfuehrung_name_en: "wo. rail (8PA)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "20",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1697",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "20",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1704",
      ausfuehrung_name: "ohne Reling",
      ausfuehrung_name_en: "without roof rails",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "20",
      ausfuehrung_aktiv: "1",
    },
  ],
  21: [
    {
      ausfuehrung_id: "31",
      ausfuehrung_name: "mit Reling  (B8,B9)",
      ausfuehrung_name_en: "with rail  (B8,B9)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "21",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1204",
      ausfuehrung_name: "mit Reling  (B8,B9)",
      ausfuehrung_name_en: "with rail  (B8,B9)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "21",
      ausfuehrung_aktiv: "1",
    },
  ],
  22: [
    {
      ausfuehrung_id: "32",
      ausfuehrung_name: "mit Reling  (B5)",
      ausfuehrung_name_en: "with rail  (B5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "22",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "33",
      ausfuehrung_name: "mit Reling (B6)",
      ausfuehrung_name_en: "with rail (B6)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "22",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1205",
      ausfuehrung_name: "mit Reling  (B8,B9)",
      ausfuehrung_name_en: "with rail  (B8,B9)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "22",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1206",
      ausfuehrung_name: "mit Reling  (B8,B9)",
      ausfuehrung_name_en: "with rail  (B8,B9)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "22",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1207",
      ausfuehrung_name: "mit Reling  (B8,B9)",
      ausfuehrung_name_en: "with rail  (B8,B9)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "22",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1208",
      ausfuehrung_name: "mit Reling (B6)",
      ausfuehrung_name_en: "with rail (B6)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "22",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1209",
      ausfuehrung_name: "mit Reling (B6)",
      ausfuehrung_name_en: "with rail (B6)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "22",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1210",
      ausfuehrung_name: "mit Reling (B6)",
      ausfuehrung_name_en: "with rail (B6)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "22",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1211",
      ausfuehrung_name: "mit Reling (B6)",
      ausfuehrung_name_en: "with rail (B6)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "22",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1698",
      ausfuehrung_name: "mit Reling (B5)",
      ausfuehrung_name_en: "with roof rails (B5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "22",
      ausfuehrung_aktiv: "1",
    },
  ],
  23: [
    {
      ausfuehrung_id: "34",
      ausfuehrung_name: "Limousine (B5)",
      ausfuehrung_name_en: "Limousine (B5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "23",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1186",
      ausfuehrung_name: "Limousine (B6,B7)",
      ausfuehrung_name_en: "Limousine (B6,B7)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "23",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1187",
      ausfuehrung_name: "Limousine (B8)",
      ausfuehrung_name_en: "Limousine (B8)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "23",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1188",
      ausfuehrung_name: "Limousine (B9)",
      ausfuehrung_name_en: "Limousine (B9)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "23",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1212",
      ausfuehrung_name: "Limousine (B5)",
      ausfuehrung_name_en: "Limousine (B5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "23",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1213",
      ausfuehrung_name: "Limousine (B5)",
      ausfuehrung_name_en: "Limousine (B5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "23",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1214",
      ausfuehrung_name: "Limousine (B5)",
      ausfuehrung_name_en: "Limousine (B5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "23",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1215",
      ausfuehrung_name: "Limousine (B5)",
      ausfuehrung_name_en: "Limousine (B5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "23",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1216",
      ausfuehrung_name: "Limousine (B5)",
      ausfuehrung_name_en: "Limousine (B5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "23",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1217",
      ausfuehrung_name: "Limousine (B5)",
      ausfuehrung_name_en: "Limousine (B5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "23",
      ausfuehrung_aktiv: "1",
    },
  ],
  24: [
    {
      ausfuehrung_id: "35",
      ausfuehrung_name: "  (B9,F5)",
      ausfuehrung_name_en: "  (B9,F5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "24",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1189",
      ausfuehrung_name: "(8T)",
      ausfuehrung_name_en: "(8T)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "24",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1218",
      ausfuehrung_name: "  (B9,F5)",
      ausfuehrung_name_en: "  (B9,F5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "24",
      ausfuehrung_aktiv: "1",
    },
  ],
  25: [
    {
      ausfuehrung_id: "36",
      ausfuehrung_name: "mit Reling (C5)",
      ausfuehrung_name_en: "with rail (C5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "25",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "46",
      ausfuehrung_name: "Quattro",
      ausfuehrung_name_en: "Quattro",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "25",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1190",
      ausfuehrung_name: "mit Reling (C6)",
      ausfuehrung_name_en: "with rail (C6)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "25",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1191",
      ausfuehrung_name: "mit Reling (C7)",
      ausfuehrung_name_en: "with rail (C7)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "25",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1219",
      ausfuehrung_name: "mit Reling (C5)",
      ausfuehrung_name_en: "with rail (C5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "25",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1220",
      ausfuehrung_name: "mit Reling (C5)",
      ausfuehrung_name_en: "with rail (C5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "25",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1230",
      ausfuehrung_name: "Quattro",
      ausfuehrung_name_en: "Quattro",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "25",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1758",
      ausfuehrung_name: "mit Reling (C8)",
      ausfuehrung_name_en: "with roof rails (C8)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "25",
      ausfuehrung_aktiv: "1",
    },
  ],
  26: [
    {
      ausfuehrung_id: "37",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "26",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "38",
      ausfuehrung_name: "o. Reling",
      ausfuehrung_name_en: "wo. rail",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "26",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "39",
      ausfuehrung_name: "mit Reling (C5)",
      ausfuehrung_name_en: "with rail (C5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "26",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "40",
      ausfuehrung_name: "mit Reling (C6)",
      ausfuehrung_name_en: "with rail (C6)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "26",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "41",
      ausfuehrung_name: "mit Reling (C7)",
      ausfuehrung_name_en: "with rail (C7)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "26",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "42",
      ausfuehrung_name: "mit Reling (C8)",
      ausfuehrung_name_en: "with rail (C8)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "26",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1221",
      ausfuehrung_name: "mit Reling (C5)",
      ausfuehrung_name_en: "with rail (C5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "26",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1222",
      ausfuehrung_name: "mit Reling (C4)",
      ausfuehrung_name_en: "with rail (C4)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "26",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1223",
      ausfuehrung_name: "mit Reling (C5)",
      ausfuehrung_name_en: "with rail (C5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "26",
      ausfuehrung_aktiv: "1",
    },
  ],
  27: [
    {
      ausfuehrung_id: "43",
      ausfuehrung_name: "Limousine (C6)",
      ausfuehrung_name_en: "Limousine (C6)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "27",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "44",
      ausfuehrung_name: "Limousine (C8) ",
      ausfuehrung_name_en: "Limousine (C8) ",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "27",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1224",
      ausfuehrung_name: "Limousine (C6)",
      ausfuehrung_name_en: "Limousine (C6)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "27",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1225",
      ausfuehrung_name: "Limousine (C7)",
      ausfuehrung_name_en: "Limousine (C6)7",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "27",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1226",
      ausfuehrung_name: "Limousine (C5)",
      ausfuehrung_name_en: "Limousine (C5)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "27",
      ausfuehrung_aktiv: "1",
    },
  ],
  28: [
    {
      ausfuehrung_id: "45",
      ausfuehrung_name: "Limousine (D3 - nur kurze Vers.)",
      ausfuehrung_name_en: "Limousine (D3 - only short version)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "28",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1227",
      ausfuehrung_name: "Limousine (D4 - nur kurze Vers.)",
      ausfuehrung_name_en: "Limousine (D4 - only short version)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "28",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1228",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "28",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1229",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "28",
      ausfuehrung_aktiv: "1",
    },
  ],
  29: [
    {
      ausfuehrung_id: "47",
      ausfuehrung_name: "(GA)",
      ausfuehrung_name_en: "(GA)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "29",
      ausfuehrung_aktiv: "1",
    },
  ],
  30: [
    {
      ausfuehrung_id: "48",
      ausfuehrung_name: "mit Reling (8U, F3)",
      ausfuehrung_name_en: "with rail (8U, F3)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "30",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1686",
      ausfuehrung_name: "Sportback",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "30",
      ausfuehrung_aktiv: "1",
    },
  ],
  31: [
    {
      ausfuehrung_id: "49",
      ausfuehrung_name: "mit Reling (8R)",
      ausfuehrung_name_en: "with rail (8R)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "31",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1231",
      ausfuehrung_name: "mit Reling (FY)",
      ausfuehrung_name_en: "with rail (FY)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "31",
      ausfuehrung_aktiv: "1",
    },
  ],
  32: [
    {
      ausfuehrung_id: "50",
      ausfuehrung_name: "mit Reling (4L)",
      ausfuehrung_name_en: "with roof rails (4L)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "32",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1232",
      ausfuehrung_name: "mit Reling (4M)",
      ausfuehrung_name_en: "with rail (4M)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "32",
      ausfuehrung_aktiv: "1",
    },
  ],
  33: [
    {
      ausfuehrung_id: "51",
      ausfuehrung_name: "mit Reling (4M)",
      ausfuehrung_name_en: "with rail (4M)",
      ausfuehrung_hersteller_id: "2",
      ausfuehrung_modell_id: "33",
      ausfuehrung_aktiv: "1",
    },
  ],
  34: [
    {
      ausfuehrung_id: "52",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "3",
      ausfuehrung_modell_id: "34",
      ausfuehrung_aktiv: "1",
    },
  ],
  35: [
    {
      ausfuehrung_id: "53",
      ausfuehrung_name: "1,6 l",
      ausfuehrung_name_en: "1,6 l",
      ausfuehrung_hersteller_id: "3",
      ausfuehrung_modell_id: "35",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "54",
      ausfuehrung_name: "2,0 l",
      ausfuehrung_name_en: "2,0 l",
      ausfuehrung_hersteller_id: "3",
      ausfuehrung_modell_id: "35",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "59",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "3",
      ausfuehrung_modell_id: "35",
      ausfuehrung_aktiv: "1",
    },
  ],
  36: [
    {
      ausfuehrung_id: "55",
      ausfuehrung_name: "Discovery",
      ausfuehrung_name_en: "Discovery",
      ausfuehrung_hersteller_id: "3",
      ausfuehrung_modell_id: "36",
      ausfuehrung_aktiv: "1",
    },
  ],
  37: [
    {
      ausfuehrung_id: "56",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "3",
      ausfuehrung_modell_id: "37",
      ausfuehrung_aktiv: "1",
    },
  ],
  38: [
    {
      ausfuehrung_id: "57",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "3",
      ausfuehrung_modell_id: "38",
      ausfuehrung_aktiv: "1",
    },
  ],
  39: [
    {
      ausfuehrung_id: "58",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "3",
      ausfuehrung_modell_id: "39",
      ausfuehrung_aktiv: "1",
    },
  ],
  40: [
    {
      ausfuehrung_id: "60",
      ausfuehrung_name: "3-türig (F21)",
      ausfuehrung_name_en: "3 doors (F21)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "40",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "61",
      ausfuehrung_name: "5-türig (F20)",
      ausfuehrung_name_en: "5 doors (F20)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "40",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "62",
      ausfuehrung_name: "3-türig (E81)",
      ausfuehrung_name_en: "3 doors(E81)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "40",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "63",
      ausfuehrung_name: "5-türig (E87)",
      ausfuehrung_name_en: "5 doors (E87)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "40",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1675",
      ausfuehrung_name: "5-türig (F40)",
      ausfuehrung_name_en: "5 doors (F40)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "40",
      ausfuehrung_aktiv: "1",
    },
  ],
  41: [
    {
      ausfuehrung_id: "64",
      ausfuehrung_name: "Active Tourer (F45)",
      ausfuehrung_name_en: "Active Tourer (F45)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "41",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "65",
      ausfuehrung_name: "Coupe (F22)",
      ausfuehrung_name_en: "Coupe (F22)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "41",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "66",
      ausfuehrung_name: "Grand Touer, mit Reling (F46)",
      ausfuehrung_name_en: "Grand Touer, with rails (F46)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "41",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1690",
      ausfuehrung_name: "Gran Coupe (F44)",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "41",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1729",
      ausfuehrung_name: "Active Tourer (U06)",
      ausfuehrung_name_en: "Active Tourer (U06)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "41",
      ausfuehrung_aktiv: "1",
    },
  ],
  42: [
    {
      ausfuehrung_id: "67",
      ausfuehrung_name: "Compact (E36)",
      ausfuehrung_name_en: "Compact (E36)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "42",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "68",
      ausfuehrung_name: "Compact (E46)",
      ausfuehrung_name_en: "Compact (E46)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "42",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "69",
      ausfuehrung_name: "Coupe, 2-türig (E92)",
      ausfuehrung_name_en: "Coupe, 2 door (E92)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "42",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "70",
      ausfuehrung_name: "Coupe, 2-türig (E46-2)",
      ausfuehrung_name_en: "Coupe 2 doors (E46-2)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "42",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "71",
      ausfuehrung_name: "GT (F34)",
      ausfuehrung_name_en: "GT (F34)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "42",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "72",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "42",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "73",
      ausfuehrung_name: "Limousine, 4-türig (E46-4)",
      ausfuehrung_name_en: "Limousine, 4 door (E46-4)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "42",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "74",
      ausfuehrung_name: "Limousine, 4-türig (E90)",
      ausfuehrung_name_en: "Limousine, 4 door (E90)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "42",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "75",
      ausfuehrung_name: "Limousine (F30)",
      ausfuehrung_name_en: "Limousine (F30)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "42",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "80",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "42",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "97",
      ausfuehrung_name: "(E36) Stufenheck",
      ausfuehrung_name_en: "(E36) notchback",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "42",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "98",
      ausfuehrung_name: "(E46) Stufenheck",
      ausfuehrung_name_en: "(E46) notchback",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "42",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1192",
      ausfuehrung_name: "Limousine (G20)",
      ausfuehrung_name_en: "Limousine (G20)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "42",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1233",
      ausfuehrung_name: "Coupe, 2-türig (E46-2)",
      ausfuehrung_name_en: "Coupe 2 doors (E46-2)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "42",
      ausfuehrung_aktiv: "1",
    },
  ],
  43: [
    {
      ausfuehrung_id: "81",
      ausfuehrung_name: "Coupe (F32)",
      ausfuehrung_name_en: "Coupe (F32)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "43",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "82",
      ausfuehrung_name: "Gran Coupe (F36)",
      ausfuehrung_name_en: "Gran Coupe (F36)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "43",
      ausfuehrung_aktiv: "1",
    },
  ],
  44: [
    {
      ausfuehrung_id: "83",
      ausfuehrung_name: "GT (F07)",
      ausfuehrung_name_en: "GT (F07)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "44",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "84",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "44",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "85",
      ausfuehrung_name: "Limousine (E39)",
      ausfuehrung_name_en: "Limousine (E39)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "44",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "86",
      ausfuehrung_name: "Limousine (E60)",
      ausfuehrung_name_en: "Limousine (E60)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "44",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "87",
      ausfuehrung_name: "Limousine (F10)",
      ausfuehrung_name_en: "Limousine (F10)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "44",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "88",
      ausfuehrung_name: "Limousine (G30)",
      ausfuehrung_name_en: "Limousine (G30)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "44",
      ausfuehrung_aktiv: "1",
    },
  ],
  45: [
    {
      ausfuehrung_id: "94",
      ausfuehrung_name: "Limousine (E32)",
      ausfuehrung_name_en: "Limousine (E32)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "45",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "95",
      ausfuehrung_name: "Limousine (E38)",
      ausfuehrung_name_en: "Limousine (E38)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "45",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "96",
      ausfuehrung_name: "Limousine (E65)",
      ausfuehrung_name_en: "Limousine (E65)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "45",
      ausfuehrung_aktiv: "1",
    },
  ],
  46: [
    {
      ausfuehrung_id: "99",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "46",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "100",
      ausfuehrung_name: "mit Reling (E84)",
      ausfuehrung_name_en: "with rail (E84)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "46",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "101",
      ausfuehrung_name: "mit Reling (F48)",
      ausfuehrung_name_en: "with rail (F48)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "46",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1748",
      ausfuehrung_name: "mit Reling (U11)",
      ausfuehrung_name_en: "with roof rails (U11)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "46",
      ausfuehrung_aktiv: "1",
    },
  ],
  47: [
    {
      ausfuehrung_id: "102",
      ausfuehrung_name: "mit Reling (F39)",
      ausfuehrung_name_en: "with rail (F39)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "47",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1773",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "47",
      ausfuehrung_aktiv: "1",
    },
  ],
  48: [
    {
      ausfuehrung_id: "103",
      ausfuehrung_name: "mit Reling (E83)",
      ausfuehrung_name_en: "with roof rail (E83)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "48",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "104",
      ausfuehrung_name: "mit Reling (F25)",
      ausfuehrung_name_en: "with rail (F25)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "48",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "105",
      ausfuehrung_name: "mit Reling (G01)",
      ausfuehrung_name_en: "with rail (G01)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "48",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1243",
      ausfuehrung_name: "mit Reling (F25)",
      ausfuehrung_name_en: "with rail (F25)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "48",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1244",
      ausfuehrung_name: "mit Reling (G01)",
      ausfuehrung_name_en: "with rail (G01)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "48",
      ausfuehrung_aktiv: "1",
    },
  ],
  49: [
    {
      ausfuehrung_id: "106",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "49",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "107",
      ausfuehrung_name: "mit Reling (F15)",
      ausfuehrung_name_en: "with rail (F15)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "49",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "108",
      ausfuehrung_name: "mit Reling (G05)",
      ausfuehrung_name_en: "with rail (G05)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "49",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "109",
      ausfuehrung_name: "mit Reling (E53,E70-nicht individual)",
      ausfuehrung_name_en: "with rail (E53,E70-not individual)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "49",
      ausfuehrung_aktiv: "1",
    },
  ],
  50: [
    {
      ausfuehrung_id: "110",
      ausfuehrung_name: "Coupe (E36-8)",
      ausfuehrung_name_en: "Coupe (E36-8)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "50",
      ausfuehrung_aktiv: "1",
    },
  ],
  51: [
    {
      ausfuehrung_id: "111",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "5",
      ausfuehrung_modell_id: "51",
      ausfuehrung_aktiv: "1",
    },
  ],
  52: [
    {
      ausfuehrung_id: "112",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "5",
      ausfuehrung_modell_id: "52",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1699",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "5",
      ausfuehrung_modell_id: "52",
      ausfuehrung_aktiv: "1",
    },
  ],
  53: [
    {
      ausfuehrung_id: "113",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rail",
      ausfuehrung_hersteller_id: "6",
      ausfuehrung_modell_id: "53",
      ausfuehrung_aktiv: "1",
    },
  ],
  54: [
    {
      ausfuehrung_id: "114",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "6",
      ausfuehrung_modell_id: "54",
      ausfuehrung_aktiv: "1",
    },
  ],
  55: [
    {
      ausfuehrung_id: "115",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "6",
      ausfuehrung_modell_id: "55",
      ausfuehrung_aktiv: "1",
    },
  ],
  56: [
    {
      ausfuehrung_id: "116",
      ausfuehrung_name: "CD, mit Reling",
      ausfuehrung_name_en: "CD, mit Reling",
      ausfuehrung_hersteller_id: "6",
      ausfuehrung_modell_id: "56",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "117",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "6",
      ausfuehrung_modell_id: "56",
      ausfuehrung_aktiv: "1",
    },
  ],
  57: [
    {
      ausfuehrung_id: "118",
      ausfuehrung_name: "Wagon",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "6",
      ausfuehrung_modell_id: "57",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1245",
      ausfuehrung_name: "Wagon",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "6",
      ausfuehrung_modell_id: "57",
      ausfuehrung_aktiv: "1",
    },
  ],
  58: [
    {
      ausfuehrung_id: "119",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rail",
      ausfuehrung_hersteller_id: "6",
      ausfuehrung_modell_id: "58",
      ausfuehrung_aktiv: "1",
    },
  ],
  59: [
    {
      ausfuehrung_id: "120",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "6",
      ausfuehrung_modell_id: "59",
      ausfuehrung_aktiv: "1",
    },
  ],
  60: [
    {
      ausfuehrung_id: "121",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rail",
      ausfuehrung_hersteller_id: "6",
      ausfuehrung_modell_id: "60",
      ausfuehrung_aktiv: "1",
    },
  ],
  61: [
    {
      ausfuehrung_id: "122",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "61",
      ausfuehrung_aktiv: "1",
    },
  ],
  62: [
    {
      ausfuehrung_id: "123",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "62",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "124",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "62",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1246",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "62",
      ausfuehrung_aktiv: "1",
    },
  ],
  63: [
    {
      ausfuehrung_id: "125",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "63",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "126",
      ausfuehrung_name: "5,9 l",
      ausfuehrung_name_en: "5,9 l",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "63",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1247",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "63",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1248",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "63",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1249",
      ausfuehrung_name: "5,9 l",
      ausfuehrung_name_en: "5,9 l",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "63",
      ausfuehrung_aktiv: "1",
    },
  ],
  64: [
    {
      ausfuehrung_id: "127",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "64",
      ausfuehrung_aktiv: "1",
    },
  ],
  65: [
    {
      ausfuehrung_id: "128",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "65",
      ausfuehrung_aktiv: "1",
    },
  ],
  66: [
    {
      ausfuehrung_id: "129",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "66",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "130",
      ausfuehrung_name: "GT Turbo",
      ausfuehrung_name_en: "GT Turbo",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "66",
      ausfuehrung_aktiv: "1",
    },
  ],
  67: [
    {
      ausfuehrung_id: "131",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "67",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1250",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "67",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1251",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "67",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1252",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "67",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1253",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "7",
      ausfuehrung_modell_id: "67",
      ausfuehrung_aktiv: "1",
    },
  ],
  68: [
    {
      ausfuehrung_id: "132",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "68",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "133",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "68",
      ausfuehrung_aktiv: "1",
    },
  ],
  69: [
    {
      ausfuehrung_id: "134",
      ausfuehrung_name: "o. Reling ",
      ausfuehrung_name_en: "without roof rails",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "69",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "135",
      ausfuehrung_name: "Multispace, mit Reling",
      ausfuehrung_name_en: "Multispace, mit Reling",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "69",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "136",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "69",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "137",
      ausfuehrung_name: "XTR, mit Reling",
      ausfuehrung_name_en: "XTR, with rool rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "69",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1254",
      ausfuehrung_name: "o. Reling",
      ausfuehrung_name_en: "wo. roof rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "69",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1255",
      ausfuehrung_name: "Multispace",
      ausfuehrung_name_en: "Multispace",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "69",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1683",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "69",
      ausfuehrung_aktiv: "1",
    },
  ],
  70: [
    {
      ausfuehrung_id: "138",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "70",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "139",
      ausfuehrung_name: "Break",
      ausfuehrung_name_en: "Break",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "70",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "140",
      ausfuehrung_name: "Break mit Reling",
      ausfuehrung_name_en: "Break with rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "70",
      ausfuehrung_aktiv: "1",
    },
  ],
  71: [
    {
      ausfuehrung_id: "141",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "71",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1256",
      ausfuehrung_name: "5-türig (nicht für Stoffschiebedach)",
      ausfuehrung_name_en: "5 doors (not for fabric sliding roof)",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "71",
      ausfuehrung_aktiv: "1",
    },
  ],
  72: [
    {
      ausfuehrung_id: "142",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "72",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "143",
      ausfuehrung_name: "Aircross mit Reling",
      ausfuehrung_name_en: "Aircross with rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "72",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "144",
      ausfuehrung_name: "Picasso mit Reling",
      ausfuehrung_name_en: "Picasso with rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "72",
      ausfuehrung_aktiv: "1",
    },
  ],
  73: [
    {
      ausfuehrung_id: "145",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "73",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "146",
      ausfuehrung_name: "Aircross, mit Reling",
      ausfuehrung_name_en: "Aircross, with roof rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "73",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "147",
      ausfuehrung_name: "Aircross o. Reling",
      ausfuehrung_name_en: "Aircross wo. rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "73",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "148",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "73",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "149",
      ausfuehrung_name: "Grand Picasso, mit Reling",
      ausfuehrung_name_en: "Grand Picasso, with roof rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "73",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "150",
      ausfuehrung_name: "Picasso mit Reling",
      ausfuehrung_name_en: "Picasso with rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "73",
      ausfuehrung_aktiv: "1",
    },
  ],
  74: [
    {
      ausfuehrung_id: "151",
      ausfuehrung_name: "Aircross mit Reling",
      ausfuehrung_name_en: "Aircross with rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "74",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "152",
      ausfuehrung_name: "Crosstourer mit Reling",
      ausfuehrung_name_en: "Crosstourer, with roof rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "74",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "153",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "74",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "154",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "74",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1257",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "74",
      ausfuehrung_aktiv: "1",
    },
  ],
  75: [
    {
      ausfuehrung_id: "155",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "75",
      ausfuehrung_aktiv: "1",
    },
  ],
  76: [
    {
      ausfuehrung_id: "156",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "76",
      ausfuehrung_aktiv: "1",
    },
  ],
  77: [
    {
      ausfuehrung_id: "157",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "77",
      ausfuehrung_aktiv: "1",
    },
  ],
  78: [
    {
      ausfuehrung_id: "158",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "78",
      ausfuehrung_aktiv: "1",
    },
  ],
  79: [
    {
      ausfuehrung_id: "159",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "79",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "160",
      ausfuehrung_name: "C-Schiene",
      ausfuehrung_name_en: "C-with rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "79",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1258",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "79",
      ausfuehrung_aktiv: "1",
    },
  ],
  80: [
    {
      ausfuehrung_id: "161",
      ausfuehrung_name: "H1 und H2",
      ausfuehrung_name_en: "H1 and H2",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "80",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "162",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "80",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "163",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "80",
      ausfuehrung_aktiv: "1",
    },
  ],
  81: [
    {
      ausfuehrung_id: "164",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "81",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1259",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "81",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1260",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "81",
      ausfuehrung_aktiv: "1",
    },
  ],
  82: [
    {
      ausfuehrung_id: "165",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "82",
      ausfuehrung_aktiv: "1",
    },
  ],
  83: [
    {
      ausfuehrung_id: "166",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "83",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "167",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "83",
      ausfuehrung_aktiv: "1",
    },
  ],
  84: [
    {
      ausfuehrung_id: "168",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "84",
      ausfuehrung_aktiv: "1",
    },
  ],
  85: [
    {
      ausfuehrung_id: "169",
      ausfuehrung_name: "Break",
      ausfuehrung_name_en: "Break",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "85",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1261",
      ausfuehrung_name: "Break",
      ausfuehrung_name_en: "Break",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "85",
      ausfuehrung_aktiv: "1",
    },
  ],
  86: [
    {
      ausfuehrung_id: "170",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "86",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "171",
      ausfuehrung_name: "Break",
      ausfuehrung_name_en: "Break",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "86",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "172",
      ausfuehrung_name: "Break mit Reling",
      ausfuehrung_name_en: "Break with rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "86",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "173",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "86",
      ausfuehrung_aktiv: "1",
    },
  ],
  87: [
    {
      ausfuehrung_id: "174",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "87",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "175",
      ausfuehrung_name: "Break",
      ausfuehrung_name_en: "Break",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "87",
      ausfuehrung_aktiv: "1",
    },
  ],
  88: [
    {
      ausfuehrung_id: "176",
      ausfuehrung_name: "Break",
      ausfuehrung_name_en: "Break",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "88",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "177",
      ausfuehrung_name: "Break mit Reling",
      ausfuehrung_name_en: "Break with rail",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "88",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "178",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "88",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "179",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "8",
      ausfuehrung_modell_id: "88",
      ausfuehrung_aktiv: "1",
    },
  ],
  89: [
    {
      ausfuehrung_id: "180",
      ausfuehrung_name: "ohne Reling",
      ausfuehrung_name_en: "wo. roof rail",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "89",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "181",
      ausfuehrung_name: "Express",
      ausfuehrung_name_en: "Express",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "89",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "182",
      ausfuehrung_name: "Stepway, o. Reling",
      ausfuehrung_name_en: "Stepway, wo. roof rail",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "89",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "183",
      ausfuehrung_name: "Stepway mit Reling",
      ausfuehrung_name_en: "Stepway with rail",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "89",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1607",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rail",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "89",
      ausfuehrung_aktiv: "1",
    },
  ],
  90: [
    {
      ausfuehrung_id: "184",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "90",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1262",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "90",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1263",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "90",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1264",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "90",
      ausfuehrung_aktiv: "1",
    },
  ],
  91: [
    {
      ausfuehrung_id: "185",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rail",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "91",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "186",
      ausfuehrung_name: "Stepway, mit Reling",
      ausfuehrung_name_en: "Stepway, with roof rail",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "91",
      ausfuehrung_aktiv: "1",
    },
  ],
  92: [
    {
      ausfuehrung_id: "187",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "92",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "188",
      ausfuehrung_name: "Express",
      ausfuehrung_name_en: "Express",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "92",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "189",
      ausfuehrung_name: "Kombi, mit Reling MCV",
      ausfuehrung_name_en: "Station Wagon, with roof rail MCV",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "92",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "190",
      ausfuehrung_name: "Kombi, o. Reling",
      ausfuehrung_name_en: "Station Wagon, wo. roof rail",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "92",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "191",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "92",
      ausfuehrung_aktiv: "1",
    },
  ],
  93: [
    {
      ausfuehrung_id: "192",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "93",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "193",
      ausfuehrung_name: "Stepway, mit Reling",
      ausfuehrung_name_en: "Stepway, with roof rail",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "93",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1265",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "93",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1708",
      ausfuehrung_name: "Dacia Sandero normales Dach",
      ausfuehrung_name_en: "Dacia Sandero regular roof",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "93",
      ausfuehrung_aktiv: "1",
    },
  ],
  94: [
    {
      ausfuehrung_id: "194",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "10",
      ausfuehrung_modell_id: "94",
      ausfuehrung_aktiv: "1",
    },
  ],
  95: [
    {
      ausfuehrung_id: "195",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "10",
      ausfuehrung_modell_id: "95",
      ausfuehrung_aktiv: "1",
    },
  ],
  96: [
    {
      ausfuehrung_id: "196",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "10",
      ausfuehrung_modell_id: "96",
      ausfuehrung_aktiv: "1",
    },
  ],
  97: [
    {
      ausfuehrung_id: "197",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "10",
      ausfuehrung_modell_id: "97",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "198",
      ausfuehrung_name: "4-türig",
      ausfuehrung_name_en: "4 doors",
      ausfuehrung_hersteller_id: "10",
      ausfuehrung_modell_id: "97",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "199",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "10",
      ausfuehrung_modell_id: "97",
      ausfuehrung_aktiv: "1",
    },
  ],
  98: [
    {
      ausfuehrung_id: "200",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "10",
      ausfuehrung_modell_id: "98",
      ausfuehrung_aktiv: "1",
    },
  ],
  99: [
    {
      ausfuehrung_id: "201",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "10",
      ausfuehrung_modell_id: "99",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "202",
      ausfuehrung_name: "CD",
      ausfuehrung_name_en: "CD",
      ausfuehrung_hersteller_id: "10",
      ausfuehrung_modell_id: "99",
      ausfuehrung_aktiv: "1",
    },
  ],
  100: [
    {
      ausfuehrung_id: "203",
      ausfuehrung_name: "4/5-türig",
      ausfuehrung_name_en: "4/5 doors",
      ausfuehrung_hersteller_id: "10",
      ausfuehrung_modell_id: "100",
      ausfuehrung_aktiv: "1",
    },
  ],
  101: [
    {
      ausfuehrung_id: "204",
      ausfuehrung_name: "Wagon",
      ausfuehrung_name_en: "Wagon",
      ausfuehrung_hersteller_id: "10",
      ausfuehrung_modell_id: "101",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "205",
      ausfuehrung_name: "4-türig",
      ausfuehrung_name_en: "4 doors",
      ausfuehrung_hersteller_id: "10",
      ausfuehrung_modell_id: "101",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "206",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "10",
      ausfuehrung_modell_id: "101",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1266",
      ausfuehrung_name: "4-türig",
      ausfuehrung_name_en: "4 doors",
      ausfuehrung_hersteller_id: "10",
      ausfuehrung_modell_id: "101",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1267",
      ausfuehrung_name: "4-türig",
      ausfuehrung_name_en: "4 doors",
      ausfuehrung_hersteller_id: "10",
      ausfuehrung_modell_id: "101",
      ausfuehrung_aktiv: "1",
    },
  ],
  102: [
    {
      ausfuehrung_id: "207",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "11",
      ausfuehrung_modell_id: "102",
      ausfuehrung_aktiv: "1",
    },
  ],
  103: [
    {
      ausfuehrung_id: "208",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "11",
      ausfuehrung_modell_id: "103",
      ausfuehrung_aktiv: "1",
    },
  ],
  104: [
    {
      ausfuehrung_id: "209",
      ausfuehrung_name: "3-türig o. Faltdach",
      ausfuehrung_name_en: "3 doors wo. folding roof",
      ausfuehrung_hersteller_id: "11",
      ausfuehrung_modell_id: "104",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "210",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "11",
      ausfuehrung_modell_id: "104",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1268",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "11",
      ausfuehrung_modell_id: "104",
      ausfuehrung_aktiv: "1",
    },
  ],
  105: [
    {
      ausfuehrung_id: "211",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "11",
      ausfuehrung_modell_id: "105",
      ausfuehrung_aktiv: "1",
    },
  ],
  106: [
    {
      ausfuehrung_id: "212",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "11",
      ausfuehrung_modell_id: "106",
      ausfuehrung_aktiv: "1",
    },
  ],
  107: [
    {
      ausfuehrung_id: "213",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rail",
      ausfuehrung_hersteller_id: "11",
      ausfuehrung_modell_id: "107",
      ausfuehrung_aktiv: "1",
    },
  ],
  108: [
    {
      ausfuehrung_id: "214",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "11",
      ausfuehrung_modell_id: "108",
      ausfuehrung_aktiv: "1",
    },
  ],
  109: [
    {
      ausfuehrung_id: "215",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "12",
      ausfuehrung_modell_id: "109",
      ausfuehrung_aktiv: "1",
    },
  ],
  110: [
    {
      ausfuehrung_id: "216",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "110",
      ausfuehrung_aktiv: "1",
    },
  ],
  111: [
    {
      ausfuehrung_id: "217",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "111",
      ausfuehrung_aktiv: "1",
    },
  ],
  112: [
    {
      ausfuehrung_id: "218",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "112",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "219",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "112",
      ausfuehrung_aktiv: "1",
    },
  ],
  113: [
    {
      ausfuehrung_id: "220",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "113",
      ausfuehrung_aktiv: "1",
    },
  ],
  114: [
    {
      ausfuehrung_id: "221",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "114",
      ausfuehrung_aktiv: "1",
    },
  ],
  115: [
    {
      ausfuehrung_id: "222",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "115",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1156",
      ausfuehrung_name: "Normal-/Mittel-/Hochdach",
      ausfuehrung_name_en: "normal/medium/high roof",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "115",
      ausfuehrung_aktiv: "1",
    },
  ],
  116: [
    {
      ausfuehrung_id: "223",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "116",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "224",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "116",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "225",
      ausfuehrung_name: "o. Reling ",
      ausfuehrung_name_en: "wo. rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "116",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1762",
      ausfuehrung_name: "ohne Reling",
      ausfuehrung_name_en: "without roof rails",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "116",
      ausfuehrung_aktiv: "1",
    },
  ],
  117: [
    {
      ausfuehrung_id: "226",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "117",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "227",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "117",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "228",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "117",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1269",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "117",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1270",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "117",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1271",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "117",
      ausfuehrung_aktiv: "1",
    },
  ],
  118: [
    {
      ausfuehrung_id: "229",
      ausfuehrung_name: "o. Reling",
      ausfuehrung_name_en: "wo. roof rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "118",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "230",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "118",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "231",
      ausfuehrung_name: "Dachluke",
      ausfuehrung_name_en: "Skylight",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "118",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1272",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "118",
      ausfuehrung_aktiv: "1",
    },
  ],
  119: [
    {
      ausfuehrung_id: "232",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "119",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1273",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "119",
      ausfuehrung_aktiv: "1",
    },
  ],
  120: [
    {
      ausfuehrung_id: "233",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "120",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "234",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "120",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1701",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "120",
      ausfuehrung_aktiv: "1",
    },
  ],
  121: [
    {
      ausfuehrung_id: "235",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "121",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1274",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "121",
      ausfuehrung_aktiv: "1",
    },
  ],
  122: [
    {
      ausfuehrung_id: "236",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "122",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "237",
      ausfuehrung_name: "Mitteldach",
      ausfuehrung_name_en: "medium roof",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "122",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "238",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "122",
      ausfuehrung_aktiv: "1",
    },
  ],
  123: [
    {
      ausfuehrung_id: "239",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "123",
      ausfuehrung_aktiv: "1",
    },
  ],
  124: [
    {
      ausfuehrung_id: "240",
      ausfuehrung_name: "Weekend",
      ausfuehrung_name_en: "Weekend",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "124",
      ausfuehrung_aktiv: "1",
    },
  ],
  125: [
    {
      ausfuehrung_id: "241",
      ausfuehrung_name: "4x4 mit Reling",
      ausfuehrung_name_en: "4x4 with rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "125",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "242",
      ausfuehrung_name: "City Cross, Cross",
      ausfuehrung_name_en: "City Cross, Cross",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "125",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "243",
      ausfuehrung_name: "Cross, mit Reling",
      ausfuehrung_name_en: "Cross, with roof rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "125",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "244",
      ausfuehrung_name: "Cross 4x4, mit Reling",
      ausfuehrung_name_en: "Cross 4x4, with roof rails",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "125",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "245",
      ausfuehrung_name: "o. Reling",
      ausfuehrung_name_en: "wo. rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "125",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "246",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "125",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "247",
      ausfuehrung_name: "o. Faltdach",
      ausfuehrung_name_en: "wo. folding roof",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "125",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1275",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "125",
      ausfuehrung_aktiv: "1",
    },
  ],
  126: [
    {
      ausfuehrung_id: "248",
      ausfuehrung_name: "EVO 3-türig",
      ausfuehrung_name_en: "EVO 3 doors",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "126",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "249",
      ausfuehrung_name: "EVO 5-türig",
      ausfuehrung_name_en: "EVO 5 doors",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "126",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "250",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "126",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "251",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "126",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1276",
      ausfuehrung_name: "EVO 3-türig",
      ausfuehrung_name_en: "EVO 3 doors",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "126",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1277",
      ausfuehrung_name: "EVO 5-türig",
      ausfuehrung_name_en: "EVO 5 doors",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "126",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1278",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "126",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1279",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "126",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1700",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "126",
      ausfuehrung_aktiv: "1",
    },
  ],
  127: [
    {
      ausfuehrung_id: "252",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "127",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1280",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "127",
      ausfuehrung_aktiv: "1",
    },
  ],
  128: [
    {
      ausfuehrung_id: "253",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "128",
      ausfuehrung_aktiv: "1",
    },
  ],
  129: [
    {
      ausfuehrung_id: "254",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "129",
      ausfuehrung_aktiv: "1",
    },
  ],
  130: [
    {
      ausfuehrung_id: "255",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "130",
      ausfuehrung_aktiv: "1",
    },
  ],
  131: [
    {
      ausfuehrung_id: "256",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "131",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "257",
      ausfuehrung_name: "Multi Wagon",
      ausfuehrung_name_en: "Multi Wagon",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "131",
      ausfuehrung_aktiv: "1",
    },
  ],
  132: [
    {
      ausfuehrung_id: "258",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "132",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1281",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "132",
      ausfuehrung_aktiv: "1",
    },
  ],
  133: [
    {
      ausfuehrung_id: "259",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "133",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "260",
      ausfuehrung_name: "Station mit Reling",
      ausfuehrung_name_en: "Station with rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "133",
      ausfuehrung_aktiv: "1",
    },
  ],
  134: [
    {
      ausfuehrung_id: "261",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "134",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "262",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "134",
      ausfuehrung_aktiv: "1",
    },
  ],
  135: [
    {
      ausfuehrung_id: "263",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "135",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1282",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "135",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1731",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "135",
      ausfuehrung_aktiv: "1",
    },
  ],
  136: [
    {
      ausfuehrung_id: "264",
      ausfuehrung_name: "Hobby mit Reling",
      ausfuehrung_name_en: "Hobby with rail",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "136",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "265",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "136",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "266",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "13",
      ausfuehrung_modell_id: "136",
      ausfuehrung_aktiv: "1",
    },
  ],
  137: [
    {
      ausfuehrung_id: "267",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "137",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1283",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "137",
      ausfuehrung_aktiv: "1",
    },
  ],
  138: [
    {
      ausfuehrung_id: "268",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "138",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1612",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "138",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1614",
      ausfuehrung_name: "ohne Dachhimmel",
      ausfuehrung_name_en: "without roofliner",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "138",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1733",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "138",
      ausfuehrung_aktiv: "1",
    },
  ],
  139: [
    {
      ausfuehrung_id: "269",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "139",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1160",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "139",
      ausfuehrung_aktiv: "1",
    },
  ],
  140: [
    {
      ausfuehrung_id: "270",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "140",
      ausfuehrung_aktiv: "1",
    },
  ],
  141: [
    {
      ausfuehrung_id: "271",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "141",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "272",
      ausfuehrung_name: "Express",
      ausfuehrung_name_en: "Express",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "141",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "273",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "141",
      ausfuehrung_aktiv: "1",
    },
  ],
  142: [
    {
      ausfuehrung_id: "274",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "142",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "275",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "142",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1284",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "142",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1285",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "142",
      ausfuehrung_aktiv: "1",
    },
  ],
  143: [
    {
      ausfuehrung_id: "276",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "143",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1286",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "143",
      ausfuehrung_aktiv: "1",
    },
  ],
  144: [
    {
      ausfuehrung_id: "277",
      ausfuehrung_name: "Active, 5-türig, mit Reling",
      ausfuehrung_name_en: "Active, 5 door, with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "144",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "278",
      ausfuehrung_name: "Courier",
      ausfuehrung_name_en: "Courier",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "144",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "279",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "144",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "280",
      ausfuehrung_name: "Dachleiste",
      ausfuehrung_name_en: "Roofwith rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "144",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1287",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "144",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1288",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "144",
      ausfuehrung_aktiv: "1",
    },
  ],
  145: [
    {
      ausfuehrung_id: "281",
      ausfuehrung_name: "4-türig, Stufenheck",
      ausfuehrung_name_en: "4 doors, notchback",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "145",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "282",
      ausfuehrung_name: "Active Limousine, mit Reling",
      ausfuehrung_name_en: "Active Limousine, with roof rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "145",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "287",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "145",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "288",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "145",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1297",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "145",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1298",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "145",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1299",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "145",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1608",
      ausfuehrung_name: "Active Turnier, mit Reling",
      ausfuehrung_name_en: "Active Turnier, with roof rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "145",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1609",
      ausfuehrung_name: "mit C-Schiene",
      ausfuehrung_name_en: "with C-rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "145",
      ausfuehrung_aktiv: "1",
    },
  ],
  146: [
    {
      ausfuehrung_id: "283",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "146",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "284",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "146",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "285",
      ausfuehrung_name: "mit C-Schiene",
      ausfuehrung_name_en: "with C-with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "146",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "286",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "146",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1289",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "146",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1290",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "146",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1291",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "146",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1292",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "146",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1293",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "146",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1294",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "146",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1295",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "146",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1296",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "146",
      ausfuehrung_aktiv: "1",
    },
  ],
  147: [
    {
      ausfuehrung_id: "289",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "147",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "290",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "147",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1300",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "147",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1301",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "147",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1302",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "147",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1303",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "147",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1304",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "147",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1305",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "147",
      ausfuehrung_aktiv: "1",
    },
  ],
  148: [
    {
      ausfuehrung_id: "291",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "148",
      ausfuehrung_aktiv: "1",
    },
  ],
  149: [
    {
      ausfuehrung_id: "292",
      ausfuehrung_name: "Connect",
      ausfuehrung_name_en: "Connect",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "149",
      ausfuehrung_aktiv: "1",
    },
  ],
  150: [
    {
      ausfuehrung_id: "293",
      ausfuehrung_name: "Connect",
      ausfuehrung_name_en: "Connect",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "150",
      ausfuehrung_aktiv: "1",
    },
  ],
  151: [
    {
      ausfuehrung_id: "294",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "151",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "295",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "151",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1306",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "151",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1695",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "151",
      ausfuehrung_aktiv: "1",
    },
  ],
  152: [
    {
      ausfuehrung_id: "296",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "152",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "297",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "152",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "298",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "152",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1307",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "152",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1308",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "152",
      ausfuehrung_aktiv: "1",
    },
  ],
  153: [
    {
      ausfuehrung_id: "299",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "153",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "300",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "153",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "301",
      ausfuehrung_name: "Limousine 4/5-türig",
      ausfuehrung_name_en: "Limousine 4/5 doors",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "153",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1309",
      ausfuehrung_name: "Limousine 4/5-türig",
      ausfuehrung_name_en: "Limousine 4/5 doors",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "153",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1310",
      ausfuehrung_name: "Limousine 4/5-türig",
      ausfuehrung_name_en: "Limousine 4/5 doors",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "153",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1610",
      ausfuehrung_name: "Limousine, 4 und 5 türig",
      ausfuehrung_name_en: "Limousine, 4 and 5 doors",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "153",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1681",
      ausfuehrung_name: "Turnier Hybrid, mit Reling",
      ausfuehrung_name_en: "Turnier Hybrid, with roof rails",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "153",
      ausfuehrung_aktiv: "1",
    },
  ],
  154: [
    {
      ausfuehrung_id: "302",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "154",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "303",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "154",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "304",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "154",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1311",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "154",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1312",
      ausfuehrung_name: "mit aufliegender mit Reling",
      ausfuehrung_name_en: "with resting with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "154",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1313",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "154",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1314",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "154",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1315",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "154",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1316",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "154",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1317",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "154",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1611",
      ausfuehrung_name: "Hybrid, mit Reling",
      ausfuehrung_name_en: "Hybrid, with roof rails",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "154",
      ausfuehrung_aktiv: "1",
    },
  ],
  155: [
    {
      ausfuehrung_id: "305",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "155",
      ausfuehrung_aktiv: "1",
    },
  ],
  156: [
    {
      ausfuehrung_id: "306",
      ausfuehrung_name: "Doppelkabine (Wildtrak) mit Reling",
      ausfuehrung_name_en: "double cabin (Wildtrak) with roof rails",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "156",
      ausfuehrung_aktiv: "1",
    },
  ],
  157: [
    {
      ausfuehrung_id: "307",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "157",
      ausfuehrung_aktiv: "1",
    },
  ],
  158: [
    {
      ausfuehrung_id: "308",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "158",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1318",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "158",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1319",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "158",
      ausfuehrung_aktiv: "1",
    },
  ],
  159: [
    {
      ausfuehrung_id: "309",
      ausfuehrung_name: "Fließheck",
      ausfuehrung_name_en: "hatchback",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "159",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "310",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "159",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "311",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "159",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "312",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "159",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "313",
      ausfuehrung_name: "Stufenheck",
      ausfuehrung_name_en: "notchback",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "159",
      ausfuehrung_aktiv: "1",
    },
  ],
  160: [
    {
      ausfuehrung_id: "314",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "160",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "315",
      ausfuehrung_name: "o. Reling",
      ausfuehrung_name_en: "wo. rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "160",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "316",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "160",
      ausfuehrung_aktiv: "1",
    },
  ],
  161: [
    {
      ausfuehrung_id: "317",
      ausfuehrung_name: "Connect",
      ausfuehrung_name_en: "Connect",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "161",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "318",
      ausfuehrung_name: "Courier, mit Reling",
      ausfuehrung_name_en: "Courier, with roof rails",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "161",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "319",
      ausfuehrung_name: "Custom",
      ausfuehrung_name_en: "Custom",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "161",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "325",
      ausfuehrung_name: "Connect mit Reling",
      ausfuehrung_name_en: "Connect with rail",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "161",
      ausfuehrung_aktiv: "1",
    },
  ],
  162: [
    {
      ausfuehrung_id: "320",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "162",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "321",
      ausfuehrung_name: "Connect",
      ausfuehrung_name_en: "Connect",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "162",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "322",
      ausfuehrung_name: "Custom, Normaldach",
      ausfuehrung_name_en: "Custom, normal roof",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "162",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "323",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "162",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "324",
      ausfuehrung_name: "Hochdach mittel",
      ausfuehrung_name_en: "high roof medium",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "162",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1152",
      ausfuehrung_name: "L2, L3, L4/H2, H3",
      ausfuehrung_name_en: "L2, L3, L4/H2, H3",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "162",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1161",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "162",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1178",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "162",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1320",
      ausfuehrung_name: "Hochdach mittel",
      ausfuehrung_name_en: "high roof medium",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "162",
      ausfuehrung_aktiv: "1",
    },
  ],
  163: [
    {
      ausfuehrung_id: "326",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "163",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "327",
      ausfuehrung_name: "Aerodeck mit Reling",
      ausfuehrung_name_en: "Aerodeck with rail",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "163",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "328",
      ausfuehrung_name: "Tourer, mit Reling",
      ausfuehrung_name_en: "Tourer, with roof rails",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "163",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "329",
      ausfuehrung_name: "nicht Aerodeck",
      ausfuehrung_name_en: "not Aerodeck",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "163",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1321",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "163",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1322",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "163",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1323",
      ausfuehrung_name: "nicht Aerodeck",
      ausfuehrung_name_en: "not Aerodeck",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "163",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1324",
      ausfuehrung_name: "nicht Aerodeck",
      ausfuehrung_name_en: "not Aerodeck",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "163",
      ausfuehrung_aktiv: "1",
    },
  ],
  164: [
    {
      ausfuehrung_id: "330",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "164",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "331",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "164",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "332",
      ausfuehrung_name: "Aerodeck, mit Reling",
      ausfuehrung_name_en: "Aerodeck, with roof rails",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "164",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "333",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "164",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "334",
      ausfuehrung_name: "4-türig",
      ausfuehrung_name_en: "4 doors",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "164",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1325",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "164",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1326",
      ausfuehrung_name: "4-türig",
      ausfuehrung_name_en: "4 doors",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "164",
      ausfuehrung_aktiv: "1",
    },
  ],
  165: [
    {
      ausfuehrung_id: "335",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "165",
      ausfuehrung_aktiv: "1",
    },
  ],
  166: [
    {
      ausfuehrung_id: "336",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "166",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1327",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "166",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1328",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "166",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1329",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "166",
      ausfuehrung_aktiv: "1",
    },
  ],
  167: [
    {
      ausfuehrung_id: "337",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "167",
      ausfuehrung_aktiv: "1",
    },
  ],
  168: [
    {
      ausfuehrung_id: "338",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "168",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1694",
      ausfuehrung_name: "Crosstar",
      ausfuehrung_name_en: "Crosstar",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "168",
      ausfuehrung_aktiv: "1",
    },
  ],
  169: [
    {
      ausfuehrung_id: "339",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "15",
      ausfuehrung_modell_id: "169",
      ausfuehrung_aktiv: "1",
    },
  ],
  170: [
    {
      ausfuehrung_id: "340",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "170",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "341",
      ausfuehrung_name: "4/5-türig",
      ausfuehrung_name_en: "4/5 doors",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "170",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "342",
      ausfuehrung_name: "4-türig",
      ausfuehrung_name_en: "4 doors",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "170",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1330",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "170",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1331",
      ausfuehrung_name: "4/5-türig",
      ausfuehrung_name_en: "4/5 doors",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "170",
      ausfuehrung_aktiv: "1",
    },
  ],
  171: [
    {
      ausfuehrung_id: "343",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "171",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "344",
      ausfuehrung_name: "Prime",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "171",
      ausfuehrung_aktiv: "1",
    },
  ],
  172: [
    {
      ausfuehrung_id: "345",
      ausfuehrung_name: "4/5-türig",
      ausfuehrung_name_en: "4/5 doors",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "172",
      ausfuehrung_aktiv: "1",
    },
  ],
  173: [
    {
      ausfuehrung_id: "346",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "173",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1332",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "173",
      ausfuehrung_aktiv: "1",
    },
  ],
  174: [
    {
      ausfuehrung_id: "347",
      ausfuehrung_name: "Cross, mit Reling",
      ausfuehrung_name_en: "Cross, with roof rails",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "174",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "348",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "174",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "349",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "174",
      ausfuehrung_aktiv: "1",
    },
  ],
  175: [
    {
      ausfuehrung_id: "350",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "175",
      ausfuehrung_aktiv: "1",
    },
  ],
  176: [
    {
      ausfuehrung_id: "351",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "176",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1168",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "176",
      ausfuehrung_aktiv: "1",
    },
  ],
  177: [
    {
      ausfuehrung_id: "352",
      ausfuehrung_name: "Kasten (LBW) o. Reling",
      ausfuehrung_name_en: "Van (LBW) wo. rail",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "177",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "353",
      ausfuehrung_name: "Starex",
      ausfuehrung_name_en: "Starex",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "177",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "354",
      ausfuehrung_name: "Starex (SBW) o. Reling",
      ausfuehrung_name_en: "Starex (SBW) wo. rail",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "177",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1333",
      ausfuehrung_name: "Starex",
      ausfuehrung_name_en: "Starex",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "177",
      ausfuehrung_aktiv: "1",
    },
  ],
  178: [
    {
      ausfuehrung_id: "355",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "178",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1334",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "178",
      ausfuehrung_aktiv: "1",
    },
  ],
  179: [
    {
      ausfuehrung_id: "356",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "179",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "357",
      ausfuehrung_name: "Active",
      ausfuehrung_name_en: "Active",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "179",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1335",
      ausfuehrung_name: "(nicht für Panoramadach)",
      ausfuehrung_name_en: "(not for panoramic roof)",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "179",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1336",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "179",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1716",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "179",
      ausfuehrung_aktiv: "1",
    },
  ],
  180: [
    {
      ausfuehrung_id: "358",
      ausfuehrung_name: "CW Kombi, mit Reling",
      ausfuehrung_name_en: "CW Tourer, with roof rails",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "180",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "359",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "180",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "360",
      ausfuehrung_name: "Limousine 5-türig",
      ausfuehrung_name_en: "Limousine 5 doors",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "180",
      ausfuehrung_aktiv: "1",
    },
  ],
  181: [
    {
      ausfuehrung_id: "361",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "181",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "362",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "181",
      ausfuehrung_aktiv: "1",
    },
  ],
  182: [
    {
      ausfuehrung_id: "363",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "182",
      ausfuehrung_aktiv: "1",
    },
  ],
  183: [
    {
      ausfuehrung_id: "364",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "183",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "367",
      ausfuehrung_name: "Station",
      ausfuehrung_name_en: "Station",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "183",
      ausfuehrung_aktiv: "1",
    },
  ],
  184: [
    {
      ausfuehrung_id: "365",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "184",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "366",
      ausfuehrung_name: "Station mit Reling",
      ausfuehrung_name_en: "Station with rail",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "184",
      ausfuehrung_aktiv: "1",
    },
  ],
  185: [
    {
      ausfuehrung_id: "368",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "185",
      ausfuehrung_aktiv: "1",
    },
  ],
  186: [
    {
      ausfuehrung_id: "369",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "186",
      ausfuehrung_aktiv: "1",
    },
  ],
  187: [
    {
      ausfuehrung_id: "370",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "187",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1337",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "187",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1338",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "187",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1339",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "187",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1340",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "187",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1341",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "187",
      ausfuehrung_aktiv: "1",
    },
  ],
  188: [
    {
      ausfuehrung_id: "371",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "188",
      ausfuehrung_aktiv: "1",
    },
  ],
  189: [
    {
      ausfuehrung_id: "372",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "189",
      ausfuehrung_aktiv: "1",
    },
  ],
  190: [
    {
      ausfuehrung_id: "373",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "190",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1342",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "190",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1343",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "190",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1344",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "190",
      ausfuehrung_aktiv: "1",
    },
  ],
  191: [
    {
      ausfuehrung_id: "374",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "191",
      ausfuehrung_aktiv: "1",
    },
  ],
  192: [
    {
      ausfuehrung_id: "375",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "192",
      ausfuehrung_aktiv: "1",
    },
  ],
  193: [
    {
      ausfuehrung_id: "376",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "193",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1345",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "193",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1346",
      ausfuehrung_name: "mit Reling (nicht für Panoramadach)",
      ausfuehrung_name_en: "with roof rails (not for panoramic roof)",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "193",
      ausfuehrung_aktiv: "1",
    },
  ],
  194: [
    {
      ausfuehrung_id: "377",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "194",
      ausfuehrung_aktiv: "1",
    },
  ],
  195: [
    {
      ausfuehrung_id: "378",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "17",
      ausfuehrung_modell_id: "195",
      ausfuehrung_aktiv: "1",
    },
  ],
  196: [
    {
      ausfuehrung_id: "379",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "17",
      ausfuehrung_modell_id: "196",
      ausfuehrung_aktiv: "1",
    },
  ],
  197: [
    {
      ausfuehrung_id: "380",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "17",
      ausfuehrung_modell_id: "197",
      ausfuehrung_aktiv: "1",
    },
  ],
  198: [
    {
      ausfuehrung_id: "381",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "18",
      ausfuehrung_modell_id: "198",
      ausfuehrung_aktiv: "1",
    },
  ],
  199: [
    {
      ausfuehrung_id: "382",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "18",
      ausfuehrung_modell_id: "199",
      ausfuehrung_aktiv: "1",
    },
  ],
  200: [
    {
      ausfuehrung_id: "383",
      ausfuehrung_name: "Estate, mit Reling",
      ausfuehrung_name_en: "Estate, with roof rails",
      ausfuehrung_hersteller_id: "18",
      ausfuehrung_modell_id: "200",
      ausfuehrung_aktiv: "1",
    },
  ],
  201: [
    {
      ausfuehrung_id: "384",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "18",
      ausfuehrung_modell_id: "201",
      ausfuehrung_aktiv: "1",
    },
  ],
  202: [
    {
      ausfuehrung_id: "385",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "19",
      ausfuehrung_modell_id: "202",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1347",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "19",
      ausfuehrung_modell_id: "202",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1621",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "19",
      ausfuehrung_modell_id: "202",
      ausfuehrung_aktiv: "1",
    },
  ],
  203: [
    {
      ausfuehrung_id: "386",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "19",
      ausfuehrung_modell_id: "203",
      ausfuehrung_aktiv: "1",
    },
  ],
  204: [
    {
      ausfuehrung_id: "387",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "204",
      ausfuehrung_aktiv: "1",
    },
  ],
  205: [
    {
      ausfuehrung_id: "388",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "205",
      ausfuehrung_aktiv: "1",
    },
  ],
  206: [
    {
      ausfuehrung_id: "389",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "206",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1348",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "206",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1349",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "206",
      ausfuehrung_aktiv: "1",
    },
  ],
  207: [
    {
      ausfuehrung_id: "390",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "207",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1350",
      ausfuehrung_name: "Limousine, 5-türig",
      ausfuehrung_name_en: "Limousine, 5 doors",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "207",
      ausfuehrung_aktiv: "1",
    },
  ],
  208: [
    {
      ausfuehrung_id: "391",
      ausfuehrung_name: "Limousine 4-türig",
      ausfuehrung_name_en: "Limousine 4 doors",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "208",
      ausfuehrung_aktiv: "1",
    },
  ],
  209: [
    {
      ausfuehrung_id: "392",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "209",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "393",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "209",
      ausfuehrung_aktiv: "1",
    },
  ],
  210: [
    {
      ausfuehrung_id: "394",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "210",
      ausfuehrung_aktiv: "1",
    },
  ],
  211: [
    {
      ausfuehrung_id: "395",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "211",
      ausfuehrung_aktiv: "1",
    },
  ],
  212: [
    {
      ausfuehrung_id: "396",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "212",
      ausfuehrung_aktiv: "1",
    },
  ],
  213: [
    {
      ausfuehrung_id: "397",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "213",
      ausfuehrung_aktiv: "1",
    },
  ],
  214: [
    {
      ausfuehrung_id: "398",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "214",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1351",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "214",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1352",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "214",
      ausfuehrung_aktiv: "1",
    },
  ],
  215: [
    {
      ausfuehrung_id: "399",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "215",
      ausfuehrung_aktiv: "1",
    },
  ],
  216: [
    {
      ausfuehrung_id: "400",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "216",
      ausfuehrung_aktiv: "1",
    },
  ],
  217: [
    {
      ausfuehrung_id: "401",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "217",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "402",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "217",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "403",
      ausfuehrung_name: "Stufenheck 4-türig",
      ausfuehrung_name_en: "notchback 4 doors",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "217",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1353",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "217",
      ausfuehrung_aktiv: "1",
    },
  ],
  218: [
    {
      ausfuehrung_id: "404",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "218",
      ausfuehrung_aktiv: "1",
    },
  ],
  219: [
    {
      ausfuehrung_id: "405",
      ausfuehrung_name: "Stufenheck",
      ausfuehrung_name_en: "notchback",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "219",
      ausfuehrung_aktiv: "1",
    },
  ],
  220: [
    {
      ausfuehrung_id: "406",
      ausfuehrung_name: "Stufenheck",
      ausfuehrung_name_en: "notchback",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "220",
      ausfuehrung_aktiv: "1",
    },
  ],
  221: [
    {
      ausfuehrung_id: "407",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "221",
      ausfuehrung_aktiv: "1",
    },
  ],
  222: [
    {
      ausfuehrung_id: "408",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "222",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "409",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "222",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1354",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "222",
      ausfuehrung_aktiv: "1",
    },
  ],
  223: [
    {
      ausfuehrung_id: "410",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "223",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "411",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "223",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1355",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "223",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1356",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "223",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1357",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "223",
      ausfuehrung_aktiv: "1",
    },
  ],
  224: [
    {
      ausfuehrung_id: "412",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "20",
      ausfuehrung_modell_id: "224",
      ausfuehrung_aktiv: "1",
    },
  ],
  225: [
    {
      ausfuehrung_id: "413",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "21",
      ausfuehrung_modell_id: "225",
      ausfuehrung_aktiv: "1",
    },
  ],
  226: [
    {
      ausfuehrung_id: "414",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "21",
      ausfuehrung_modell_id: "226",
      ausfuehrung_aktiv: "1",
    },
  ],
  227: [
    {
      ausfuehrung_id: "415",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "21",
      ausfuehrung_modell_id: "227",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1182",
      ausfuehrung_name: "Kombi mit mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "21",
      ausfuehrung_modell_id: "227",
      ausfuehrung_aktiv: "1",
    },
  ],
  228: [
    {
      ausfuehrung_id: "416",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "22",
      ausfuehrung_modell_id: "228",
      ausfuehrung_aktiv: "1",
    },
  ],
  229: [
    {
      ausfuehrung_id: "417",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "22",
      ausfuehrung_modell_id: "229",
      ausfuehrung_aktiv: "1",
    },
  ],
  230: [
    {
      ausfuehrung_id: "418",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "22",
      ausfuehrung_modell_id: "230",
      ausfuehrung_aktiv: "1",
    },
  ],
  231: [
    {
      ausfuehrung_id: "419",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "22",
      ausfuehrung_modell_id: "231",
      ausfuehrung_aktiv: "1",
    },
  ],
  232: [
    {
      ausfuehrung_id: "420",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "22",
      ausfuehrung_modell_id: "232",
      ausfuehrung_aktiv: "1",
    },
  ],
  233: [
    {
      ausfuehrung_id: "421",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "22",
      ausfuehrung_modell_id: "233",
      ausfuehrung_aktiv: "1",
    },
  ],
  234: [
    {
      ausfuehrung_id: "422",
      ausfuehrung_name: "C-Schiene",
      ausfuehrung_name_en: "C-with rail",
      ausfuehrung_hersteller_id: "22",
      ausfuehrung_modell_id: "234",
      ausfuehrung_aktiv: "1",
    },
  ],
  235: [
    {
      ausfuehrung_id: "423",
      ausfuehrung_name: "(nicht für Hochdach)",
      ausfuehrung_name_en: "(not for high roof)",
      ausfuehrung_hersteller_id: "23",
      ausfuehrung_modell_id: "235",
      ausfuehrung_aktiv: "1",
    },
  ],
  236: [
    {
      ausfuehrung_id: "424",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "23",
      ausfuehrung_modell_id: "236",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1625",
      ausfuehrung_name: "mit C-Schiene",
      ausfuehrung_name_en: "with C-rail",
      ausfuehrung_hersteller_id: "23",
      ausfuehrung_modell_id: "236",
      ausfuehrung_aktiv: "1",
    },
  ],
  237: [
    {
      ausfuehrung_id: "425",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "23",
      ausfuehrung_modell_id: "237",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1627",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "23",
      ausfuehrung_modell_id: "237",
      ausfuehrung_aktiv: "1",
    },
  ],
  238: [
    {
      ausfuehrung_id: "426",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "24",
      ausfuehrung_modell_id: "238",
      ausfuehrung_aktiv: "1",
    },
  ],
  239: [
    {
      ausfuehrung_id: "427",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "239",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "432",
      ausfuehrung_name: "3/5-türig",
      ausfuehrung_name_en: "3/5 doors",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "239",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "433",
      ausfuehrung_name: "3/5-türig",
      ausfuehrung_name_en: "3/5 doors",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "239",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1358",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "239",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1359",
      ausfuehrung_name: "3/5-türig",
      ausfuehrung_name_en: "3/5 doors",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "239",
      ausfuehrung_aktiv: "1",
    },
  ],
  240: [
    {
      ausfuehrung_id: "428",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "240",
      ausfuehrung_aktiv: "1",
    },
  ],
  241: [
    {
      ausfuehrung_id: "429",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "241",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "430",
      ausfuehrung_name: "auch Faltdach",
      ausfuehrung_name_en: "folding roof too",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "241",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "431",
      ausfuehrung_name: "3/5-türig",
      ausfuehrung_name_en: "3/5 doors",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "241",
      ausfuehrung_aktiv: "1",
    },
  ],
  244: [
    {
      ausfuehrung_id: "434",
      ausfuehrung_name: "4/5-türig",
      ausfuehrung_name_en: "4/5 doors",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "244",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "435",
      ausfuehrung_name: "4-türig",
      ausfuehrung_name_en: "4 doors",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "244",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "436",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "244",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "437",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "244",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1360",
      ausfuehrung_name: "4/5-türig",
      ausfuehrung_name_en: "4/5 doors",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "244",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1628",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "244",
      ausfuehrung_aktiv: "1",
    },
  ],
  245: [
    {
      ausfuehrung_id: "438",
      ausfuehrung_name: "Compact 3-türig",
      ausfuehrung_name_en: "Compact 3 doors",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "245",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "439",
      ausfuehrung_name: "Fließheck 5-türig",
      ausfuehrung_name_en: "hatchback 5 doors",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "245",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "440",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "245",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "441",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "245",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "442",
      ausfuehrung_name: "P",
      ausfuehrung_name_en: "P",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "245",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "443",
      ausfuehrung_name: "Stufenheck",
      ausfuehrung_name_en: "notchback",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "245",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "444",
      ausfuehrung_name: "Stufenheck 4-türig",
      ausfuehrung_name_en: "notchback 4 doors",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "245",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "445",
      ausfuehrung_name: "Schrägheck 3-türig",
      ausfuehrung_name_en: "fastback 3 doors",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "245",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "446",
      ausfuehrung_name: "Schrägheck 4-türig",
      ausfuehrung_name_en: "fastback 4 doors",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "245",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "447",
      ausfuehrung_name: "Schrägheck 5-türig",
      ausfuehrung_name_en: "fastback 5 doors",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "245",
      ausfuehrung_aktiv: "1",
    },
  ],
  246: [
    {
      ausfuehrung_id: "448",
      ausfuehrung_name: "Limousine, 4 und 5 türig",
      ausfuehrung_name_en: "Limousine, 4 and 5 doors",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "246",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "449",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "246",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "450",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "246",
      ausfuehrung_aktiv: "1",
    },
  ],
  247: [
    {
      ausfuehrung_id: "451",
      ausfuehrung_name: "Fließheck",
      ausfuehrung_name_en: "hatchback",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "247",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "452",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "247",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "453",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "247",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "454",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "247",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "455",
      ausfuehrung_name: "Stufenheck",
      ausfuehrung_name_en: "notchback",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "247",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1361",
      ausfuehrung_name: "Fließheck",
      ausfuehrung_name_en: "hatchback",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "247",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1362",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "247",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1363",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "247",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1364",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "247",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1365",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "247",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1366",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "247",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1367",
      ausfuehrung_name: "Stufenheck",
      ausfuehrung_name_en: "notchback",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "247",
      ausfuehrung_aktiv: "1",
    },
  ],
  248: [
    {
      ausfuehrung_id: "456",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "248",
      ausfuehrung_aktiv: "1",
    },
  ],
  249: [
    {
      ausfuehrung_id: "457",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "249",
      ausfuehrung_aktiv: "1",
    },
  ],
  250: [
    {
      ausfuehrung_id: "458",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "250",
      ausfuehrung_aktiv: "1",
    },
  ],
  251: [
    {
      ausfuehrung_id: "459",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "251",
      ausfuehrung_aktiv: "1",
    },
  ],
  252: [
    {
      ausfuehrung_id: "460",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "252",
      ausfuehrung_aktiv: "1",
    },
  ],
  253: [
    {
      ausfuehrung_id: "461",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "253",
      ausfuehrung_aktiv: "1",
    },
  ],
  254: [
    {
      ausfuehrung_id: "462",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "254",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1368",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "254",
      ausfuehrung_aktiv: "1",
    },
  ],
  255: [
    {
      ausfuehrung_id: "463",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "255",
      ausfuehrung_aktiv: "1",
    },
  ],
  256: [
    {
      ausfuehrung_id: "464",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "256",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "465",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "256",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1369",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "256",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1370",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "256",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1371",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "256",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1372",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "256",
      ausfuehrung_aktiv: "1",
    },
  ],
  257: [
    {
      ausfuehrung_id: "466",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "257",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1373",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "257",
      ausfuehrung_aktiv: "1",
    },
  ],
  258: [
    {
      ausfuehrung_id: "467",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "258",
      ausfuehrung_aktiv: "1",
    },
  ],
  259: [
    {
      ausfuehrung_id: "468",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "259",
      ausfuehrung_aktiv: "1",
    },
  ],
  260: [
    {
      ausfuehrung_id: "469",
      ausfuehrung_name: "V 168 (lang)",
      ausfuehrung_name_en: "V 168 (long)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "260",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "470",
      ausfuehrung_name: "W 168",
      ausfuehrung_name_en: "W 168",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "260",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "471",
      ausfuehrung_name: "3 und 5-türig (W169)",
      ausfuehrung_name_en: "3 and 5 doors (W169)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "260",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "472",
      ausfuehrung_name: "(W176)",
      ausfuehrung_name_en: "(W176)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "260",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "473",
      ausfuehrung_name: "(W177)",
      ausfuehrung_name_en: "(W177)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "260",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1631",
      ausfuehrung_name: "Limousine (V177)",
      ausfuehrung_name_en: "Limousine (V177)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "260",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1680",
      ausfuehrung_name: "Limousine (V177)",
      ausfuehrung_name_en: "Limousine (V177)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "260",
      ausfuehrung_aktiv: "1",
    },
  ],
  261: [
    {
      ausfuehrung_id: "474",
      ausfuehrung_name: "(T245)",
      ausfuehrung_name_en: "(T245)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "261",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "475",
      ausfuehrung_name: "(W246)",
      ausfuehrung_name_en: "(W246)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "261",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1632",
      ausfuehrung_name: "(W247)",
      ausfuehrung_name_en: "(W247)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "261",
      ausfuehrung_aktiv: "1",
    },
  ],
  262: [
    {
      ausfuehrung_id: "476",
      ausfuehrung_name: "W 203 SC",
      ausfuehrung_name_en: "W 203 SC",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "262",
      ausfuehrung_aktiv: "1",
    },
  ],
  263: [
    {
      ausfuehrung_id: "477",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "263",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1738",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "263",
      ausfuehrung_aktiv: "1",
    },
  ],
  264: [
    {
      ausfuehrung_id: "478",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "479",
      ausfuehrung_name: "(W205)",
      ausfuehrung_name_en: "(W205)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "480",
      ausfuehrung_name: "Coupe (C204)",
      ausfuehrung_name_en: "Coupe (C204)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "481",
      ausfuehrung_name: "W 202",
      ausfuehrung_name_en: "W 202",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "482",
      ausfuehrung_name: "T-Modell (S202), mit Reling",
      ausfuehrung_name_en: "T-Modell (S202), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "483",
      ausfuehrung_name: "T-Modell (S203), mit Reling",
      ausfuehrung_name_en: "T-Modell (S203), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "484",
      ausfuehrung_name: "T-Modell (S204), mit Reling",
      ausfuehrung_name_en: "T-Modell (S204), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "485",
      ausfuehrung_name: "T-Modell (S205), mit Reling",
      ausfuehrung_name_en: "T-Modell (S205), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "486",
      ausfuehrung_name: "(W203)",
      ausfuehrung_name_en: "(W203)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "487",
      ausfuehrung_name: "(W204)",
      ausfuehrung_name_en: "(W204)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1374",
      ausfuehrung_name: "(W205)",
      ausfuehrung_name_en: "(W205)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1375",
      ausfuehrung_name: "W 202",
      ausfuehrung_name_en: "W 202",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1376",
      ausfuehrung_name: "T-Modell S 202",
      ausfuehrung_name_en: "T-Model S 202",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1377",
      ausfuehrung_name: "T-Modell (S205), mit Reling",
      ausfuehrung_name_en: "T-Modell (S205), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1378",
      ausfuehrung_name: "W 204",
      ausfuehrung_name_en: "W 204",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1633",
      ausfuehrung_name: "Sport Coupe (CL203)",
      ausfuehrung_name_en: "Sport Coupe (CL203)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1712",
      ausfuehrung_name: "T-Modell (S206), mit Reling",
      ausfuehrung_name_en: "with roof rails (S206)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1722",
      ausfuehrung_name: "T-Modell mit Reling (S206)",
      ausfuehrung_name_en: "Estate, with roof rails (S206)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1723",
      ausfuehrung_name: "All Terrain, mit Reling (S206-2)",
      ausfuehrung_name_en: "All Terrain, with roof rails (S206-2)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1740",
      ausfuehrung_name: "(W206)",
      ausfuehrung_name_en: "W(206)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1741",
      ausfuehrung_name: "Coupe (C205)",
      ausfuehrung_name_en: "Coupe (C205)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "264",
      ausfuehrung_aktiv: "1",
    },
  ],
  265: [
    {
      ausfuehrung_id: "488",
      ausfuehrung_name: "(C117)",
      ausfuehrung_name_en: "(C117)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "265",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "489",
      ausfuehrung_name: "Shooting Brake (X117)",
      ausfuehrung_name_en: "Shooting Brake (X117)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "265",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1634",
      ausfuehrung_name: "(C118)",
      ausfuehrung_name_en: "(C118)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "265",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1635",
      ausfuehrung_name: "Shooting Brake (X118)",
      ausfuehrung_name_en: "Shooting Brake (X118)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "265",
      ausfuehrung_aktiv: "1",
    },
  ],
  266: [
    {
      ausfuehrung_id: "490",
      ausfuehrung_name: "C 208",
      ausfuehrung_name_en: "C 208",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "266",
      ausfuehrung_aktiv: "1",
    },
  ],
  267: [
    {
      ausfuehrung_id: "491",
      ausfuehrung_name: "Coupe (C218)",
      ausfuehrung_name_en: "Coupe (C218)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "267",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "492",
      ausfuehrung_name: "Shooting Brake (X218)",
      ausfuehrung_name_en: "Shooting Brake (X218)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "267",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "493",
      ausfuehrung_name: "Coupe (C257)",
      ausfuehrung_name_en: "Coupe (C257)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "267",
      ausfuehrung_aktiv: "1",
    },
  ],
  268: [
    {
      ausfuehrung_id: "494",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "268",
      ausfuehrung_aktiv: "1",
    },
  ],
  269: [
    {
      ausfuehrung_id: "495",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "269",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "496",
      ausfuehrung_name: "All Terrain (T213), mit Reling",
      ausfuehrung_name_en: "All Terrain (T213), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "269",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "497",
      ausfuehrung_name: "E63 AMG T-Modell (S213), mit Reling",
      ausfuehrung_name_en: "E63 AMG T-Modell (S213), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "269",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "498",
      ausfuehrung_name: "Coupe (C207)",
      ausfuehrung_name_en: "Coupe (C207)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "269",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "499",
      ausfuehrung_name: "Coupe (C238)",
      ausfuehrung_name_en: "Coupe (C238)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "269",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "500",
      ausfuehrung_name: "Kombi W 124",
      ausfuehrung_name_en: "Station Wagon W 124",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "269",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "501",
      ausfuehrung_name: "T-Modell (S210), mit Reling",
      ausfuehrung_name_en: "T-Modell (S210), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "269",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "502",
      ausfuehrung_name: "T-Modell (S211), mit Reling",
      ausfuehrung_name_en: "T-Modell (S211), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "269",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "503",
      ausfuehrung_name: "T-Modell (S212), mit Reling",
      ausfuehrung_name_en: "T-Modell (S212), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "269",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "504",
      ausfuehrung_name: "T-Modell (S213), mit Reling",
      ausfuehrung_name_en: "T-Modell (S213), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "269",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "505",
      ausfuehrung_name: "(W210)",
      ausfuehrung_name_en: "(W210)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "269",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "506",
      ausfuehrung_name: "(W211)",
      ausfuehrung_name_en: "(W211)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "269",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "507",
      ausfuehrung_name: "(W212)",
      ausfuehrung_name_en: "(W212)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "269",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "508",
      ausfuehrung_name: "(W213)",
      ausfuehrung_name_en: "(W213)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "269",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1379",
      ausfuehrung_name: "(W212)",
      ausfuehrung_name_en: "(W212)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "269",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1763",
      ausfuehrung_name: "T-Modell mit Reling ( S 214)",
      ausfuehrung_name_en: "Estate, with roof rails( S 214)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "269",
      ausfuehrung_aktiv: "1",
    },
  ],
  270: [
    {
      ausfuehrung_id: "509",
      ausfuehrung_name: "(X166), mit Reling",
      ausfuehrung_name_en: "(X166), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "270",
      ausfuehrung_aktiv: "1",
    },
  ],
  271: [
    {
      ausfuehrung_id: "510",
      ausfuehrung_name: "X 156",
      ausfuehrung_name_en: "X 156",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "271",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "511",
      ausfuehrung_name: "(X156), mit Reling",
      ausfuehrung_name_en: "(X156), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "271",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1749",
      ausfuehrung_name: "(H247), mit Reling",
      ausfuehrung_name_en: "(H247), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "271",
      ausfuehrung_aktiv: "1",
    },
  ],
  272: [
    {
      ausfuehrung_id: "512",
      ausfuehrung_name: "Coupe (C253), mit Reling",
      ausfuehrung_name_en: "Coupe (C253), with roof rail",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "272",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "513",
      ausfuehrung_name: "(X253), mit Reling",
      ausfuehrung_name_en: "(X253), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "272",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1755",
      ausfuehrung_name: "(X254), mit Reling",
      ausfuehrung_name_en: "(X254), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "272",
      ausfuehrung_aktiv: "1",
    },
  ],
  273: [
    {
      ausfuehrung_id: "514",
      ausfuehrung_name: "Coupe (C292)",
      ausfuehrung_name_en: "Coupe (C292)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "273",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "515",
      ausfuehrung_name: "(W166), mit Reling",
      ausfuehrung_name_en: "(W166), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "273",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1637",
      ausfuehrung_name: "(V167), mit Reling",
      ausfuehrung_name_en: "(V167), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "273",
      ausfuehrung_aktiv: "1",
    },
  ],
  274: [
    {
      ausfuehrung_id: "516",
      ausfuehrung_name: "(X204), mit Reling",
      ausfuehrung_name_en: "(X204), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "274",
      ausfuehrung_aktiv: "1",
    },
  ],
  275: [
    {
      ausfuehrung_id: "517",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "275",
      ausfuehrung_aktiv: "1",
    },
  ],
  276: [
    {
      ausfuehrung_id: "518",
      ausfuehrung_name: "(X166), mit Reling",
      ausfuehrung_name_en: "(X166), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "276",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1678",
      ausfuehrung_name: "mit Reling (X167)",
      ausfuehrung_name_en: "with roof rails (X167)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "276",
      ausfuehrung_aktiv: "1",
    },
  ],
  277: [
    {
      ausfuehrung_id: "519",
      ausfuehrung_name: "Flachdach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "277",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "520",
      ausfuehrung_name: "Hochddach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "277",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1380",
      ausfuehrung_name: "Flachdach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "277",
      ausfuehrung_aktiv: "1",
    },
  ],
  278: [
    {
      ausfuehrung_id: "521",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "278",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "522",
      ausfuehrung_name: "(W163+164), mit Reling",
      ausfuehrung_name_en: "(W163+164), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "278",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1381",
      ausfuehrung_name: "(W166), mit Reling",
      ausfuehrung_name_en: "(W166), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "278",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1638",
      ausfuehrung_name: "(W163+164), mit Reling",
      ausfuehrung_name_en: "(W163+164), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "278",
      ausfuehrung_aktiv: "1",
    },
  ],
  279: [
    {
      ausfuehrung_id: "523",
      ausfuehrung_name: "(W251)",
      ausfuehrung_name_en: "(W251)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "279",
      ausfuehrung_aktiv: "1",
    },
  ],
  280: [
    {
      ausfuehrung_id: "524",
      ausfuehrung_name: "(W222 - kurz)",
      ausfuehrung_name_en: "(W222 - short)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "280",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "525",
      ausfuehrung_name: "(V222 - lang)",
      ausfuehrung_name_en: "(V222 - long)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "280",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "526",
      ausfuehrung_name: "W 140",
      ausfuehrung_name_en: "W 140",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "280",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "527",
      ausfuehrung_name: "(W221)",
      ausfuehrung_name_en: "(W221)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "280",
      ausfuehrung_aktiv: "1",
    },
  ],
  281: [
    {
      ausfuehrung_id: "528",
      ausfuehrung_name: "mit Doppelkabine",
      ausfuehrung_name_en: "with double cabin",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "281",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "529",
      ausfuehrung_name: "Normal-/Hochdach C-Schiene",
      ausfuehrung_name_en: "normal/high roof C-with rail",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "281",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1143",
      ausfuehrung_name: "Flachdach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "281",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1144",
      ausfuehrung_name: "Flachdach mit C-Schiene",
      ausfuehrung_name_en: "normal roof with c-with rail",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "281",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1147",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "281",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1150",
      ausfuehrung_name: "Hochdach mit C-Schiene",
      ausfuehrung_name_en: "high roof with c-with rail",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "281",
      ausfuehrung_aktiv: "1",
    },
  ],
  282: [
    {
      ausfuehrung_id: "530",
      ausfuehrung_name: "Flachdach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "282",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "531",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "282",
      ausfuehrung_aktiv: "1",
    },
  ],
  283: [
    {
      ausfuehrung_id: "532",
      ausfuehrung_name: "Flachdach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "283",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "533",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "283",
      ausfuehrung_aktiv: "1",
    },
  ],
  284: [
    {
      ausfuehrung_id: "534",
      ausfuehrung_name: "414",
      ausfuehrung_name_en: "414",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "284",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "535",
      ausfuehrung_name: "414 mit Reling",
      ausfuehrung_name_en: "414 with rail",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "284",
      ausfuehrung_aktiv: "1",
    },
  ],
  285: [
    {
      ausfuehrung_id: "536",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "285",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1165",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "285",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1174",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "285",
      ausfuehrung_aktiv: "1",
    },
  ],
  286: [
    {
      ausfuehrung_id: "537",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "286",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "538",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "286",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1382",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "286",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1383",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "286",
      ausfuehrung_aktiv: "1",
    },
  ],
  287: [
    {
      ausfuehrung_id: "539",
      ausfuehrung_name: "Vito (W638), mit Reling",
      ausfuehrung_name_en: "Vito (W638), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "287",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1384",
      ausfuehrung_name: "Vito (W638), ohne Reling",
      ausfuehrung_name_en: "Vito (W638), without roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "287",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1639",
      ausfuehrung_name: "Vito, Viano (W639), mit Reling",
      ausfuehrung_name_en: "Vito, Viano (W639), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "287",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1640",
      ausfuehrung_name: "Vito (W447), mit Reling",
      ausfuehrung_name_en: "Vito (W447), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "287",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1641",
      ausfuehrung_name: "Viano, mit Reling",
      ausfuehrung_name_en: "Viano, with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "287",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1642",
      ausfuehrung_name: "Viano, ohne Reling",
      ausfuehrung_name_en: "Viano, without roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "287",
      ausfuehrung_aktiv: "1",
    },
  ],
  288: [
    {
      ausfuehrung_id: "540",
      ausfuehrung_name: "T",
      ausfuehrung_name_en: "T",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "288",
      ausfuehrung_aktiv: "1",
    },
  ],
  289: [
    {
      ausfuehrung_id: "541",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "289",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "542",
      ausfuehrung_name: "CE",
      ausfuehrung_name_en: "CE",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "289",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "543",
      ausfuehrung_name: "T",
      ausfuehrung_name_en: "T",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "289",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1385",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "289",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1386",
      ausfuehrung_name: "T",
      ausfuehrung_name_en: "T",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "289",
      ausfuehrung_aktiv: "1",
    },
  ],
  290: [
    {
      ausfuehrung_id: "544",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "290",
      ausfuehrung_aktiv: "1",
    },
  ],
  291: [
    {
      ausfuehrung_id: "545",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "291",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1387",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "291",
      ausfuehrung_aktiv: "1",
    },
  ],
  292: [
    {
      ausfuehrung_id: "546",
      ausfuehrung_name: "(W470), mit Reling",
      ausfuehrung_name_en: "(W470), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "292",
      ausfuehrung_aktiv: "1",
    },
  ],
  293: [
    {
      ausfuehrung_id: "547",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "27",
      ausfuehrung_modell_id: "293",
      ausfuehrung_aktiv: "1",
    },
  ],
  294: [
    {
      ausfuehrung_id: "548",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "27",
      ausfuehrung_modell_id: "294",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1388",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "27",
      ausfuehrung_modell_id: "294",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1772",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "27",
      ausfuehrung_modell_id: "294",
      ausfuehrung_aktiv: "1",
    },
  ],
  295: [
    {
      ausfuehrung_id: "549",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "295",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "550",
      ausfuehrung_name: "o. Reling",
      ausfuehrung_name_en: "wo. rail",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "295",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1759",
      ausfuehrung_name: " o. Reling",
      ausfuehrung_name_en: "without rail",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "295",
      ausfuehrung_aktiv: "1",
    },
  ],
  296: [
    {
      ausfuehrung_id: "551",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "296",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "552",
      ausfuehrung_name: "3-türig o. Faltdach",
      ausfuehrung_name_en: "3 dorrs wo. folding roof",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "296",
      ausfuehrung_aktiv: "1",
    },
  ],
  297: [
    {
      ausfuehrung_id: "553",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "297",
      ausfuehrung_aktiv: "1",
    },
  ],
  298: [
    {
      ausfuehrung_id: "554",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "298",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "555",
      ausfuehrung_name: "Fließheck",
      ausfuehrung_name_en: "hatchback",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "298",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "556",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "298",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "557",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "298",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "558",
      ausfuehrung_name: "Stufenheck",
      ausfuehrung_name_en: "notchback",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "298",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "559",
      ausfuehrung_name: "4-türig",
      ausfuehrung_name_en: "4 doors",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "298",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1389",
      ausfuehrung_name: "Fließheck",
      ausfuehrung_name_en: "hatchback",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "298",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1390",
      ausfuehrung_name: "Stufenheck",
      ausfuehrung_name_en: "notchback",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "298",
      ausfuehrung_aktiv: "1",
    },
  ],
  299: [
    {
      ausfuehrung_id: "560",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "299",
      ausfuehrung_aktiv: "1",
    },
  ],
  300: [
    {
      ausfuehrung_id: "561",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "300",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1391",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "300",
      ausfuehrung_aktiv: "1",
    },
  ],
  301: [
    {
      ausfuehrung_id: "562",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "301",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "563",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "301",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1392",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "301",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1393",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "301",
      ausfuehrung_aktiv: "1",
    },
  ],
  302: [
    {
      ausfuehrung_id: "564",
      ausfuehrung_name: "Limousine, 4-türig",
      ausfuehrung_name_en: "Limousine, 4 doors",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "302",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "565",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "302",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "566",
      ausfuehrung_name: "Kombi 4WD",
      ausfuehrung_name_en: "Station Wagon 4WD",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "302",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "567",
      ausfuehrung_name: "Kombi 4WD mit Reling",
      ausfuehrung_name_en: "Station Wagon 4WD with rail",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "302",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "568",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "302",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "569",
      ausfuehrung_name: "Limousine und Kombi",
      ausfuehrung_name_en: "Limousine and Station Wagon",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "302",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "570",
      ausfuehrung_name: "Sportback 5-türig",
      ausfuehrung_name_en: "Sportback 5 doors",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "302",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "571",
      ausfuehrung_name: "Stufenheck",
      ausfuehrung_name_en: "notchback",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "302",
      ausfuehrung_aktiv: "1",
    },
  ],
  303: [
    {
      ausfuehrung_id: "572",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "303",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "573",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "303",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "574",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "303",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1645",
      ausfuehrung_name: "Hybrid, mit Reling",
      ausfuehrung_name_en: "PHEV, with roof rails",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "303",
      ausfuehrung_aktiv: "1",
    },
  ],
  304: [
    {
      ausfuehrung_id: "575",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "304",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "576",
      ausfuehrung_name: "3 und 5-türig, mit Reling",
      ausfuehrung_name_en: "3 and 5 doors, with roof rails",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "304",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "577",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "304",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "578",
      ausfuehrung_name: "Pinin, mit Reling",
      ausfuehrung_name_en: "Pinin, with roof rails",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "304",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "579",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "304",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1394",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "304",
      ausfuehrung_aktiv: "1",
    },
  ],
  305: [
    {
      ausfuehrung_id: "580",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "305",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1395",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "305",
      ausfuehrung_aktiv: "1",
    },
  ],
  306: [
    {
      ausfuehrung_id: "581",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "306",
      ausfuehrung_aktiv: "1",
    },
  ],
  307: [
    {
      ausfuehrung_id: "582",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "307",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "583",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "307",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "584",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "307",
      ausfuehrung_aktiv: "1",
    },
  ],
  308: [
    {
      ausfuehrung_id: "585",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "308",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "586",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "308",
      ausfuehrung_aktiv: "1",
    },
  ],
  309: [
    {
      ausfuehrung_id: "587",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "309",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1396",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "309",
      ausfuehrung_aktiv: "1",
    },
  ],
  310: [
    {
      ausfuehrung_id: "588",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "310",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "589",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "310",
      ausfuehrung_aktiv: "1",
    },
  ],
  311: [
    {
      ausfuehrung_id: "590",
      ausfuehrung_name: "Break",
      ausfuehrung_name_en: "Break",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "311",
      ausfuehrung_aktiv: "1",
    },
  ],
  312: [
    {
      ausfuehrung_id: "591",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "312",
      ausfuehrung_aktiv: "1",
    },
  ],
  313: [
    {
      ausfuehrung_id: "592",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "313",
      ausfuehrung_aktiv: "1",
    },
  ],
  314: [
    {
      ausfuehrung_id: "593",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "314",
      ausfuehrung_aktiv: "1",
    },
  ],
  315: [
    {
      ausfuehrung_id: "594",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "315",
      ausfuehrung_aktiv: "1",
    },
  ],
  316: [
    {
      ausfuehrung_id: "595",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "316",
      ausfuehrung_aktiv: "1",
    },
  ],
  317: [
    {
      ausfuehrung_id: "596",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "317",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "597",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "317",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "598",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "317",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1397",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "317",
      ausfuehrung_aktiv: "1",
    },
  ],
  318: [
    {
      ausfuehrung_id: "599",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "318",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1398",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "318",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1399",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "318",
      ausfuehrung_aktiv: "1",
    },
  ],
  319: [
    {
      ausfuehrung_id: "600",
      ausfuehrung_name: "NP300 DC, mit Reling",
      ausfuehrung_name_en: "NP300 DC, with roof rails",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "319",
      ausfuehrung_aktiv: "1",
    },
  ],
  320: [
    {
      ausfuehrung_id: "601",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "320",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1400",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "320",
      ausfuehrung_aktiv: "1",
    },
  ],
  321: [
    {
      ausfuehrung_id: "602",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "321",
      ausfuehrung_aktiv: "1",
    },
  ],
  322: [
    {
      ausfuehrung_id: "603",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "322",
      ausfuehrung_aktiv: "1",
    },
  ],
  323: [
    {
      ausfuehrung_id: "604",
      ausfuehrung_name: "(für alle 4 Positionen)",
      ausfuehrung_name_en: "(for all 4 positions)",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "323",
      ausfuehrung_aktiv: "1",
    },
  ],
  324: [
    {
      ausfuehrung_id: "605",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "324",
      ausfuehrung_aktiv: "1",
    },
  ],
  325: [
    {
      ausfuehrung_id: "606",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "325",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1646",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "325",
      ausfuehrung_aktiv: "1",
    },
  ],
  326: [
    {
      ausfuehrung_id: "607",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "326",
      ausfuehrung_aktiv: "1",
    },
  ],
  327: [
    {
      ausfuehrung_id: "608",
      ausfuehrung_name: "mit Reling DM 18 mm",
      ausfuehrung_name_en: "Reling dia 18 mm",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "327",
      ausfuehrung_aktiv: "1",
    },
  ],
  328: [
    {
      ausfuehrung_id: "609",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "328",
      ausfuehrung_aktiv: "1",
    },
  ],
  329: [
    {
      ausfuehrung_id: "610",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "329",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "611",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "329",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "612",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "329",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "613",
      ausfuehrung_name: "Traveller, mit Reling",
      ausfuehrung_name_en: "Traveller, with roof rails",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "329",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "614",
      ausfuehrung_name: "Fließ- und Stufenheck",
      ausfuehrung_name_en: "hatch- and notchback",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "329",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1401",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "329",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1402",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "329",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1403",
      ausfuehrung_name: "Traveller",
      ausfuehrung_name_en: "Traveller",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "329",
      ausfuehrung_aktiv: "1",
    },
  ],
  330: [
    {
      ausfuehrung_id: "615",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "330",
      ausfuehrung_aktiv: "1",
    },
  ],
  331: [
    {
      ausfuehrung_id: "616",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "331",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "617",
      ausfuehrung_name: "2 mit Reling",
      ausfuehrung_name_en: "2 with roof rails",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "331",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "618",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "331",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1404",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "331",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1405",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "331",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1406",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "331",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1407",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "331",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1745",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "331",
      ausfuehrung_aktiv: "1",
    },
  ],
  332: [
    {
      ausfuehrung_id: "619",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "332",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "620",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "332",
      ausfuehrung_aktiv: "1",
    },
  ],
  333: [
    {
      ausfuehrung_id: "621",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "333",
      ausfuehrung_aktiv: "1",
    },
  ],
  334: [
    {
      ausfuehrung_id: "622",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "334",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "623",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "334",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "624",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "334",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "625",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "334",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "626",
      ausfuehrung_name: "4/5-türig",
      ausfuehrung_name_en: "4/5 doors",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "334",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1408",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "334",
      ausfuehrung_aktiv: "1",
    },
  ],
  335: [
    {
      ausfuehrung_id: "627",
      ausfuehrung_name: "mit Reling DM 28 mm",
      ausfuehrung_name_en: "with rail dia 28 mm",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "335",
      ausfuehrung_aktiv: "1",
    },
  ],
  336: [
    {
      ausfuehrung_id: "628",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "336",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "629",
      ausfuehrung_name: "mit Reling DM 28 mm",
      ausfuehrung_name_en: "with rail dia 28 mm",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "336",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "630",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "336",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1409",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "336",
      ausfuehrung_aktiv: "1",
    },
  ],
  337: [
    {
      ausfuehrung_id: "631",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "337",
      ausfuehrung_aktiv: "1",
    },
  ],
  338: [
    {
      ausfuehrung_id: "632",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "338",
      ausfuehrung_aktiv: "1",
    },
  ],
  339: [
    {
      ausfuehrung_id: "633",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "339",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1153",
      ausfuehrung_name: "Largo",
      ausfuehrung_name_en: "Largo",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "339",
      ausfuehrung_aktiv: "1",
    },
  ],
  340: [
    {
      ausfuehrung_id: "634",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "340",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1410",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "340",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1411",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "340",
      ausfuehrung_aktiv: "1",
    },
  ],
  341: [
    {
      ausfuehrung_id: "635",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "341",
      ausfuehrung_aktiv: "1",
    },
  ],
  342: [
    {
      ausfuehrung_id: "636",
      ausfuehrung_name: "ohne Reling",
      ausfuehrung_name_en: "without roof rails",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "342",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "637",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "342",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1412",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "342",
      ausfuehrung_aktiv: "1",
    },
  ],
  343: [
    {
      ausfuehrung_id: "638",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "343",
      ausfuehrung_aktiv: "1",
    },
  ],
  344: [
    {
      ausfuehrung_id: "639",
      ausfuehrung_name: "Caravan",
      ausfuehrung_name_en: "Caravan",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "640",
      ausfuehrung_name: "Caravan o. Reling",
      ausfuehrung_name_en: "Caravan wo. rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "641",
      ausfuehrung_name: "Caravan, mit Reling (F,G)",
      ausfuehrung_name_en: "Caravan, with roof rails (F,G)",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "642",
      ausfuehrung_name: "Coupe, 2-türig",
      ausfuehrung_name_en: "Coupe, 2 doors",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "643",
      ausfuehrung_name: "Coupe GTC, 3-türig",
      ausfuehrung_name_en: "Coupe GTC, 3 doors",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "644",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "645",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "646",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "647",
      ausfuehrung_name: "Caravan, mit Reling",
      ausfuehrung_name_en: "Caravan, with roof rails",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "648",
      ausfuehrung_name: "Sports Tourer (Schmuck-Reling)",
      ausfuehrung_name_en: "Sports Tourer (decorative rail)",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "649",
      ausfuehrung_name: "Sports Tourer mit Reling",
      ausfuehrung_name_en: "Sports Tourer with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "650",
      ausfuehrung_name: "Fließheck 3/5-türig",
      ausfuehrung_name_en: "hatchback 3/5 doors",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "651",
      ausfuehrung_name: "Stufenheck, 4-türig",
      ausfuehrung_name_en: "notchback, 4 doors",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1413",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1414",
      ausfuehrung_name: "Limousine, 5-türig",
      ausfuehrung_name_en: "Limousine, 5 doors",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1415",
      ausfuehrung_name: "Caravan, mit Reling",
      ausfuehrung_name_en: "Caravan, with roof rails",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1416",
      ausfuehrung_name: "Stufenheck 4-türig",
      ausfuehrung_name_en: "notchback 4 doors",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1743",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1765",
      ausfuehrung_name: "Sports Tourer mit Reling",
      ausfuehrung_name_en: "Sports Tourer, with roof rails",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "344",
      ausfuehrung_aktiv: "1",
    },
  ],
  345: [
    {
      ausfuehrung_id: "652",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "345",
      ausfuehrung_aktiv: "1",
    },
  ],
  346: [
    {
      ausfuehrung_id: "653",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "346",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "654",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "346",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1417",
      ausfuehrung_name: "ohne Reling",
      ausfuehrung_name_en: "without roof rails",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "346",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1418",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "346",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1419",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "346",
      ausfuehrung_aktiv: "1",
    },
  ],
  347: [
    {
      ausfuehrung_id: "655",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "347",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "656",
      ausfuehrung_name: "(C, D, E), 3- und 5-türig",
      ausfuehrung_name_en: "(C, D, E), 3 and 5 doors",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "347",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1420",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "347",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1421",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "347",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1422",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "347",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1687",
      ausfuehrung_name: "(F)",
      ausfuehrung_name_en: "(F)",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "347",
      ausfuehrung_aktiv: "1",
    },
  ],
  348: [
    {
      ausfuehrung_id: "657",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "348",
      ausfuehrung_aktiv: "1",
    },
  ],
  349: [
    {
      ausfuehrung_id: "658",
      ausfuehrung_name: "Sport 3-türig mit Reling",
      ausfuehrung_name_en: "Sport 3 doors Reling",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "349",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "659",
      ausfuehrung_name: "4-türig mit Reling",
      ausfuehrung_name_en: "4 doors with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "349",
      ausfuehrung_aktiv: "1",
    },
  ],
  350: [
    {
      ausfuehrung_id: "660",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "350",
      ausfuehrung_aktiv: "1",
    },
  ],
  351: [
    {
      ausfuehrung_id: "661",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "351",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "662",
      ausfuehrung_name: "Country Tourer, mit Reling",
      ausfuehrung_name_en: "Country Tourer, with roof rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "351",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "663",
      ausfuehrung_name: "Grand Sport",
      ausfuehrung_name_en: "Grand Sport",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "351",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "664",
      ausfuehrung_name: "GSI Limousine",
      ausfuehrung_name_en: "GSI Limousine",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "351",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "665",
      ausfuehrung_name: "GSI Sports Tourer, mit Reling",
      ausfuehrung_name_en: "GSI Sports Tourer, with roof rails",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "351",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "666",
      ausfuehrung_name: "Sports Tourer, mit Reling",
      ausfuehrung_name_en: "Sports Tourer, with roof rails",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "351",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1423",
      ausfuehrung_name: "Country Tourer, mit Reling",
      ausfuehrung_name_en: "Country Tourer, with roof rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "351",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1424",
      ausfuehrung_name: "Sports Tourer, mit Reling",
      ausfuehrung_name_en: "Sports Tourer, with roof rails",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "351",
      ausfuehrung_aktiv: "1",
    },
  ],
  352: [
    {
      ausfuehrung_id: "667",
      ausfuehrung_name: "Combo",
      ausfuehrung_name_en: "Combo",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "352",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "668",
      ausfuehrung_name: "E",
      ausfuehrung_name_en: "E",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "352",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "669",
      ausfuehrung_name: "E mit Reling",
      ausfuehrung_name_en: "E with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "352",
      ausfuehrung_aktiv: "1",
    },
  ],
  353: [
    {
      ausfuehrung_id: "670",
      ausfuehrung_name: "Rocks, mit Reling",
      ausfuehrung_name_en: "Rocks, with roof rails",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "353",
      ausfuehrung_aktiv: "1",
    },
  ],
  354: [
    {
      ausfuehrung_id: "671",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "354",
      ausfuehrung_aktiv: "1",
    },
  ],
  355: [
    {
      ausfuehrung_id: "672",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "355",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "673",
      ausfuehrung_name: "X mit Reling",
      ausfuehrung_name_en: "X with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "355",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1719",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "355",
      ausfuehrung_aktiv: "1",
    },
  ],
  356: [
    {
      ausfuehrung_id: "674",
      ausfuehrung_name: "2/4-türig",
      ausfuehrung_name_en: "2/4 doors",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "356",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "675",
      ausfuehrung_name: "3. Bügel",
      ausfuehrung_name_en: "3rd bracket",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "356",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "676",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "356",
      ausfuehrung_aktiv: "1",
    },
  ],
  357: [
    {
      ausfuehrung_id: "677",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "357",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1148",
      ausfuehrung_name: "Hochdach (nicht GFK)",
      ausfuehrung_name_en: "high roof (not GFK)",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "357",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1162",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "357",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1175",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "357",
      ausfuehrung_aktiv: "1",
    },
  ],
  358: [
    {
      ausfuehrung_id: "678",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "358",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "679",
      ausfuehrung_name: "Caravan",
      ausfuehrung_name_en: "Caravan",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "358",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "680",
      ausfuehrung_name: "Caravan mit Reling A",
      ausfuehrung_name_en: "Caravan with rail A",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "358",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "681",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "358",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "682",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "358",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1425",
      ausfuehrung_name: "Caravan",
      ausfuehrung_name_en: "Caravan",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "358",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1426",
      ausfuehrung_name: "Caravan",
      ausfuehrung_name_en: "Caravan",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "358",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1427",
      ausfuehrung_name: "Caravan mit Reling A",
      ausfuehrung_name_en: "Caravan with rail A",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "358",
      ausfuehrung_aktiv: "1",
    },
  ],
  359: [
    {
      ausfuehrung_id: "683",
      ausfuehrung_name: "CD",
      ausfuehrung_name_en: "CD",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "359",
      ausfuehrung_aktiv: "1",
    },
  ],
  360: [
    {
      ausfuehrung_id: "684",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "360",
      ausfuehrung_aktiv: "1",
    },
  ],
  361: [
    {
      ausfuehrung_id: "685",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "361",
      ausfuehrung_aktiv: "1",
    },
  ],
  362: [
    {
      ausfuehrung_id: "686",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "362",
      ausfuehrung_aktiv: "1",
    },
  ],
  363: [
    {
      ausfuehrung_id: "687",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "363",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "688",
      ausfuehrung_name: "Caravan",
      ausfuehrung_name_en: "Caravan",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "363",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "689",
      ausfuehrung_name: "Caravan mit Reling B",
      ausfuehrung_name_en: "Caravan with rail B",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "363",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "690",
      ausfuehrung_name: "Fließheck",
      ausfuehrung_name_en: "hatchback",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "363",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "691",
      ausfuehrung_name: "(C)",
      ausfuehrung_name_en: "(C)",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "363",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "692",
      ausfuehrung_name: "Caravan",
      ausfuehrung_name_en: "Caravan",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "363",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "693",
      ausfuehrung_name: "Stufenheck",
      ausfuehrung_name_en: "notchback",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "363",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1428",
      ausfuehrung_name: "Caravan mit Reling B",
      ausfuehrung_name_en: "Caravan with rail B",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "363",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1429",
      ausfuehrung_name: "Caravan, mit Reling ",
      ausfuehrung_name_en: "Caravan, with rail ",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "363",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1430",
      ausfuehrung_name: "Fließheck",
      ausfuehrung_name_en: "hatchback",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "363",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1431",
      ausfuehrung_name: "Stufenheck",
      ausfuehrung_name_en: "notchback",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "363",
      ausfuehrung_aktiv: "1",
    },
  ],
  364: [
    {
      ausfuehrung_id: "694",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "364",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1432",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "364",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1647",
      ausfuehrung_name: "Cargo",
      ausfuehrung_name_en: "Cargo",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "364",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1648",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Combi",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "364",
      ausfuehrung_aktiv: "1",
    },
  ],
  365: [
    {
      ausfuehrung_id: "695",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "365",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "696",
      ausfuehrung_name: "o. Reling",
      ausfuehrung_name_en: "wo. rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "365",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "697",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "365",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "698",
      ausfuehrung_name: "mit Reling kein Panoramadach",
      ausfuehrung_name_en: "with rail no panorama sunroof",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "365",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "699",
      ausfuehrung_name: "Tourer mit Reling",
      ausfuehrung_name_en: "Tourer with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "365",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "700",
      ausfuehrung_name: "Tourer o. Reling",
      ausfuehrung_name_en: "Tourer wo. rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "365",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1433",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "365",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1434",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "365",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1435",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "365",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1649",
      ausfuehrung_name: "Life",
      ausfuehrung_name_en: "Life",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "365",
      ausfuehrung_aktiv: "1",
    },
  ],
  366: [
    {
      ausfuehrung_id: "701",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "366",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "731",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "366",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "732",
      ausfuehrung_name: "SW, mit Reling",
      ausfuehrung_name_en: "SW, with roof rails",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "366",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1438",
      ausfuehrung_name: "SW, mit Reling",
      ausfuehrung_name_en: "SW, with roof rails",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "366",
      ausfuehrung_aktiv: "1",
    },
  ],
  367: [
    {
      ausfuehrung_id: "702",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "367",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "737",
      ausfuehrung_name: "Break",
      ausfuehrung_name_en: "Break",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "367",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "738",
      ausfuehrung_name: "Break",
      ausfuehrung_name_en: "Break",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "367",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "739",
      ausfuehrung_name: "Break, mit Reling",
      ausfuehrung_name_en: "Break, with roof rails",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "367",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "740",
      ausfuehrung_name: "Break mit Reling",
      ausfuehrung_name_en: "Break with rail",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "367",
      ausfuehrung_aktiv: "1",
    },
  ],
  368: [
    {
      ausfuehrung_id: "703",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "368",
      ausfuehrung_aktiv: "1",
    },
  ],
  369: [
    {
      ausfuehrung_id: "704",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "369",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1436",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "369",
      ausfuehrung_aktiv: "1",
    },
  ],
  370: [
    {
      ausfuehrung_id: "705",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "370",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "709",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "370",
      ausfuehrung_aktiv: "1",
    },
  ],
  371: [
    {
      ausfuehrung_id: "706",
      ausfuehrung_name: "Crossover",
      ausfuehrung_name_en: "Crossover",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "371",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "724",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "371",
      ausfuehrung_aktiv: "1",
    },
  ],
  372: [
    {
      ausfuehrung_id: "707",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "372",
      ausfuehrung_aktiv: "1",
    },
  ],
  373: [
    {
      ausfuehrung_id: "708",
      ausfuehrung_name: "ohne Reling",
      ausfuehrung_name_en: "without roof rails",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "373",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "733",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "373",
      ausfuehrung_aktiv: "1",
    },
  ],
  375: [
    {
      ausfuehrung_id: "710",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "375",
      ausfuehrung_aktiv: "1",
    },
  ],
  376: [
    {
      ausfuehrung_id: "711",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "376",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "712",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "376",
      ausfuehrung_aktiv: "1",
    },
  ],
  377: [
    {
      ausfuehrung_id: "713",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "377",
      ausfuehrung_aktiv: "1",
    },
  ],
  378: [
    {
      ausfuehrung_id: "714",
      ausfuehrung_name: "5-türig (nicht für Stoffschiebedach)",
      ausfuehrung_name_en: "5 doors (not for fabric sliding roof)",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "378",
      ausfuehrung_aktiv: "1",
    },
  ],
  379: [
    {
      ausfuehrung_id: "715",
      ausfuehrung_name: "Multi",
      ausfuehrung_name_en: "Multi",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "379",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "716",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "379",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "717",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "379",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "718",
      ausfuehrung_name: "o. Ausstellfenster",
      ausfuehrung_name_en: "wo. vent window",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "379",
      ausfuehrung_aktiv: "1",
    },
  ],
  380: [
    {
      ausfuehrung_id: "719",
      ausfuehrung_name: "SW, mit Reling",
      ausfuehrung_name_en: "SW, with roof rails",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "380",
      ausfuehrung_aktiv: "1",
    },
  ],
  381: [
    {
      ausfuehrung_id: "720",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "381",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "721",
      ausfuehrung_name: "SW, mit Reling",
      ausfuehrung_name_en: "SW, with roof rails",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "381",
      ausfuehrung_aktiv: "1",
    },
  ],
  382: [
    {
      ausfuehrung_id: "722",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "382",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "723",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "382",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1691",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "382",
      ausfuehrung_aktiv: "1",
    },
  ],
  384: [
    {
      ausfuehrung_id: "725",
      ausfuehrung_name: "Break",
      ausfuehrung_name_en: "Break",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "384",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "726",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "384",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "727",
      ausfuehrung_name: "4-türig",
      ausfuehrung_name_en: "4 doors",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "384",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1437",
      ausfuehrung_name: "Break, mit Reling",
      ausfuehrung_name_en: "Break, with roof rails",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "384",
      ausfuehrung_aktiv: "1",
    },
  ],
  385: [
    {
      ausfuehrung_id: "728",
      ausfuehrung_name: "Break Kombi",
      ausfuehrung_name_en: "Break Station Wagon",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "385",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "729",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "385",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "730",
      ausfuehrung_name: "SW, mit Reling",
      ausfuehrung_name_en: "SW, with roof rails",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "385",
      ausfuehrung_aktiv: "1",
    },
  ],
  387: [
    {
      ausfuehrung_id: "734",
      ausfuehrung_name: "Caravan",
      ausfuehrung_name_en: "Caravan",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "387",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "735",
      ausfuehrung_name: "Caravan mit Reling",
      ausfuehrung_name_en: "Caravan with rail",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "387",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "736",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "387",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1439",
      ausfuehrung_name: "Caravan",
      ausfuehrung_name_en: "Caravan",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "387",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1440",
      ausfuehrung_name: "Caravan",
      ausfuehrung_name_en: "Caravan",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "387",
      ausfuehrung_aktiv: "1",
    },
  ],
  390: [
    {
      ausfuehrung_id: "741",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "390",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "742",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "390",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "743",
      ausfuehrung_name: "SW, mit Reling",
      ausfuehrung_name_en: "SW, with roof rails",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "390",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1441",
      ausfuehrung_name: "SW",
      ausfuehrung_name_en: "SW",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "390",
      ausfuehrung_aktiv: "1",
    },
  ],
  391: [
    {
      ausfuehrung_id: "744",
      ausfuehrung_name: "o. Alu-Dachleiste",
      ausfuehrung_name_en: "wo. Alu roof bar",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "391",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "745",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "391",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1442",
      ausfuehrung_name: "o. Alu-Dachleiste",
      ausfuehrung_name_en: "wo. Alu roof bar",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "391",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1443",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "391",
      ausfuehrung_aktiv: "1",
    },
  ],
  392: [
    {
      ausfuehrung_id: "746",
      ausfuehrung_name: "RXH, mit Reling",
      ausfuehrung_name_en: "RXH, mit Reling",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "392",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "747",
      ausfuehrung_name: "SW, mit Reling",
      ausfuehrung_name_en: "SW, with roof rails",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "392",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1650",
      ausfuehrung_name: "SW, mit Reling",
      ausfuehrung_name_en: "SW, with roof rails",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "392",
      ausfuehrung_aktiv: "1",
    },
  ],
  393: [
    {
      ausfuehrung_id: "748",
      ausfuehrung_name: "C-Schiene",
      ausfuehrung_name_en: "C-with rail",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "393",
      ausfuehrung_aktiv: "1",
    },
  ],
  394: [
    {
      ausfuehrung_id: "749",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "394",
      ausfuehrung_aktiv: "1",
    },
  ],
  395: [
    {
      ausfuehrung_id: "750",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "395",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1155",
      ausfuehrung_name: "Normal und Mittelhochdach",
      ausfuehrung_name_en: "normal and medium high roof",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "395",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1176",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "395",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1444",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "395",
      ausfuehrung_aktiv: "1",
    },
  ],
  396: [
    {
      ausfuehrung_id: "751",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "396",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1445",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "396",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1446",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "396",
      ausfuehrung_aktiv: "1",
    },
  ],
  397: [
    {
      ausfuehrung_id: "752",
      ausfuehrung_name: "Flachdach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "397",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "753",
      ausfuehrung_name: "Hochdach mittel",
      ausfuehrung_name_en: "high roof medium",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "397",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1149",
      ausfuehrung_name: "Hochdach hoch",
      ausfuehrung_name_en: "high roof high",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "397",
      ausfuehrung_aktiv: "1",
    },
  ],
  398: [
    {
      ausfuehrung_id: "754",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "398",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "755",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "398",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "756",
      ausfuehrung_name: "Family, mit Reling",
      ausfuehrung_name_en: "Family, with roof rails",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "398",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "757",
      ausfuehrung_name: "Tepee, ohne Zenitdach, mit Reling",
      ausfuehrung_name_en: "Tepee, wo. zenith roof, with roof rail",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "398",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1447",
      ausfuehrung_name: "Tepee, mit Zenitdach und Reling",
      ausfuehrung_name_en: "Tepee, with zenith roof and roof rails",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "398",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1651",
      ausfuehrung_name: "Tepee, mit Reling",
      ausfuehrung_name_en: "Tepee, with roof rails",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "398",
      ausfuehrung_aktiv: "1",
    },
  ],
  399: [
    {
      ausfuehrung_id: "758",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "399",
      ausfuehrung_aktiv: "1",
    },
  ],
  400: [
    {
      ausfuehrung_id: "759",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "31",
      ausfuehrung_modell_id: "400",
      ausfuehrung_aktiv: "1",
    },
  ],
  401: [
    {
      ausfuehrung_id: "760",
      ausfuehrung_name: "Regenrinne",
      ausfuehrung_name_en: "rain gutter",
      ausfuehrung_hersteller_id: "32",
      ausfuehrung_modell_id: "401",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "761",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "32",
      ausfuehrung_modell_id: "401",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "762",
      ausfuehrung_name: "Off-road Fahrzeuge, mit Gerätehalterung",
      ausfuehrung_name_en: "Off-road Cars with device holder",
      ausfuehrung_hersteller_id: "32",
      ausfuehrung_modell_id: "401",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "763",
      ausfuehrung_name: "Stufenheck",
      ausfuehrung_name_en: "notchback",
      ausfuehrung_hersteller_id: "32",
      ausfuehrung_modell_id: "401",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "764",
      ausfuehrung_name: "Van/Transporter",
      ausfuehrung_name_en: "van/transporter",
      ausfuehrung_hersteller_id: "32",
      ausfuehrung_modell_id: "401",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "765",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "32",
      ausfuehrung_modell_id: "401",
      ausfuehrung_aktiv: "1",
    },
  ],
  402: [
    {
      ausfuehrung_id: "766",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "33",
      ausfuehrung_modell_id: "402",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1448",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "33",
      ausfuehrung_modell_id: "402",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1449",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "33",
      ausfuehrung_modell_id: "402",
      ausfuehrung_aktiv: "1",
    },
  ],
  403: [
    {
      ausfuehrung_id: "767",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "403",
      ausfuehrung_aktiv: "1",
    },
  ],
  404: [
    {
      ausfuehrung_id: "768",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "404",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1676",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "404",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1692",
      ausfuehrung_name: "ohne Reling",
      ausfuehrung_name_en: "without roof rails",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "404",
      ausfuehrung_aktiv: "1",
    },
  ],
  405: [
    {
      ausfuehrung_id: "769",
      ausfuehrung_name: "4-türig",
      ausfuehrung_name_en: "4 doors",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "405",
      ausfuehrung_aktiv: "1",
    },
  ],
  406: [
    {
      ausfuehrung_id: "770",
      ausfuehrung_name: "Grandtour, mir Reling",
      ausfuehrung_name_en: "Grandtour, with roof rails",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "406",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "771",
      ausfuehrung_name: "Grandtour mit Reling",
      ausfuehrung_name_en: "Grandtour with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "406",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "772",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "406",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "773",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "406",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1450",
      ausfuehrung_name: "Grandtour mit Reling",
      ausfuehrung_name_en: "Grandtour with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "406",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1451",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "406",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1452",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "406",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1453",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "406",
      ausfuehrung_aktiv: "1",
    },
  ],
  407: [
    {
      ausfuehrung_id: "774",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "407",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "775",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "407",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "776",
      ausfuehrung_name: "C-Schiene",
      ausfuehrung_name_en: "C-with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "407",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1454",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "407",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1455",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "407",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1456",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "407",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1764",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "407",
      ausfuehrung_aktiv: "1",
    },
  ],
  408: [
    {
      ausfuehrung_id: "777",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "408",
      ausfuehrung_aktiv: "1",
    },
  ],
  409: [
    {
      ausfuehrung_id: "778",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "409",
      ausfuehrung_aktiv: "1",
    },
  ],
  410: [
    {
      ausfuehrung_id: "779",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "410",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1457",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "410",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1652",
      ausfuehrung_name: "XXL (für Panoramadach geeignet)",
      ausfuehrung_name_en: "XXL (panoramic roof suitable)",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "410",
      ausfuehrung_aktiv: "1",
    },
  ],
  411: [
    {
      ausfuehrung_id: "780",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "411",
      ausfuehrung_aktiv: "1",
    },
  ],
  412: [
    {
      ausfuehrung_id: "781",
      ausfuehrung_name: "(auch für lange Version)",
      ausfuehrung_name_en: "(for long version also)",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "412",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "782",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "412",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1177",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "412",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1737",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "412",
      ausfuehrung_aktiv: "1",
    },
  ],
  413: [
    {
      ausfuehrung_id: "783",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "413",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1458",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "413",
      ausfuehrung_aktiv: "1",
    },
  ],
  414: [
    {
      ausfuehrung_id: "784",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "414",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "785",
      ausfuehrung_name: "Grandtour",
      ausfuehrung_name_en: "Grandtour",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "414",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "786",
      ausfuehrung_name: "Grandtour mit Reling",
      ausfuehrung_name_en: "Grandtour with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "414",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1459",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "414",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1460",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "414",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1461",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "414",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1462",
      ausfuehrung_name: "Grandtour",
      ausfuehrung_name_en: "Grandtour",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "414",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1463",
      ausfuehrung_name: "Grandtour mit Reling",
      ausfuehrung_name_en: "Grandtour with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "414",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1464",
      ausfuehrung_name: "Grandtour mit Reling",
      ausfuehrung_name_en: "Grandtour with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "414",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1465",
      ausfuehrung_name: "Grandtour mit Reling",
      ausfuehrung_name_en: "Grandtour with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "414",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1466",
      ausfuehrung_name: "Grandtour mit Reling",
      ausfuehrung_name_en: "Grandtour with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "414",
      ausfuehrung_aktiv: "1",
    },
  ],
  415: [
    {
      ausfuehrung_id: "787",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "415",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "788",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "415",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "789",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "415",
      ausfuehrung_aktiv: "1",
    },
  ],
  416: [
    {
      ausfuehrung_id: "790",
      ausfuehrung_name: "3/5-türig",
      ausfuehrung_name_en: "3/5 doors",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "416",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "791",
      ausfuehrung_name: "Schrägheck, 5-türig",
      ausfuehrung_name_en: "hatchback, 5 doors",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "416",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "792",
      ausfuehrung_name: "Grand Scenic XXL",
      ausfuehrung_name_en: "Grand Scenic XXL",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "416",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "793",
      ausfuehrung_name: "Grandtour mit Reling",
      ausfuehrung_name_en: "Grandtour with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "416",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "794",
      ausfuehrung_name: "RS",
      ausfuehrung_name_en: "RS",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "416",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "795",
      ausfuehrung_name: "Scenic",
      ausfuehrung_name_en: "Scenic",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "416",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "796",
      ausfuehrung_name: "4/5-türig",
      ausfuehrung_name_en: "4/5 doors",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "416",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1467",
      ausfuehrung_name: "Grandtour mit Reling",
      ausfuehrung_name_en: "Grandtour with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "416",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1468",
      ausfuehrung_name: "RS",
      ausfuehrung_name_en: "RS",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "416",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1469",
      ausfuehrung_name: "Scenic",
      ausfuehrung_name_en: "Scenic",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "416",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1470",
      ausfuehrung_name: "Limousine, 5-türig",
      ausfuehrung_name_en: "Limousine, 5 doors",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "416",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1653",
      ausfuehrung_name: "Scenic Conquest, mit Reling",
      ausfuehrung_name_en: "Scenic Conquest, with roof rails",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "416",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1757",
      ausfuehrung_name: "E-Tech",
      ausfuehrung_name_en: "E-Tech",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "416",
      ausfuehrung_aktiv: "1",
    },
  ],
  417: [
    {
      ausfuehrung_id: "797",
      ausfuehrung_name: "(für Glasdach geeignet)",
      ausfuehrung_name_en: "(glas roof suitable)",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "417",
      ausfuehrung_aktiv: "1",
    },
  ],
  418: [
    {
      ausfuehrung_id: "798",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "418",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "799",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "418",
      ausfuehrung_aktiv: "1",
    },
  ],
  419: [
    {
      ausfuehrung_id: "800",
      ausfuehrung_name: "Nevada",
      ausfuehrung_name_en: "Nevada",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "419",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "801",
      ausfuehrung_name: "Nevada mit Reling",
      ausfuehrung_name_en: "Nevada with rail",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "419",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "802",
      ausfuehrung_name: "Limousine/Kombi",
      ausfuehrung_name_en: "Limousine/Station Wagon",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "419",
      ausfuehrung_aktiv: "1",
    },
  ],
  420: [
    {
      ausfuehrung_id: "803",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "420",
      ausfuehrung_aktiv: "1",
    },
  ],
  421: [
    {
      ausfuehrung_id: "804",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "421",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "805",
      ausfuehrung_name: "Leiterklappe 3. Bügel Fahrerhaus",
      ausfuehrung_name_en: "ladder flap 3rd bracket over cabin",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "421",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "806",
      ausfuehrung_name: "o. Leiterklappe 3. Bügel Fahrerhaus",
      ausfuehrung_name_en: "wo. ladder flap 3rd bracket over cabin",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "421",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "807",
      ausfuehrung_name: "mit Reling ",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "421",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "808",
      ausfuehrung_name: "mit und o. Leiterklappe",
      ausfuehrung_name_en: "w. and wo. ladder flap",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "421",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "809",
      ausfuehrung_name: "o. Ladeluke",
      ausfuehrung_name_en: "wo. Hatch",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "421",
      ausfuehrung_aktiv: "1",
    },
  ],
  422: [
    {
      ausfuehrung_id: "810",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "422",
      ausfuehrung_aktiv: "1",
    },
  ],
  423: [
    {
      ausfuehrung_id: "811",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "423",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "812",
      ausfuehrung_name: "XL (Panoramadach geeignet)",
      ausfuehrung_name_en: "XL (panoramic roof suitable)",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "423",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "813",
      ausfuehrung_name: "XMOD, mit Reling",
      ausfuehrung_name_en: "XMOD, with roof rails",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "423",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1471",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "423",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1472",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "423",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1473",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "423",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1474",
      ausfuehrung_name: "XL",
      ausfuehrung_name_en: "XL",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "423",
      ausfuehrung_aktiv: "1",
    },
  ],
  424: [
    {
      ausfuehrung_id: "814",
      ausfuehrung_name: "Grandtour, mit Reling",
      ausfuehrung_name_en: "Grandtour, with roof rails",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "424",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "815",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "424",
      ausfuehrung_aktiv: "1",
    },
  ],
  425: [
    {
      ausfuehrung_id: "816",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "425",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "817",
      ausfuehrung_name: "Flachdach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "425",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1163",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "425",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1475",
      ausfuehrung_name: "(H1, L1, L2 - eine Trägerbrücke)",
      ausfuehrung_name_en: "(H1, L1, L2 - one bridge)",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "425",
      ausfuehrung_aktiv: "1",
    },
  ],
  426: [
    {
      ausfuehrung_id: "818",
      ausfuehrung_name: "(Faltdach geeignet)",
      ausfuehrung_name_en: "(folding roof suitable)",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "426",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "819",
      ausfuehrung_name: "ohne Glasschiebedach",
      ausfuehrung_name_en: "wo. glass sliding roof",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "426",
      ausfuehrung_aktiv: "1",
    },
  ],
  427: [
    {
      ausfuehrung_id: "820",
      ausfuehrung_name: "Tourer",
      ausfuehrung_name_en: "Tourer",
      ausfuehrung_hersteller_id: "35",
      ausfuehrung_modell_id: "427",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1476",
      ausfuehrung_name: "Tourer",
      ausfuehrung_name_en: "Tourer",
      ausfuehrung_hersteller_id: "35",
      ausfuehrung_modell_id: "427",
      ausfuehrung_aktiv: "1",
    },
  ],
  428: [
    {
      ausfuehrung_id: "821",
      ausfuehrung_name: "Freelander",
      ausfuehrung_name_en: "Freelander",
      ausfuehrung_hersteller_id: "35",
      ausfuehrung_modell_id: "428",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "822",
      ausfuehrung_name: "Freelander mit Reling",
      ausfuehrung_name_en: "Freelander with rail",
      ausfuehrung_hersteller_id: "35",
      ausfuehrung_modell_id: "428",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1477",
      ausfuehrung_name: "Freelander mit Reling",
      ausfuehrung_name_en: "Freelander with rail",
      ausfuehrung_hersteller_id: "35",
      ausfuehrung_modell_id: "428",
      ausfuehrung_aktiv: "1",
    },
  ],
  429: [
    {
      ausfuehrung_id: "823",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "35",
      ausfuehrung_modell_id: "429",
      ausfuehrung_aktiv: "1",
    },
  ],
  430: [
    {
      ausfuehrung_id: "824",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "35",
      ausfuehrung_modell_id: "430",
      ausfuehrung_aktiv: "1",
    },
  ],
  431: [
    {
      ausfuehrung_id: "825",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "35",
      ausfuehrung_modell_id: "431",
      ausfuehrung_aktiv: "1",
    },
  ],
  432: [
    {
      ausfuehrung_id: "826",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "35",
      ausfuehrung_modell_id: "432",
      ausfuehrung_aktiv: "1",
    },
  ],
  433: [
    {
      ausfuehrung_id: "827",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "35",
      ausfuehrung_modell_id: "433",
      ausfuehrung_aktiv: "1",
    },
  ],
  434: [
    {
      ausfuehrung_id: "828",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "35",
      ausfuehrung_modell_id: "434",
      ausfuehrung_aktiv: "1",
    },
  ],
  435: [
    {
      ausfuehrung_id: "829",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "36",
      ausfuehrung_modell_id: "435",
      ausfuehrung_aktiv: "1",
    },
  ],
  436: [
    {
      ausfuehrung_id: "830",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "36",
      ausfuehrung_modell_id: "436",
      ausfuehrung_aktiv: "1",
    },
  ],
  437: [
    {
      ausfuehrung_id: "831",
      ausfuehrung_name: "SportCombi",
      ausfuehrung_name_en: "SportCombi",
      ausfuehrung_hersteller_id: "36",
      ausfuehrung_modell_id: "437",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "832",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "36",
      ausfuehrung_modell_id: "437",
      ausfuehrung_aktiv: "1",
    },
  ],
  438: [
    {
      ausfuehrung_id: "833",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "36",
      ausfuehrung_modell_id: "438",
      ausfuehrung_aktiv: "1",
    },
  ],
  439: [
    {
      ausfuehrung_id: "834",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "439",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "835",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "439",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1478",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "439",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1479",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "439",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1480",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "439",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1481",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "439",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1482",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "439",
      ausfuehrung_aktiv: "1",
    },
  ],
  440: [
    {
      ausfuehrung_id: "836",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "440",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "837",
      ausfuehrung_name: "Freetrack, mit Reling",
      ausfuehrung_name_en: "Freetrack, with roof rails",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "440",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "838",
      ausfuehrung_name: "XL, mit Reling",
      ausfuehrung_name_en: "XL, with roof rails",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "440",
      ausfuehrung_aktiv: "1",
    },
  ],
  441: [
    {
      ausfuehrung_id: "839",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "441",
      ausfuehrung_aktiv: "1",
    },
  ],
  442: [
    {
      ausfuehrung_id: "840",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "442",
      ausfuehrung_aktiv: "1",
    },
  ],
  443: [
    {
      ausfuehrung_id: "841",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "443",
      ausfuehrung_aktiv: "1",
    },
  ],
  444: [
    {
      ausfuehrung_id: "842",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "444",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "843",
      ausfuehrung_name: "Vario",
      ausfuehrung_name_en: "Vario",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "444",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "844",
      ausfuehrung_name: "Vario",
      ausfuehrung_name_en: "Vario",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "444",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1483",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "444",
      ausfuehrung_aktiv: "1",
    },
  ],
  445: [
    {
      ausfuehrung_id: "845",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "445",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "846",
      ausfuehrung_name: "ST, mit Reling",
      ausfuehrung_name_en: "ST, with roof rails",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "445",
      ausfuehrung_aktiv: "1",
    },
  ],
  446: [
    {
      ausfuehrung_id: "847",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "446",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "848",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "446",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "849",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "446",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "850",
      ausfuehrung_name: "ST, mit Reling",
      ausfuehrung_name_en: "ST, with roof rails",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "446",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "851",
      ausfuehrung_name: "3/5-türig",
      ausfuehrung_name_en: "3/5 doors",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "446",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1484",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "446",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1485",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "446",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1486",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "446",
      ausfuehrung_aktiv: "1",
    },
  ],
  447: [
    {
      ausfuehrung_id: "852",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "447",
      ausfuehrung_aktiv: "1",
    },
  ],
  448: [
    {
      ausfuehrung_id: "853",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "448",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "854",
      ausfuehrung_name: "SC, 3-türig",
      ausfuehrung_name_en: "SC, 3 doors",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "448",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "855",
      ausfuehrung_name: "ST, mit Reling",
      ausfuehrung_name_en: "ST, with roof rails",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "448",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "856",
      ausfuehrung_name: "ST X-Perience, mit Reling",
      ausfuehrung_name_en: "ST X-Perience, with roof rails",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "448",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1487",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "448",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1488",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "448",
      ausfuehrung_aktiv: "1",
    },
  ],
  449: [
    {
      ausfuehrung_id: "857",
      ausfuehrung_name: "F57",
      ausfuehrung_name_en: "F57",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "449",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "858",
      ausfuehrung_name: "F58",
      ausfuehrung_name_en: "F58",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "449",
      ausfuehrung_aktiv: "1",
    },
  ],
  450: [
    {
      ausfuehrung_id: "859",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "450",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "860",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "450",
      ausfuehrung_aktiv: "1",
    },
  ],
  451: [
    {
      ausfuehrung_id: "861",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "451",
      ausfuehrung_aktiv: "1",
    },
  ],
  452: [
    {
      ausfuehrung_id: "862",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "452",
      ausfuehrung_aktiv: "1",
    },
  ],
  453: [
    {
      ausfuehrung_id: "863",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "453",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1489",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "453",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1490",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "453",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1491",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "453",
      ausfuehrung_aktiv: "1",
    },
  ],
  454: [
    {
      ausfuehrung_id: "864",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "454",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "865",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "454",
      ausfuehrung_aktiv: "1",
    },
  ],
  455: [
    {
      ausfuehrung_id: "866",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "455",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "867",
      ausfuehrung_name: "Kombi o. Reling",
      ausfuehrung_name_en: "Station Wagon wo. rail",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "455",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "868",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "455",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "869",
      ausfuehrung_name: "Limousine, 5-türig",
      ausfuehrung_name_en: "Limousine, 5 doors",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "455",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1492",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "455",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1493",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "455",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1494",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "455",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1495",
      ausfuehrung_name: "Limousine, 5-türig",
      ausfuehrung_name_en: "Limousine, 5 doors",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "455",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1496",
      ausfuehrung_name: "Limousine, 5-türig",
      ausfuehrung_name_en: "Limousine, 5 doors",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "455",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1742",
      ausfuehrung_name: "Limousine, 5-türig",
      ausfuehrung_name_en: "Limousine, 5 doors",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "455",
      ausfuehrung_aktiv: "1",
    },
  ],
  456: [
    {
      ausfuehrung_id: "870",
      ausfuehrung_name: "135L",
      ausfuehrung_name_en: "135L",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "456",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "871",
      ausfuehrung_name: "136L",
      ausfuehrung_name_en: "136L",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "456",
      ausfuehrung_aktiv: "1",
    },
  ],
  457: [
    {
      ausfuehrung_id: "872",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "457",
      ausfuehrung_aktiv: "1",
    },
  ],
  458: [
    {
      ausfuehrung_id: "873",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "458",
      ausfuehrung_aktiv: "1",
    },
  ],
  459: [
    {
      ausfuehrung_id: "874",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "459",
      ausfuehrung_aktiv: "1",
    },
  ],
  460: [
    {
      ausfuehrung_id: "875",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "460",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "876",
      ausfuehrung_name: "Sportline, mit Reling",
      ausfuehrung_name_en: "Sportline, with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "460",
      ausfuehrung_aktiv: "1",
    },
  ],
  461: [
    {
      ausfuehrung_id: "877",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "461",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "878",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "461",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "879",
      ausfuehrung_name: "Kombi RS, mit Reling",
      ausfuehrung_name_en: "Station Wagon RS, with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "461",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "880",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "461",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "881",
      ausfuehrung_name: "Limousine RS",
      ausfuehrung_name_en: "Limousine RS",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "461",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "882",
      ausfuehrung_name: "Scout Kombi, mit Reling",
      ausfuehrung_name_en: "Scout Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "461",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "883",
      ausfuehrung_name: "Kombi o. Reling",
      ausfuehrung_name_en: "Station Wagon wo. rail",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "461",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1497",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "461",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1498",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "461",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1499",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "461",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1500",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "461",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1501",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "461",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1502",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "461",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1655",
      ausfuehrung_name: "Limousine, RS",
      ausfuehrung_name_en: "Limousine, RS",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "461",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1693",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Estate, with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "461",
      ausfuehrung_aktiv: "1",
    },
  ],
  462: [
    {
      ausfuehrung_id: "884",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "462",
      ausfuehrung_aktiv: "1",
    },
  ],
  463: [
    {
      ausfuehrung_id: "885",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "463",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "886",
      ausfuehrung_name: "Spaceback",
      ausfuehrung_name_en: "Spaceback",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "463",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "887",
      ausfuehrung_name: "Spaceback Scout",
      ausfuehrung_name_en: "Spaceback Scout",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "463",
      ausfuehrung_aktiv: "1",
    },
  ],
  464: [
    {
      ausfuehrung_id: "888",
      ausfuehrung_name: "mit Reling ",
      ausfuehrung_name_en: "with roof rails ",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "464",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1503",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "464",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1656",
      ausfuehrung_name: "Scout, mit Reling",
      ausfuehrung_name_en: "Scout, with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "464",
      ausfuehrung_aktiv: "1",
    },
  ],
  465: [
    {
      ausfuehrung_id: "889",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "465",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "890",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "465",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1504",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "465",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1505",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "465",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1506",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "465",
      ausfuehrung_aktiv: "1",
    },
  ],
  466: [
    {
      ausfuehrung_id: "891",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "466",
      ausfuehrung_aktiv: "1",
    },
  ],
  467: [
    {
      ausfuehrung_id: "892",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "39",
      ausfuehrung_modell_id: "467",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1658",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "39",
      ausfuehrung_modell_id: "467",
      ausfuehrung_aktiv: "1",
    },
  ],
  468: [
    {
      ausfuehrung_id: "893",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "39",
      ausfuehrung_modell_id: "468",
      ausfuehrung_aktiv: "1",
    },
  ],
  469: [
    {
      ausfuehrung_id: "894",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "39",
      ausfuehrung_modell_id: "469",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "895",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "39",
      ausfuehrung_modell_id: "469",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "896",
      ausfuehrung_name: "mit Reling Sport",
      ausfuehrung_name_en: "with rail Sport",
      ausfuehrung_hersteller_id: "39",
      ausfuehrung_modell_id: "469",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1507",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "39",
      ausfuehrung_modell_id: "469",
      ausfuehrung_aktiv: "1",
    },
  ],
  470: [
    {
      ausfuehrung_id: "897",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "39",
      ausfuehrung_modell_id: "470",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1508",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "39",
      ausfuehrung_modell_id: "470",
      ausfuehrung_aktiv: "1",
    },
  ],
  471: [
    {
      ausfuehrung_id: "898",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "39",
      ausfuehrung_modell_id: "471",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1509",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "39",
      ausfuehrung_modell_id: "471",
      ausfuehrung_aktiv: "1",
    },
  ],
  472: [
    {
      ausfuehrung_id: "899",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "39",
      ausfuehrung_modell_id: "472",
      ausfuehrung_aktiv: "1",
    },
  ],
  473: [
    {
      ausfuehrung_id: "900",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "473",
      ausfuehrung_aktiv: "1",
    },
  ],
  474: [
    {
      ausfuehrung_id: "901",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "474",
      ausfuehrung_aktiv: "1",
    },
  ],
  475: [
    {
      ausfuehrung_id: "902",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "475",
      ausfuehrung_aktiv: "1",
    },
  ],
  476: [
    {
      ausfuehrung_id: "903",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "476",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "904",
      ausfuehrung_name: "o. Heckspoiler",
      ausfuehrung_name_en: "wo. Spoiler",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "476",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1510",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "476",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1511",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "476",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1659",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "476",
      ausfuehrung_aktiv: "1",
    },
  ],
  477: [
    {
      ausfuehrung_id: "905",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "477",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "906",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "477",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "907",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "477",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1512",
      ausfuehrung_name: "(V)",
      ausfuehrung_name_en: "(V)",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "477",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1513",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "477",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1514",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "477",
      ausfuehrung_aktiv: "1",
    },
  ],
  478: [
    {
      ausfuehrung_id: "908",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "478",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "909",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "478",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "910",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "478",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1660",
      ausfuehrung_name: "G3X, mit Reling",
      ausfuehrung_name_en: "G3X, with roof rails",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "478",
      ausfuehrung_aktiv: "1",
    },
  ],
  479: [
    {
      ausfuehrung_id: "911",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "912",
      ausfuehrung_name: "Secan",
      ausfuehrung_name_en: "Sedan",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "913",
      ausfuehrung_name: "Station",
      ausfuehrung_name_en: "Station",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "914",
      ausfuehrung_name: "Station, mit Reling",
      ausfuehrung_name_en: "Station, with roof rails",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "915",
      ausfuehrung_name: "Super Station",
      ausfuehrung_name_en: "Super Station",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "916",
      ausfuehrung_name: "Super Station Outback",
      ausfuehrung_name_en: "Super Station Outback",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "917",
      ausfuehrung_name: "Super Station mit Reling",
      ausfuehrung_name_en: "Super Station with rail",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "918",
      ausfuehrung_name: "Sedan",
      ausfuehrung_name_en: "Sedan",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "919",
      ausfuehrung_name: "Super Station (L-Serie)",
      ausfuehrung_name_en: "Super Station (L-series)",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1515",
      ausfuehrung_name: "Station",
      ausfuehrung_name_en: "Station",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1516",
      ausfuehrung_name: "Station, mit Reling",
      ausfuehrung_name_en: "Station, with roof rails",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1517",
      ausfuehrung_name: "Super Station",
      ausfuehrung_name_en: "Super Station",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1518",
      ausfuehrung_name: "Super Station Outback",
      ausfuehrung_name_en: "Super Station Outback",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1519",
      ausfuehrung_name: "Super Station Outback",
      ausfuehrung_name_en: "Super Station Outback",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1520",
      ausfuehrung_name: "Super Station mit Reling",
      ausfuehrung_name_en: "Super Station with rail",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1521",
      ausfuehrung_name: "Super Station mit Reling",
      ausfuehrung_name_en: "Super Station with rail",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1661",
      ausfuehrung_name: "Outback, mit Reling",
      ausfuehrung_name_en: "Outback, with roof rails",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "479",
      ausfuehrung_aktiv: "1",
    },
  ],
  480: [
    {
      ausfuehrung_id: "920",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "480",
      ausfuehrung_aktiv: "1",
    },
  ],
  481: [
    {
      ausfuehrung_id: "921",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "481",
      ausfuehrung_aktiv: "1",
    },
  ],
  482: [
    {
      ausfuehrung_id: "922",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "482",
      ausfuehrung_aktiv: "1",
    },
  ],
  483: [
    {
      ausfuehrung_id: "923",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "483",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "924",
      ausfuehrung_name: "II (nicht für 1.6i Trend)",
      ausfuehrung_name_en: "II (not for 1.6i Trend)",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "483",
      ausfuehrung_aktiv: "1",
    },
  ],
  484: [
    {
      ausfuehrung_id: "925",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "484",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "926",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "484",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "927",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "484",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1522",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "484",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1523",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "484",
      ausfuehrung_aktiv: "1",
    },
  ],
  485: [
    {
      ausfuehrung_id: "928",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "485",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "929",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "485",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "930",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "485",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "931",
      ausfuehrung_name: "4-türig",
      ausfuehrung_name_en: "4 doors",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "485",
      ausfuehrung_aktiv: "1",
    },
  ],
  486: [
    {
      ausfuehrung_id: "932",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "486",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "933",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "486",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "934",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "486",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "935",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "486",
      ausfuehrung_aktiv: "1",
    },
  ],
  487: [
    {
      ausfuehrung_id: "936",
      ausfuehrung_name: "5-türig, mit Reling",
      ausfuehrung_name_en: "5 doors, with roof rails",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "487",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1524",
      ausfuehrung_name: "5-türig, mit Reling",
      ausfuehrung_name_en: "5 doors, with roof rails",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "487",
      ausfuehrung_aktiv: "1",
    },
  ],
  488: [
    {
      ausfuehrung_id: "937",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "488",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "938",
      ausfuehrung_name: "2WD",
      ausfuehrung_name_en: "2WD",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "488",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "939",
      ausfuehrung_name: "4WD, mit Reling",
      ausfuehrung_name_en: "4WD, with roof rails",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "488",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1662",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "488",
      ausfuehrung_aktiv: "1",
    },
  ],
  489: [
    {
      ausfuehrung_id: "940",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "489",
      ausfuehrung_aktiv: "1",
    },
  ],
  490: [
    {
      ausfuehrung_id: "941",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "490",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "942",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "490",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "943",
      ausfuehrung_name: "Stufenheck",
      ausfuehrung_name_en: "notchback",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "490",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1525",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "490",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1526",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "490",
      ausfuehrung_aktiv: "1",
    },
  ],
  491: [
    {
      ausfuehrung_id: "944",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "491",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "945",
      ausfuehrung_name: "S-Cross, mit Reling",
      ausfuehrung_name_en: "S-Cross, with roof rails",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "491",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1726",
      ausfuehrung_name: "S-Cross, mit Reling",
      ausfuehrung_name_en: "S-Cross, with roof rails",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "491",
      ausfuehrung_aktiv: "1",
    },
  ],
  492: [
    {
      ausfuehrung_id: "946",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "492",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "947",
      ausfuehrung_name: "ET",
      ausfuehrung_name_en: "ET",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "492",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "948",
      ausfuehrung_name: "Long",
      ausfuehrung_name_en: "Long",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "492",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "949",
      ausfuehrung_name: "TA",
      ausfuehrung_name_en: "TA",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "492",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "950",
      ausfuehrung_name: "X90",
      ausfuehrung_name_en: "X90",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "492",
      ausfuehrung_aktiv: "1",
    },
  ],
  493: [
    {
      ausfuehrung_id: "951",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "493",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1527",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "493",
      ausfuehrung_aktiv: "1",
    },
  ],
  494: [
    {
      ausfuehrung_id: "952",
      ausfuehrung_name: "Touring Sports, mit Reling",
      ausfuehrung_name_en: "Touring Sports, with roof rails",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "494",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "953",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "494",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1528",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "494",
      ausfuehrung_aktiv: "1",
    },
  ],
  495: [
    {
      ausfuehrung_id: "954",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "495",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "955",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "495",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "956",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "495",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "957",
      ausfuehrung_name: "Verso, mit Reling",
      ausfuehrung_name_en: "Verso, with roof rails",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "495",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1529",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "495",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1530",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "495",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1531",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "495",
      ausfuehrung_aktiv: "1",
    },
  ],
  496: [
    {
      ausfuehrung_id: "958",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "496",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1532",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "496",
      ausfuehrung_aktiv: "1",
    },
  ],
  497: [
    {
      ausfuehrung_id: "959",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "497",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "960",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "497",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "961",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "497",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "962",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "497",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1533",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "497",
      ausfuehrung_aktiv: "1",
    },
  ],
  498: [
    {
      ausfuehrung_id: "963",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "498",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "964",
      ausfuehrung_name: "1 + 2 Kombi (mit Reling DM 16 mm)",
      ausfuehrung_name_en: "1 + 2 Station Wagon (with rail dia. 16 mm)",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "498",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "965",
      ausfuehrung_name: "1 Kombi (mit Reling DM 16 mm)",
      ausfuehrung_name_en: "1 Station Wagon (with rail dia. 16 mm)",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "498",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "966",
      ausfuehrung_name: "2 Kombi (mit Reling DM 16 mm)",
      ausfuehrung_name_en: "2 Station Wagon (with rail dia. 16 mm)",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "498",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "967",
      ausfuehrung_name: "E Kombi",
      ausfuehrung_name_en: "E Station Wagon",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "498",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "968",
      ausfuehrung_name: "E Kombi mit Reling",
      ausfuehrung_name_en: "E Station Wagon with rail",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "498",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "969",
      ausfuehrung_name: "E Liftback",
      ausfuehrung_name_en: "E Liftback",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "498",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "970",
      ausfuehrung_name: "E Limousine",
      ausfuehrung_name_en: "E Limousine",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "498",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "971",
      ausfuehrung_name: "Kombi (mit Reling DM 16 mm)",
      ausfuehrung_name_en: "Station Wagon (with rail dia. 16 mm)",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "498",
      ausfuehrung_aktiv: "1",
    },
  ],
  499: [
    {
      ausfuehrung_id: "972",
      ausfuehrung_name: "Compact 3-türig",
      ausfuehrung_name_en: "Compact 3 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "973",
      ausfuehrung_name: "Compact 5-türig",
      ausfuehrung_name_en: "Compact 5 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "974",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "975",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "976",
      ausfuehrung_name: "Liftback 5-türig",
      ausfuehrung_name_en: "Liftback 5 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "977",
      ausfuehrung_name: "Limousine 4-türig",
      ausfuehrung_name_en: "Limousine 4 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "978",
      ausfuehrung_name: "Limousine 5-türig",
      ausfuehrung_name_en: "Limousine 5 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "979",
      ausfuehrung_name: "Verso",
      ausfuehrung_name_en: "Verso",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "980",
      ausfuehrung_name: "Verso o. Reling",
      ausfuehrung_name_en: "Verso wo. rail",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "981",
      ausfuehrung_name: "Verso, mit Reling",
      ausfuehrung_name_en: "Verso, with roof rails",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1534",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1535",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1536",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1537",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1538",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1539",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1663",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1664",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1665",
      ausfuehrung_name: "Touring Sports, mit Reling",
      ausfuehrung_name_en: "Touring Sports, with roof rails",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "499",
      ausfuehrung_aktiv: "1",
    },
  ],
  500: [
    {
      ausfuehrung_id: "982",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "500",
      ausfuehrung_aktiv: "1",
    },
  ],
  501: [
    {
      ausfuehrung_id: "983",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "501",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "984",
      ausfuehrung_name: "J15",
      ausfuehrung_name_en: "J15",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "501",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "985",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "501",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1540",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "501",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1666",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "501",
      ausfuehrung_aktiv: "1",
    },
  ],
  502: [
    {
      ausfuehrung_id: "986",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "502",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "987",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "502",
      ausfuehrung_aktiv: "1",
    },
  ],
  503: [
    {
      ausfuehrung_id: "988",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "503",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "989",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "503",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1541",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "503",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1542",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "503",
      ausfuehrung_aktiv: "1",
    },
  ],
  504: [
    {
      ausfuehrung_id: "990",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "504",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "991",
      ausfuehrung_name: "Verso",
      ausfuehrung_name_en: "Verso",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "504",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1543",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "504",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1544",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "504",
      ausfuehrung_aktiv: "1",
    },
  ],
  505: [
    {
      ausfuehrung_id: "992",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "505",
      ausfuehrung_aktiv: "1",
    },
  ],
  506: [
    {
      ausfuehrung_id: "993",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "506",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "994",
      ausfuehrung_name: "3/5-türig",
      ausfuehrung_name_en: "3/5 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "506",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "995",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "506",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "996",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "506",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1545",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "506",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1546",
      ausfuehrung_name: "3/5-türig",
      ausfuehrung_name_en: "3/5 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "506",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1547",
      ausfuehrung_name: "3 und 5-türig",
      ausfuehrung_name_en: "3 and 5 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "506",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1548",
      ausfuehrung_name: "mit Nachrüst Reling",
      ausfuehrung_name_en: "with retrofitted rail",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "506",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1549",
      ausfuehrung_name: "3 und 5-türig, mit Reling",
      ausfuehrung_name_en: "3 and 5 doors, with roof rails",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "506",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1667",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "506",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1668",
      ausfuehrung_name: "Edition S, mit Reling",
      ausfuehrung_name_en: "Edition S, with roof rails",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "506",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1669",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "506",
      ausfuehrung_aktiv: "1",
    },
  ],
  507: [
    {
      ausfuehrung_id: "997",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "507",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "998",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "507",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1670",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "507",
      ausfuehrung_aktiv: "1",
    },
  ],
  508: [
    {
      ausfuehrung_id: "999",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "508",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1000",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "508",
      ausfuehrung_aktiv: "1",
    },
  ],
  509: [
    {
      ausfuehrung_id: "1001",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "509",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1002",
      ausfuehrung_name: "S (nicht für Glasdach)",
      ausfuehrung_name_en: "S (not for glass roof)",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "509",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1550",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "509",
      ausfuehrung_aktiv: "1",
    },
  ],
  510: [
    {
      ausfuehrung_id: "1003",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "510",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1004",
      ausfuehrung_name: "Verso, mit Reling",
      ausfuehrung_name_en: "Verso, with roof rails",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "510",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1005",
      ausfuehrung_name: "Verso, mit Reling",
      ausfuehrung_name_en: "Verso, with rail",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "510",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1551",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "510",
      ausfuehrung_aktiv: "1",
    },
  ],
  511: [
    {
      ausfuehrung_id: "1006",
      ausfuehrung_name: "Double Cab",
      ausfuehrung_name_en: "Double Cab",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "511",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1760",
      ausfuehrung_name: "Amarok mit Reling ",
      ausfuehrung_name_en: "Amarok with roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "511",
      ausfuehrung_aktiv: "1",
    },
  ],
  512: [
    {
      ausfuehrung_id: "1007",
      ausfuehrung_name: "(3H)",
      ausfuehrung_name_en: "(3H)",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "512",
      ausfuehrung_aktiv: "1",
    },
  ],
  513: [
    {
      ausfuehrung_id: "1008",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "513",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1009",
      ausfuehrung_name: "Variant",
      ausfuehrung_name_en: "Variant",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "513",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1010",
      ausfuehrung_name: "Variant, mit Reling",
      ausfuehrung_name_en: "Estate, with roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "513",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1552",
      ausfuehrung_name: "Variant",
      ausfuehrung_name_en: "Variant",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "513",
      ausfuehrung_aktiv: "1",
    },
  ],
  514: [
    {
      ausfuehrung_id: "1011",
      ausfuehrung_name: "III, mit Reling",
      ausfuehrung_name_en: "III, with roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "514",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1012",
      ausfuehrung_name: "III, ohne Reling",
      ausfuehrung_name_en: "III, wo. roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "514",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1013",
      ausfuehrung_name: "II",
      ausfuehrung_name_en: "II",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "514",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1014",
      ausfuehrung_name: "IV, mit Reling (auch Maxi und Alltrack)",
      ausfuehrung_name_en: "IV, with roof rails (Maxi and Alltrack also)",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "514",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1015",
      ausfuehrung_name: "IV, ohne Reling",
      ausfuehrung_name_en: "IV, wo. roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "514",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1016",
      ausfuehrung_name: "Alltrack IV, mit Reling",
      ausfuehrung_name_en: "Alltrack IV, with roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "514",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1017",
      ausfuehrung_name: "2",
      ausfuehrung_name_en: "2",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "514",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1018",
      ausfuehrung_name: "Maxi III, ohne Reling",
      ausfuehrung_name_en: "Maxi III,  wo. roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "514",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1019",
      ausfuehrung_name: "Maxi IV, mit Reling",
      ausfuehrung_name_en: "Maxi IV, with roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "514",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1020",
      ausfuehrung_name: "Maxi IV, ohne Reling",
      ausfuehrung_name_en: "Maxi IV, wo. roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "514",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1703",
      ausfuehrung_name: "V, mit Reling",
      ausfuehrung_name_en: "V, with roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "514",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1747",
      ausfuehrung_name: "V, ohne Reling",
      ausfuehrung_name_en: "V, without roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "514",
      ausfuehrung_aktiv: "1",
    },
  ],
  515: [
    {
      ausfuehrung_id: "1021",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "515",
      ausfuehrung_aktiv: "1",
    },
  ],
  516: [
    {
      ausfuehrung_id: "1022",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "516",
      ausfuehrung_aktiv: "1",
    },
  ],
  517: [
    {
      ausfuehrung_id: "1023",
      ausfuehrung_name: "Normal-/Hochdach C-Schiene",
      ausfuehrung_name_en: "normal/high roof C-with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "517",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1151",
      ausfuehrung_name: "Hochdach mit C-Schiene",
      ausfuehrung_name_en: "high roof with c-with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "517",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1164",
      ausfuehrung_name: "Normaldach mit C-Schiene",
      ausfuehrung_name_en: "normal roof with c-with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "517",
      ausfuehrung_aktiv: "1",
    },
  ],
  518: [
    {
      ausfuehrung_id: "1024",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "518",
      ausfuehrung_aktiv: "1",
    },
  ],
  519: [
    {
      ausfuehrung_id: "1025",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "519",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1553",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "519",
      ausfuehrung_aktiv: "1",
    },
  ],
  520: [
    {
      ausfuehrung_id: "1026",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "520",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1027",
      ausfuehrung_name: "Variant",
      ausfuehrung_name_en: "Variant",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "520",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1028",
      ausfuehrung_name: "Variant, ohne Reling",
      ausfuehrung_name_en: "Estate, wo. roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "520",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1029",
      ausfuehrung_name: "Variant mit Reling",
      ausfuehrung_name_en: "Variant with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "520",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1030",
      ausfuehrung_name: "Vento",
      ausfuehrung_name_en: "Vento",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "520",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1554",
      ausfuehrung_name: "Variant mit Reling",
      ausfuehrung_name_en: "Variant with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "520",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1555",
      ausfuehrung_name: "2/4-türig",
      ausfuehrung_name_en: "2/4 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "520",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1674",
      ausfuehrung_name: "Variant, mit Reling",
      ausfuehrung_name_en: "Estate, with roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "520",
      ausfuehrung_aktiv: "1",
    },
  ],
  521: [
    {
      ausfuehrung_id: "1031",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "521",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1032",
      ausfuehrung_name: "Variant",
      ausfuehrung_name_en: "Variant",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "521",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1033",
      ausfuehrung_name: "Variant mit Reling",
      ausfuehrung_name_en: "Variant with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "521",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1034",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "521",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1035",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "521",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1556",
      ausfuehrung_name: "Variant",
      ausfuehrung_name_en: "Variant",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "521",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1557",
      ausfuehrung_name: "Variant, mit Reling",
      ausfuehrung_name_en: "Estate, with roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "521",
      ausfuehrung_aktiv: "1",
    },
  ],
  522: [
    {
      ausfuehrung_id: "1036",
      ausfuehrung_name: "Sportsvan o. Reling",
      ausfuehrung_name_en: "Sportsvan wo. rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "522",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1037",
      ausfuehrung_name: "Sportsvan mit Reling",
      ausfuehrung_name_en: "Sportsvan with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "522",
      ausfuehrung_aktiv: "1",
    },
  ],
  523: [
    {
      ausfuehrung_id: "1038",
      ausfuehrung_name: "Cross, mit Reling",
      ausfuehrung_name_en: "Cross, with roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "523",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1039",
      ausfuehrung_name: "Plus",
      ausfuehrung_name_en: "Plus",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "523",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1040",
      ausfuehrung_name: "Plus, o. Reling",
      ausfuehrung_name_en: "Plus, wo. roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "523",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1041",
      ausfuehrung_name: "Plus, mit Reling",
      ausfuehrung_name_en: "Plus, with roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "523",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1042",
      ausfuehrung_name: "Variant, mit Reling",
      ausfuehrung_name_en: "Estate, with roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "523",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1043",
      ausfuehrung_name: "3/5-türig",
      ausfuehrung_name_en: "3/5 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "523",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1558",
      ausfuehrung_name: "Plus",
      ausfuehrung_name_en: "Plus",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "523",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1559",
      ausfuehrung_name: "Variant",
      ausfuehrung_name_en: "Variant",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "523",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1560",
      ausfuehrung_name: "3 und 5-türig",
      ausfuehrung_name_en: "3 and 5 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "523",
      ausfuehrung_aktiv: "1",
    },
  ],
  524: [
    {
      ausfuehrung_id: "1044",
      ausfuehrung_name: "Plus",
      ausfuehrung_name_en: "Plus",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "524",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1045",
      ausfuehrung_name: "Plus, o. Reling",
      ausfuehrung_name_en: "Plus, wo. roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "524",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1046",
      ausfuehrung_name: "Plus, mit Reling",
      ausfuehrung_name_en: "Plus, with roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "524",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1047",
      ausfuehrung_name: "Variant",
      ausfuehrung_name_en: "Variant",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "524",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1048",
      ausfuehrung_name: "Variant mit Reling",
      ausfuehrung_name_en: "Variant with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "524",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1049",
      ausfuehrung_name: "3 und 5-türig",
      ausfuehrung_name_en: "3 and 5 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "524",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1561",
      ausfuehrung_name: "Plus mit Reling",
      ausfuehrung_name_en: "Plus with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "524",
      ausfuehrung_aktiv: "1",
    },
  ],
  525: [
    {
      ausfuehrung_id: "1050",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "525",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1051",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "525",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1052",
      ausfuehrung_name: "Alltrack mit Reling",
      ausfuehrung_name_en: "Alltrack with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "525",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1053",
      ausfuehrung_name: "Sportsvan",
      ausfuehrung_name_en: "Sportsvan",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "525",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1054",
      ausfuehrung_name: "Variant",
      ausfuehrung_name_en: "Variant",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "525",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1055",
      ausfuehrung_name: "Variant mit Reling",
      ausfuehrung_name_en: "Variant with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "525",
      ausfuehrung_aktiv: "1",
    },
  ],
  526: [
    {
      ausfuehrung_id: "1056",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "526",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1562",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "526",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1563",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "526",
      ausfuehrung_aktiv: "1",
    },
  ],
  527: [
    {
      ausfuehrung_id: "1057",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "527",
      ausfuehrung_aktiv: "1",
    },
  ],
  528: [
    {
      ausfuehrung_id: "1058",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "528",
      ausfuehrung_aktiv: "1",
    },
  ],
  529: [
    {
      ausfuehrung_id: "1059",
      ausfuehrung_name: "Flachdach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "529",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1060",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "529",
      ausfuehrung_aktiv: "1",
    },
  ],
  530: [
    {
      ausfuehrung_id: "1061",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "530",
      ausfuehrung_aktiv: "1",
    },
  ],
  531: [
    {
      ausfuehrung_id: "1062",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "531",
      ausfuehrung_aktiv: "1",
    },
  ],
  532: [
    {
      ausfuehrung_id: "1063",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "532",
      ausfuehrung_aktiv: "1",
    },
  ],
  533: [
    {
      ausfuehrung_id: "1064",
      ausfuehrung_name: "Alltrack",
      ausfuehrung_name_en: "Alltrack",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1065",
      ausfuehrung_name: "Alltrack mit Reling",
      ausfuehrung_name_en: "Alltrack with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1066",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1067",
      ausfuehrung_name: "Variant",
      ausfuehrung_name_en: "Variant",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1068",
      ausfuehrung_name: "Variant mit Reling",
      ausfuehrung_name_en: "Variant with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1069",
      ausfuehrung_name: "Variant o. Reling",
      ausfuehrung_name_en: "Variant wo. rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1070",
      ausfuehrung_name: "Variant über mit Reling",
      ausfuehrung_name_en: "Variant over with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1564",
      ausfuehrung_name: "Alltrack mit Reling",
      ausfuehrung_name_en: "Alltrack with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1565",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1566",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1567",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1568",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1569",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1570",
      ausfuehrung_name: "Variant",
      ausfuehrung_name_en: "Variant",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1571",
      ausfuehrung_name: "Variant",
      ausfuehrung_name_en: "Variant",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1572",
      ausfuehrung_name: "Variant mit Reling",
      ausfuehrung_name_en: "Variant with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1573",
      ausfuehrung_name: "Variant mit Reling",
      ausfuehrung_name_en: "Variant with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1574",
      ausfuehrung_name: "Variant mit Reling",
      ausfuehrung_name_en: "Variant with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1575",
      ausfuehrung_name: "Variant mit Reling",
      ausfuehrung_name_en: "Variant with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1770",
      ausfuehrung_name: "Variant mit Reling",
      ausfuehrung_name_en: "Variant with roof rails ",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "533",
      ausfuehrung_aktiv: "1",
    },
  ],
  534: [
    {
      ausfuehrung_id: "1071",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "534",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1072",
      ausfuehrung_name: "6R/6C",
      ausfuehrung_name_en: "6R/6C",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "534",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1073",
      ausfuehrung_name: "Classic",
      ausfuehrung_name_en: "Classic",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "534",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1074",
      ausfuehrung_name: "Cross",
      ausfuehrung_name_en: "Cross",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "534",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1075",
      ausfuehrung_name: "Fun",
      ausfuehrung_name_en: "Fun",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "534",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1076",
      ausfuehrung_name: "Variant",
      ausfuehrung_name_en: "Variant",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "534",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1077",
      ausfuehrung_name: "Variant (o. Dachträgersystem)",
      ausfuehrung_name_en: "Variant (wo. Carriersystem)",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "534",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1078",
      ausfuehrung_name: "Variant mit Reling",
      ausfuehrung_name_en: "Variant with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "534",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1079",
      ausfuehrung_name: "VI Typ AW 5-türig",
      ausfuehrung_name_en: "VI type AW 5 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "534",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1080",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "534",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1081",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "534",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1576",
      ausfuehrung_name: "Cross",
      ausfuehrung_name_en: "Cross",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "534",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1577",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "534",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1578",
      ausfuehrung_name: "5-türig",
      ausfuehrung_name_en: "5 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "534",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1724",
      ausfuehrung_name: "Polo VI Typ AW 5-türig",
      ausfuehrung_name_en: "Polo VI type AW 5 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "534",
      ausfuehrung_aktiv: "1",
    },
  ],
  535: [
    {
      ausfuehrung_id: "1082",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "535",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1083",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "535",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1579",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "535",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1580",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "535",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1581",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "535",
      ausfuehrung_aktiv: "1",
    },
  ],
  536: [
    {
      ausfuehrung_id: "1084",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "536",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1582",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "536",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1583",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "536",
      ausfuehrung_aktiv: "1",
    },
  ],
  537: [
    {
      ausfuehrung_id: "1085",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "537",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1086",
      ausfuehrung_name: "C-Schiene",
      ausfuehrung_name_en: "C-with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "537",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1087",
      ausfuehrung_name: "o. C-Schiene",
      ausfuehrung_name_en: "wo. C-with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "537",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1584",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "537",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1585",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "537",
      ausfuehrung_aktiv: "1",
    },
  ],
  538: [
    {
      ausfuehrung_id: "1088",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "538",
      ausfuehrung_aktiv: "1",
    },
  ],
  539: [
    {
      ausfuehrung_id: "1089",
      ausfuehrung_name: "Allspace mit Reling",
      ausfuehrung_name_en: "Allspace with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "539",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1090",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "539",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1586",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "539",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1769",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "539",
      ausfuehrung_aktiv: "1",
    },
  ],
  540: [
    {
      ausfuehrung_id: "1091",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "540",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1092",
      ausfuehrung_name: "C-Schiene",
      ausfuehrung_name_en: "C-with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "540",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1093",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "540",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1587",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "540",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1588",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "540",
      ausfuehrung_aktiv: "1",
    },
  ],
  541: [
    {
      ausfuehrung_id: "1094",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "541",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1095",
      ausfuehrung_name: "Cross mit Reling",
      ausfuehrung_name_en: "Cross with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "541",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1096",
      ausfuehrung_name: "o. Reling",
      ausfuehrung_name_en: "wo. rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "541",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1097",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "541",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1589",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "541",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1590",
      ausfuehrung_name: "o. Reling",
      ausfuehrung_name_en: "wo. rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "541",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1591",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "541",
      ausfuehrung_aktiv: "1",
    },
  ],
  542: [
    {
      ausfuehrung_id: "1098",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "542",
      ausfuehrung_aktiv: "1",
    },
  ],
  543: [
    {
      ausfuehrung_id: "1099",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "543",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1100",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "543",
      ausfuehrung_aktiv: "1",
    },
  ],
  544: [
    {
      ausfuehrung_id: "1101",
      ausfuehrung_name: "3/5-türig",
      ausfuehrung_name_en: "3/5 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "544",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1102",
      ausfuehrung_name: "3-türig",
      ausfuehrung_name_en: "3 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "544",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1103",
      ausfuehrung_name: "Cross",
      ausfuehrung_name_en: "Cross",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "544",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1104",
      ausfuehrung_name: "GTI 3/5-türig",
      ausfuehrung_name_en: "GTI 3/5 doors",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "544",
      ausfuehrung_aktiv: "1",
    },
  ],
  545: [
    {
      ausfuehrung_id: "1105",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "545",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1592",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "545",
      ausfuehrung_aktiv: "1",
    },
  ],
  546: [
    {
      ausfuehrung_id: "1106",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "546",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1113",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "546",
      ausfuehrung_aktiv: "1",
    },
  ],
  547: [
    {
      ausfuehrung_id: "1107",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "547",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1114",
      ausfuehrung_name: "Dachleiste",
      ausfuehrung_name_en: "Roofwith rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "547",
      ausfuehrung_aktiv: "1",
    },
  ],
  548: [
    {
      ausfuehrung_id: "1108",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "548",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1115",
      ausfuehrung_name: "Dachleiste",
      ausfuehrung_name_en: "Roofwith rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "548",
      ausfuehrung_aktiv: "1",
    },
  ],
  549: [
    {
      ausfuehrung_id: "1109",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "549",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1116",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "549",
      ausfuehrung_aktiv: "1",
    },
  ],
  550: [
    {
      ausfuehrung_id: "1110",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "550",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1117",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "550",
      ausfuehrung_aktiv: "1",
    },
  ],
  551: [
    {
      ausfuehrung_id: "1111",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "551",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1121",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "551",
      ausfuehrung_aktiv: "1",
    },
  ],
  552: [
    {
      ausfuehrung_id: "1112",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "552",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1122",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "552",
      ausfuehrung_aktiv: "1",
    },
  ],
  553: [
    {
      ausfuehrung_id: "1118",
      ausfuehrung_name: "Kombi",
      ausfuehrung_name_en: "Station Wagon",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "553",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1119",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "553",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1120",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "553",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1593",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "553",
      ausfuehrung_aktiv: "1",
    },
  ],
  554: [
    {
      ausfuehrung_id: "1123",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "554",
      ausfuehrung_aktiv: "1",
    },
  ],
  555: [
    {
      ausfuehrung_id: "1124",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "555",
      ausfuehrung_aktiv: "1",
    },
  ],
  556: [
    {
      ausfuehrung_id: "1125",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "556",
      ausfuehrung_aktiv: "1",
    },
  ],
  557: [
    {
      ausfuehrung_id: "1126",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "557",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1127",
      ausfuehrung_name: "Cross Country, mit Reling",
      ausfuehrung_name_en: "Cross Country, with roof rails",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "557",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1128",
      ausfuehrung_name: "Kombi o. Reling",
      ausfuehrung_name_en: "Station Wagon wo. rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "557",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1129",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "557",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1135",
      ausfuehrung_name: "Cross Country mit Reling",
      ausfuehrung_name_en: "Cross Country with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "557",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1594",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "557",
      ausfuehrung_aktiv: "1",
    },
  ],
  558: [
    {
      ausfuehrung_id: "1130",
      ausfuehrung_name: "Kombi, mit Reling",
      ausfuehrung_name_en: "Station Wagon, with roof rails",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "558",
      ausfuehrung_aktiv: "1",
    },
  ],
  559: [
    {
      ausfuehrung_id: "1131",
      ausfuehrung_name: "Cross Country, mit Reling",
      ausfuehrung_name_en: "Cross Country, with roof rails",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "559",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1132",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "559",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1595",
      ausfuehrung_name: "Cross Country, mit Reling",
      ausfuehrung_name_en: "Cross Country, with roof rails",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "559",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1596",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "559",
      ausfuehrung_aktiv: "1",
    },
  ],
  560: [
    {
      ausfuehrung_id: "1133",
      ausfuehrung_name: "Cross Country ",
      ausfuehrung_name_en: "Cross Country",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "560",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1134",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "560",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1597",
      ausfuehrung_name: "Cross Country, mit Reling",
      ausfuehrung_name_en: "Cross Country, with roof rails",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "560",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1598",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "560",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1599",
      ausfuehrung_name: "Kombi mit Reling",
      ausfuehrung_name_en: "Station Wagon with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "560",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1671",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "560",
      ausfuehrung_aktiv: "1",
    },
  ],
  561: [
    {
      ausfuehrung_id: "1136",
      ausfuehrung_name: "Cross Country, mit Reling",
      ausfuehrung_name_en: "Cross Country, with roof rails",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "561",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1137",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "561",
      ausfuehrung_aktiv: "1",
    },
  ],
  562: [
    {
      ausfuehrung_id: "1138",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "562",
      ausfuehrung_aktiv: "1",
    },
  ],
  563: [
    {
      ausfuehrung_id: "1139",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "563",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1140",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "563",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1600",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "563",
      ausfuehrung_aktiv: "1",
    },
  ],
  564: [
    {
      ausfuehrung_id: "1141",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "564",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1672",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "564",
      ausfuehrung_aktiv: "1",
    },
  ],
  565: [
    {
      ausfuehrung_id: "1142",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "565",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1601",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with rail",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "565",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1602",
      ausfuehrung_name: "mit aufliegender Reling",
      ausfuehrung_name_en: "with flush mounted roof rails",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "565",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1673",
      ausfuehrung_name: "mit freistehender Reling",
      ausfuehrung_name_en: "with raised roof rails",
      ausfuehrung_hersteller_id: "44",
      ausfuehrung_modell_id: "565",
      ausfuehrung_aktiv: "1",
    },
  ],
  566: [
    {
      ausfuehrung_id: "1169",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "566",
      ausfuehrung_aktiv: "1",
    },
  ],
  567: [
    {
      ausfuehrung_id: "1166",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "567",
      ausfuehrung_aktiv: "1",
    },
  ],
  568: [
    {
      ausfuehrung_id: "1167",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "25",
      ausfuehrung_modell_id: "568",
      ausfuehrung_aktiv: "1",
    },
  ],
  569: [
    {
      ausfuehrung_id: "1170",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "569",
      ausfuehrung_aktiv: "1",
    },
  ],
  570: [
    {
      ausfuehrung_id: "1145",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "570",
      ausfuehrung_aktiv: "1",
    },
  ],
  571: [
    {
      ausfuehrung_id: "1157",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "571",
      ausfuehrung_aktiv: "1",
    },
  ],
  572: [
    {
      ausfuehrung_id: "1158",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "572",
      ausfuehrung_aktiv: "1",
    },
  ],
  573: [
    {
      ausfuehrung_id: "1171",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "573",
      ausfuehrung_aktiv: "1",
    },
  ],
  574: [
    {
      ausfuehrung_id: "1172",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "574",
      ausfuehrung_aktiv: "1",
    },
  ],
  575: [
    {
      ausfuehrung_id: "1173",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "575",
      ausfuehrung_aktiv: "1",
    },
  ],
  576: [
    {
      ausfuehrung_id: "1146",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "576",
      ausfuehrung_aktiv: "1",
    },
  ],
  577: [
    {
      ausfuehrung_id: "1159",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "577",
      ausfuehrung_aktiv: "1",
    },
  ],
  578: [
    {
      ausfuehrung_id: "1179",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "21",
      ausfuehrung_modell_id: "578",
      ausfuehrung_aktiv: "1",
    },
  ],
  579: [
    {
      ausfuehrung_id: "1180",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "21",
      ausfuehrung_modell_id: "579",
      ausfuehrung_aktiv: "1",
    },
  ],
  580: [
    {
      ausfuehrung_id: "1181",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "21",
      ausfuehrung_modell_id: "580",
      ausfuehrung_aktiv: "1",
    },
  ],
  581: [
    {
      ausfuehrung_id: "76",
      ausfuehrung_name: "Touring (E91) mit aufliegender Dachleiste",
      ausfuehrung_name_en: "Touring (E91) with roof ledge",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "581",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "77",
      ausfuehrung_name: "o. Reling (E91)",
      ausfuehrung_name_en: "without rail (E91)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "581",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "78",
      ausfuehrung_name: "mit Reling (E21, E30)",
      ausfuehrung_name_en: "with roof rail (E21, E30)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "581",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "79",
      ausfuehrung_name: "mit Reling (F31)",
      ausfuehrung_name_en: "with roof rails (F31)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "581",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1234",
      ausfuehrung_name: "mit Reling (E91)",
      ausfuehrung_name_en: "with roof rails (E91)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "581",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1235",
      ausfuehrung_name: "Touring, mit Reling (E36)",
      ausfuehrung_name_en: "Touring, with roof rail (E36)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "581",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1236",
      ausfuehrung_name: "Touring, mit Reling (E36)",
      ausfuehrung_name_en: "Touring, with roof rail (E36)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "581",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1237",
      ausfuehrung_name: "mit Reling (E36)",
      ausfuehrung_name_en: "with roof rail (E36)w",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "581",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1238",
      ausfuehrung_name: "mit Reling (E46-3)",
      ausfuehrung_name_en: "with roof rail (E46-3)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "581",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1239",
      ausfuehrung_name: "mit Reling (E91)",
      ausfuehrung_name_en: "with roof rail (E91)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "581",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1240",
      ausfuehrung_name: "Touring, mit Reling (E91)",
      ausfuehrung_name_en: "Touring, with roof rail (E91)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "581",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1603",
      ausfuehrung_name: "mit Reling (G21)",
      ausfuehrung_name_en: "with roof rail (G21)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "581",
      ausfuehrung_aktiv: "1",
    },
  ],
  582: [
    {
      ausfuehrung_id: "1605",
      ausfuehrung_name: "mit Reling (G07)",
      ausfuehrung_name_en: "with roof rail (G07)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "582",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1682",
      ausfuehrung_name: "(G07), mit Reling",
      ausfuehrung_name_en: "(G07), with roof rails",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "582",
      ausfuehrung_aktiv: "1",
    },
  ],
  583: [
    {
      ausfuehrung_id: "1606",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "mit Reling",
      ausfuehrung_hersteller_id: "6",
      ausfuehrung_modell_id: "583",
      ausfuehrung_aktiv: "1",
    },
  ],
  584: [
    {
      ausfuehrung_id: "1679",
      ausfuehrung_name: "+ Active, mit Reling",
      ausfuehrung_name_en: "+ Active, with roof rails",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "584",
      ausfuehrung_aktiv: "1",
    },
  ],
  585: [
    {
      ausfuehrung_id: "1613",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "585",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1615",
      ausfuehrung_name: "ohne Dachhimmel",
      ausfuehrung_name_en: "without roofliner",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "585",
      ausfuehrung_aktiv: "1",
    },
  ],
  586: [
    {
      ausfuehrung_id: "1616",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "586",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1617",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "586",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1619",
      ausfuehrung_name: "ohne Dachhimmel",
      ausfuehrung_name_en: "without roofliner",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "586",
      ausfuehrung_aktiv: "1",
    },
  ],
  587: [
    {
      ausfuehrung_id: "1618",
      ausfuehrung_name: "ohne Dachhimmel",
      ausfuehrung_name_en: "without roofliner",
      ausfuehrung_hersteller_id: "14",
      ausfuehrung_modell_id: "587",
      ausfuehrung_aktiv: "1",
    },
  ],
  588: [
    {
      ausfuehrung_id: "1620",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "16",
      ausfuehrung_modell_id: "588",
      ausfuehrung_aktiv: "1",
    },
  ],
  589: [
    {
      ausfuehrung_id: "1622",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "19",
      ausfuehrung_modell_id: "589",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1623",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "19",
      ausfuehrung_modell_id: "589",
      ausfuehrung_aktiv: "1",
    },
  ],
  590: [
    {
      ausfuehrung_id: "1624",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "19",
      ausfuehrung_modell_id: "590",
      ausfuehrung_aktiv: "1",
    },
  ],
  591: [
    {
      ausfuehrung_id: "1626",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "23",
      ausfuehrung_modell_id: "591",
      ausfuehrung_aktiv: "1",
    },
  ],
  592: [
    {
      ausfuehrung_id: "1629",
      ausfuehrung_name: "T-Modell (W124), mit Reling",
      ausfuehrung_name_en: "T-Modell (W124), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "592",
      ausfuehrung_aktiv: "1",
    },
  ],
  593: [
    {
      ausfuehrung_id: "1630",
      ausfuehrung_name: "T-Modell (W124), mit Reling",
      ausfuehrung_name_en: "T-Modell (W124), with roof rails",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "593",
      ausfuehrung_aktiv: "1",
    },
  ],
  594: [
    {
      ausfuehrung_id: "1636",
      ausfuehrung_name: "(BM460)",
      ausfuehrung_name_en: "(BM460)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "594",
      ausfuehrung_aktiv: "1",
    },
  ],
  595: [
    {
      ausfuehrung_id: "1643",
      ausfuehrung_name: "Hochdach",
      ausfuehrung_name_en: "high roof",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "595",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1644",
      ausfuehrung_name: "Normaldach",
      ausfuehrung_name_en: "normal roof",
      ausfuehrung_hersteller_id: "28",
      ausfuehrung_modell_id: "595",
      ausfuehrung_aktiv: "1",
    },
  ],
  596: [
    {
      ausfuehrung_id: "1654",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "596",
      ausfuehrung_aktiv: "1",
    },
  ],
  597: [
    {
      ausfuehrung_id: "1657",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "Limousine",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "597",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1718",
      ausfuehrung_name: "Skoda Scala Limousine",
      ausfuehrung_name_en: "Skoda Scala Limousine",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "597",
      ausfuehrung_aktiv: "1",
    },
  ],
  598: [
    {
      ausfuehrung_id: "1677",
      ausfuehrung_name: "mit Reling (X247)",
      ausfuehrung_name_en: "with roof rails (X247)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "598",
      ausfuehrung_aktiv: "1",
    },
  ],
  600: [
    {
      ausfuehrung_id: "89",
      ausfuehrung_name: "(E61)",
      ausfuehrung_name_en: "(E61)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "600",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "90",
      ausfuehrung_name: "mit Reling (E39, E61)",
      ausfuehrung_name_en: "with rail (E39, E61)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "600",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "91",
      ausfuehrung_name: "(F11) mit Reling",
      ausfuehrung_name_en: "(F11) with roof rails",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "600",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "92",
      ausfuehrung_name: "(G31) mit Reling",
      ausfuehrung_name_en: "(G31) with rail",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "600",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "93",
      ausfuehrung_name: "Touring ohne mit Reling",
      ausfuehrung_name_en: "Touring wo. rail",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "600",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1241",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "600",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1242",
      ausfuehrung_name: "Touring mit Reling (E39, E61)",
      ausfuehrung_name_en: "Touring with rail (E39, E61)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "600",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1604",
      ausfuehrung_name: "Touring (E39)",
      ausfuehrung_name_en: "Touring (E39)",
      ausfuehrung_hersteller_id: "4",
      ausfuehrung_modell_id: "600",
      ausfuehrung_aktiv: "1",
    },
  ],
  601: [
    {
      ausfuehrung_id: "1684",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "19",
      ausfuehrung_modell_id: "601",
      ausfuehrung_aktiv: "1",
    },
  ],
  602: [
    {
      ausfuehrung_id: "1685",
      ausfuehrung_name: "Limousine",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "602",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1710",
      ausfuehrung_name: "mit Reling ",
      ausfuehrung_name_en: "with roof rails ",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "602",
      ausfuehrung_aktiv: "1",
    },
  ],
  603: [
    {
      ausfuehrung_id: "1688",
      ausfuehrung_name: "ohne Reling",
      ausfuehrung_name_en: "without roof rails",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "603",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1689",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "603",
      ausfuehrung_aktiv: "1",
    },
  ],
  604: [
    {
      ausfuehrung_id: "1696",
      ausfuehrung_name: "(N293)",
      ausfuehrung_name_en: "(N293)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "604",
      ausfuehrung_aktiv: "1",
    },
  ],
  605: [
    {
      ausfuehrung_id: "1702",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "46",
      ausfuehrung_modell_id: "605",
      ausfuehrung_aktiv: "1",
    },
  ],
  606: [
    {
      ausfuehrung_id: "1705",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "39",
      ausfuehrung_modell_id: "606",
      ausfuehrung_aktiv: "1",
    },
    {
      ausfuehrung_id: "1730",
      ausfuehrung_name: "Grand, mit Reling",
      ausfuehrung_name_en: "Grand, with roof rails",
      ausfuehrung_hersteller_id: "39",
      ausfuehrung_modell_id: "606",
      ausfuehrung_aktiv: "1",
    },
  ],
  607: [
    {
      ausfuehrung_id: "1706",
      ausfuehrung_name: "ID 4 mit Reling",
      ausfuehrung_name_en: "ID 4 with railing",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "607",
      ausfuehrung_aktiv: "1",
    },
  ],
  608: [
    {
      ausfuehrung_id: "1707",
      ausfuehrung_name: "EQA (H 243) mit Reling ",
      ausfuehrung_name_en: "EQA (H 243) with railing",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "608",
      ausfuehrung_aktiv: "1",
    },
  ],
  609: [
    {
      ausfuehrung_id: "1709",
      ausfuehrung_name: "Sandero mit normalem Dach",
      ausfuehrung_name_en: "Sandero with regular roof",
      ausfuehrung_hersteller_id: "9",
      ausfuehrung_modell_id: "609",
      ausfuehrung_aktiv: "1",
    },
  ],
  610: [
    {
      ausfuehrung_id: "1711",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "610",
      ausfuehrung_aktiv: "1",
    },
  ],
  612: [
    {
      ausfuehrung_id: "1713",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "46",
      ausfuehrung_modell_id: "612",
      ausfuehrung_aktiv: "1",
    },
  ],
  615: [
    {
      ausfuehrung_id: "1714",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "37",
      ausfuehrung_modell_id: "615",
      ausfuehrung_aktiv: "1",
    },
  ],
  616: [
    {
      ausfuehrung_id: "1715",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "38",
      ausfuehrung_modell_id: "616",
      ausfuehrung_aktiv: "1",
    },
  ],
  617: [
    {
      ausfuehrung_id: "1717",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "617",
      ausfuehrung_aktiv: "1",
    },
  ],
  619: [
    {
      ausfuehrung_id: "1720",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "619",
      ausfuehrung_aktiv: "1",
    },
  ],
  620: [
    {
      ausfuehrung_id: "1721",
      ausfuehrung_name: "mit Reling (X243)",
      ausfuehrung_name_en: "with roof rails (X243)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "620",
      ausfuehrung_aktiv: "1",
    },
  ],
  621: [
    {
      ausfuehrung_id: "1725",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "621",
      ausfuehrung_aktiv: "1",
    },
  ],
  622: [
    {
      ausfuehrung_id: "1727",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "622",
      ausfuehrung_aktiv: "1",
    },
  ],
  623: [
    {
      ausfuehrung_id: "1728",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "41",
      ausfuehrung_modell_id: "623",
      ausfuehrung_aktiv: "1",
    },
  ],
  624: [
    {
      ausfuehrung_id: "1732",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "47",
      ausfuehrung_modell_id: "624",
      ausfuehrung_aktiv: "1",
    },
  ],
  625: [
    {
      ausfuehrung_id: "1734",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "625",
      ausfuehrung_aktiv: "1",
    },
  ],
  626: [
    {
      ausfuehrung_id: "1735",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "48",
      ausfuehrung_modell_id: "626",
      ausfuehrung_aktiv: "1",
    },
  ],
  627: [
    {
      ausfuehrung_id: "1736",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "48",
      ausfuehrung_modell_id: "627",
      ausfuehrung_aktiv: "1",
    },
  ],
  628: [
    {
      ausfuehrung_id: "1739",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "29",
      ausfuehrung_modell_id: "628",
      ausfuehrung_aktiv: "1",
    },
  ],
  629: [
    {
      ausfuehrung_id: "1744",
      ausfuehrung_name: "(V295)",
      ausfuehrung_name_en: "(V295)",
      ausfuehrung_hersteller_id: "26",
      ausfuehrung_modell_id: "629",
      ausfuehrung_aktiv: "1",
    },
  ],
  630: [
    {
      ausfuehrung_id: "1746",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "630",
      ausfuehrung_aktiv: "1",
    },
  ],
  631: [
    {
      ausfuehrung_id: "1750",
      ausfuehrung_name: "mit Dachleiste",
      ausfuehrung_name_en: "with roof bar",
      ausfuehrung_hersteller_id: "42",
      ausfuehrung_modell_id: "631",
      ausfuehrung_aktiv: "1",
    },
  ],
  632: [
    {
      ausfuehrung_id: "1751",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "48",
      ausfuehrung_modell_id: "632",
      ausfuehrung_aktiv: "1",
    },
  ],
  633: [
    {
      ausfuehrung_id: "1752",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "34",
      ausfuehrung_modell_id: "633",
      ausfuehrung_aktiv: "1",
    },
  ],
  634: [
    {
      ausfuehrung_id: "1753",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "49",
      ausfuehrung_modell_id: "634",
      ausfuehrung_aktiv: "1",
    },
  ],
  635: [
    {
      ausfuehrung_id: "1754",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "49",
      ausfuehrung_modell_id: "635",
      ausfuehrung_aktiv: "1",
    },
  ],
  636: [
    {
      ausfuehrung_id: "1756",
      ausfuehrung_name: "",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "636",
      ausfuehrung_aktiv: "1",
    },
  ],
  638: [
    {
      ausfuehrung_id: "1761",
      ausfuehrung_name: "mit Dachleiste ",
      ausfuehrung_name_en: "",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "638",
      ausfuehrung_aktiv: "1",
    },
  ],
  641: [
    {
      ausfuehrung_id: "1766",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "50",
      ausfuehrung_modell_id: "641",
      ausfuehrung_aktiv: "1",
    },
  ],
  642: [
    {
      ausfuehrung_id: "1767",
      ausfuehrung_name: "o. Reling ",
      ausfuehrung_name_en: "without roof rails",
      ausfuehrung_hersteller_id: "30",
      ausfuehrung_modell_id: "642",
      ausfuehrung_aktiv: "1",
    },
  ],
  643: [
    {
      ausfuehrung_id: "1768",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "40",
      ausfuehrung_modell_id: "643",
      ausfuehrung_aktiv: "1",
    },
  ],
  644: [
    {
      ausfuehrung_id: "1771",
      ausfuehrung_name: "mit Reling",
      ausfuehrung_name_en: "with roof rails",
      ausfuehrung_hersteller_id: "43",
      ausfuehrung_modell_id: "644",
      ausfuehrung_aktiv: "1",
    },
  ],
};

window.manufacturers = manufacturers;
window.models = models;
window.trims = trims;
